(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mlb-media-player"), require("rxjs/operators"));
	else if(typeof define === 'function' && define.amd)
		define(["mlb-media-player", "rxjs/operators"], factory);
	else if(typeof exports === 'object')
		exports["mlb-player-plugins"] = factory(require("mlb-media-player"), require("rxjs/operators"));
	else
		root["MLBPlayerPlugins"] = factory(root["MediaPlayer"], root["rxjs"]["operators"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__8__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 202);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(56);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(57);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function ( root, factory ) {
    if ( true ) {
        // AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
			__webpack_require__(189)
              ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
} )( this, function ( MessageService ) {
    'use strict';

    var the_bandwagon, //bandwagon instance
    	eventsCache = {
	    	global: {}
	    }, //events subscribed to
    	messageServiceCache = {}; //messageService instances spun up;

    /**
     *  Constructor
     */
    function Bandwagon () {
	    //console.log("bandwagon constructor")
		init();
    }

    var init = function() {
	   //console.log("bandwagon init");
    }

    Bandwagon.prototype = {
        /**
	     *  Register events enum with bandwagon
	     *  @param {string} ns - namespace to store events enum in object. If not provided, will dump in "global".
	     *	@param {object} events - events enum object to store
	     */
	    registerEvents: function ( ns, events ) {

			if (!ns) {
    			//console.log("bandwagon: extend global events enum : ", events )
				this.merge( events, ns );
			} else {
    			if (eventsCache[ns]) {
        			//console.log("bandwagon: extend existing events enum :" + ns, events)
                    this.merge( events, ns );
                } else {
                    //console.log("bandwagon: adding events enum: " + ns, events)
                    eventsCache[ns] = events;
                }
			}

			return;
	    },

        /**
        *
        * Merge custom events into global event object
        * if a namespace exists will merge new properties into that namespace
        * @param {object} events
        */
        merge: function ( events, ns ) {

            for (var e in events) {
                if (events.hasOwnProperty(e)) {
                    eventsCache[ns ? ns : 'global'][e] = events[e];
                }
            }

        },

	    /**
	     *  Delete events enum from bandwagon
	     *  @param {string} key - namespace to delete from cache
	     */
	    deleteEventsByKey: function ( key ) {
		    //console.log("bandwagon: deleting events enum: " + key);

            if (key && eventsCache[key]) {

            	delete eventsCache[key];

            } else {

                console.log("bandwagon: specified namespace does not exist in events cache to delete", key)

            }

		    return;
	    },

	    /**
	     *  Return events enum from bandwagon
	     */
	    getRegisteredEvents: function () {

			return eventsCache;

	    },

	    /**
	     *  Return events enum from bandwagon by key
	     *  @param {string} key - namespace to return from object
	     */
	    getRegisteredEventsByKey: function ( key ) {

		  	var events;

		  	if ( key && eventsCache[key] ) {
				events = eventsCache[key]
		  	} else {
				console.log("please provide valid event key you want to retrieve from the events cache", key);
		  	}

		  	return events;

	    },

		/**
	     *  Return instance of Message service by key. If instance does not exist, it will be created.
	     *	@param {string} key - message service is stored by this key
	     */
	    getInstanceByKey: function ( key ) {

    	    var instance = {};

            if (key && !messageServiceCache[key]) {
                //console.log("bandwagon: new messageService instance -> " + key)
                instance = messageServiceCache[key] = MessageService.create();
            } else {
                //console.log("bandwagon: existing messageService instance -> " + key)
                instance = messageServiceCache[key];
            }

            //console.log("messageServiceInstance returned by key: " + key, instance)

            return instance;
	    },

	    /**
	     *  Returns cache object of instances
	     */
	    getInstancesAvailable: function () {

            //console.log("bandwagon: stored messageService instances", messageServiceCache)

            return messageServiceCache;

	    },

	    /**
	     *  Delete instance of message service by key
	     *  @param {string} key - instance to delete out of cache
	     */
	    deleteInstanceByKey: function (key) {

    	    //console.log("bandwagon: delete messageService instance -> " + key )

    	    if (key && messageServiceCache[key]) {

    	        delete messageServiceCache[key];

    	    } else {

        	    console.log("bandwagon: specified key does not exist in cache to delete", key)

    	    }

    	    return;

	    }

	}

    // return Bandwagon instance.
    return (the_bandwagon = (the_bandwagon || new Bandwagon()));
} );


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(95),
    getValue = __webpack_require__(98);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8__;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(13),
    getRawTag = __webpack_require__(87),
    objectToString = __webpack_require__(88);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 10 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(61),
    baseKeys = __webpack_require__(121),
    isArrayLike = __webpack_require__(12);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(36),
    isLength = __webpack_require__(42);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(4);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 14 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(21);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(46),
    baseAssignValue = __webpack_require__(47);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(61),
    baseKeysIn = __webpack_require__(136),
    isArrayLike = __webpack_require__(12);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v2.1.4
 * http://jquery.com/
 *
 * Includes Sizzle.js
 * http://sizzlejs.com/
 *
 * Copyright 2005, 2014 jQuery Foundation, Inc. and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2015-04-28T16:01Z
 */

(function( global, factory ) {

	if (  true && typeof module.exports === "object" ) {
		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Support: Firefox 18+
// Can't be in strict mode, several libs including ASP.NET trace
// the stack via arguments.caller.callee and Firefox dies if
// you try to trace through "use strict" call chains. (#13335)
//

var arr = [];

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var support = {};



var
	// Use the correct document accordingly with window argument (sandbox)
	document = window.document,

	version = "2.1.4",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {
		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android<4.1
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([\da-z])/gi,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {
	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// Start with an empty selector
	selector: "",

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {
		return num != null ?

			// Return just the one element from the set
			( num < 0 ? this[ num + this.length ] : this[ num ] ) :

			// Return all the elements in a clean array
			slice.call( this );
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;
		ret.context = this.context;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	// (You can seed the arguments with an array of args, but this is
	// only used internally.)
	each: function( callback, args ) {
		return jQuery.each( this, callback, args );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map(this, function( elem, i ) {
			return callback.call( elem, i, elem );
		}));
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[j] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor(null);
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[0] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction(target) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {
		// Only deal with non-null/undefined values
		if ( (options = arguments[ i ]) != null ) {
			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)) ) ) {
					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && jQuery.isArray(src) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject(src) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend({
	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type(obj) === "function";
	},

	isArray: Array.isArray,

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {
		// parseFloat NaNs numeric-cast false positives (null|true|false|"")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		// adding 1 corrects loss of precision from parseFloat (#15100)
		return !jQuery.isArray( obj ) && (obj - parseFloat( obj ) + 1) >= 0;
	},

	isPlainObject: function( obj ) {
		// Not plain objects:
		// - Any object or value whose internal [[Class]] property is not "[object Object]"
		// - DOM nodes
		// - window
		if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
			return false;
		}

		if ( obj.constructor &&
				!hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
			return false;
		}

		// If the function hasn't returned already, we're confident that
		// |obj| is a plain object, created by {} or constructed with new Object
		return true;
	},

	isEmptyObject: function( obj ) {
		var name;
		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
		// Support: Android<4.0, iOS<6 (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call(obj) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		var script,
			indirect = eval;

		code = jQuery.trim( code );

		if ( code ) {
			// If the code includes a valid, prologue position
			// strict mode pragma, execute code by injecting a
			// script tag into the document.
			if ( code.indexOf("use strict") === 1 ) {
				script = document.createElement("script");
				script.text = code;
				document.head.appendChild( script ).parentNode.removeChild( script );
			} else {
			// Otherwise, avoid the DOM node creation, insertion
			// and removal by using an indirect global eval
				indirect( code );
			}
		}
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE9-11+
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	nodeName: function( elem, name ) {
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	},

	// args is for internal usage only
	each: function( obj, callback, args ) {
		var value,
			i = 0,
			length = obj.length,
			isArray = isArraylike( obj );

		if ( args ) {
			if ( isArray ) {
				for ( ; i < length; i++ ) {
					value = callback.apply( obj[ i ], args );

					if ( value === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					value = callback.apply( obj[ i ], args );

					if ( value === false ) {
						break;
					}
				}
			}

		// A special, fast, case for the most common use of each
		} else {
			if ( isArray ) {
				for ( ; i < length; i++ ) {
					value = callback.call( obj[ i ], i, obj[ i ] );

					if ( value === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					value = callback.call( obj[ i ], i, obj[ i ] );

					if ( value === false ) {
						break;
					}
				}
			}
		}

		return obj;
	},

	// Support: Android<4.1
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArraylike( Object(arr) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var value,
			i = 0,
			length = elems.length,
			isArray = isArraylike( elems ),
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArray ) {
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
});

// Populate the class2type map
jQuery.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(i, name) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
});

function isArraylike( obj ) {

	// Support: iOS 8.2 (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	if ( obj.nodeType === 1 && length ) {
		return true;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.2.0-pre
 * http://sizzlejs.com/
 *
 * Copyright 2008, 2014 jQuery Foundation, Inc. and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2014-12-16
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// General-purpose constants
	MAX_NEGATIVE = 1 << 31,

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// http://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// Whitespace characters http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",
	// http://www.w3.org/TR/css3-syntax/#characters
	characterEncoding = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",

	// Loosely modeled on CSS identifier characters
	// An unquoted value should be a CSS identifier http://www.w3.org/TR/css3-selectors/#attribute-selectors
	// Proper syntax: http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = characterEncoding.replace( "w", "w#" ),

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + characterEncoding + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + characterEncoding + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + characterEncoding + ")" ),
		"CLASS": new RegExp( "^\\.(" + characterEncoding + ")" ),
		"TAG": new RegExp( "^(" + characterEncoding.replace( "w", "w*" ) + ")" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,
	rescape = /'|\\/g,

	// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	};

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var match, elem, m, nodeType,
		// QSA vars
		i, groups, old, nid, newContext, newSelector;

	if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
		setDocument( context );
	}

	context = context || document;
	results = results || [];
	nodeType = context.nodeType;

	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	if ( !seed && documentIsHTML ) {

		// Try to shortcut find operations when possible (e.g., not under DocumentFragment)
		if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
			// Speed-up: Sizzle("#ID")
			if ( (m = match[1]) ) {
				if ( nodeType === 9 ) {
					elem = context.getElementById( m );
					// Check parentNode to catch when Blackberry 4.6 returns
					// nodes that are no longer in the document (jQuery #6963)
					if ( elem && elem.parentNode ) {
						// Handle the case where IE, Opera, and Webkit return items
						// by name instead of ID
						if ( elem.id === m ) {
							results.push( elem );
							return results;
						}
					} else {
						return results;
					}
				} else {
					// Context is not a document
					if ( context.ownerDocument && (elem = context.ownerDocument.getElementById( m )) &&
						contains( context, elem ) && elem.id === m ) {
						results.push( elem );
						return results;
					}
				}

			// Speed-up: Sizzle("TAG")
			} else if ( match[2] ) {
				push.apply( results, context.getElementsByTagName( selector ) );
				return results;

			// Speed-up: Sizzle(".CLASS")
			} else if ( (m = match[3]) && support.getElementsByClassName ) {
				push.apply( results, context.getElementsByClassName( m ) );
				return results;
			}
		}

		// QSA path
		if ( support.qsa && (!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
			nid = old = expando;
			newContext = context;
			newSelector = nodeType !== 1 && selector;

			// qSA works strangely on Element-rooted queries
			// We can work around this by specifying an extra ID on the root
			// and working up from there (Thanks to Andrew Dupont for the technique)
			// IE 8 doesn't work on object elements
			if ( nodeType === 1 && context.nodeName.toLowerCase() !== "object" ) {
				groups = tokenize( selector );

				if ( (old = context.getAttribute("id")) ) {
					nid = old.replace( rescape, "\\$&" );
				} else {
					context.setAttribute( "id", nid );
				}
				nid = "[id='" + nid + "'] ";

				i = groups.length;
				while ( i-- ) {
					groups[i] = nid + toSelector( groups[i] );
				}
				newContext = rsibling.test( selector ) && testContext( context.parentNode ) || context;
				newSelector = groups.join(",");
			}

			if ( newSelector ) {
				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch(qsaError) {
				} finally {
					if ( !old ) {
						context.removeAttribute("id");
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {Function(string, Object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created div and expects a boolean result
 */
function assert( fn ) {
	var div = document.createElement("div");

	try {
		return !!fn( div );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( div.parentNode ) {
			div.parentNode.removeChild( div );
		}
		// release memory in IE
		div = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = attrs.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			( ~b.sourceIndex || MAX_NEGATIVE ) -
			( ~a.sourceIndex || MAX_NEGATIVE );

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, parent,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// If no document and documentElement is available, return
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Set our document
	document = doc;
	docElem = doc.documentElement;
	parent = doc.defaultView;

	// Support: IE>8
	// If iframe document is assigned to "document" variable and if iframe has been reloaded,
	// IE will throw "permission denied" error when accessing "document" variable, see jQuery #13936
	// IE6-8 do not support the defaultView property so parent will be undefined
	if ( parent && parent !== parent.top ) {
		// IE11 does not have attachEvent, so all must suffer
		if ( parent.addEventListener ) {
			parent.addEventListener( "unload", unloadHandler, false );
		} else if ( parent.attachEvent ) {
			parent.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Support tests
	---------------------------------------------------------------------- */
	documentIsHTML = !isXML( doc );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( div ) {
		div.className = "i";
		return !div.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( div ) {
		div.appendChild( doc.createComment("") );
		return !div.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( doc.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( div ) {
		docElem.appendChild( div ).id = expando;
		return !doc.getElementsByName || !doc.getElementsByName( expando ).length;
	});

	// ID find and filter
	if ( support.getById ) {
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var m = context.getElementById( id );
				// Check parentNode to catch when Blackberry 4.6 returns
				// nodes that are no longer in the document #6963
				return m && m.parentNode ? [ m ] : [];
			}
		};
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
	} else {
		// Support: IE6/7
		// getElementById is not reliable as a find shortcut
		delete Expr.find["ID"];

		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See http://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( doc.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( div ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// http://bugs.jquery.com/ticket/12359
			docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\f]' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( div.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !div.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.2+, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.7+
			if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibing-combinator selector` fails
			if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( div ) {
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = doc.createElement("input");
			input.setAttribute( "type", "hidden" );
			div.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( div.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":enabled").length ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			div.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( div ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( div, "div" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( div, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully does not implement inclusive descendent
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === doc ? -1 :
				b === doc ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return doc;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, outerCache, node, diff, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) {
										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {
							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || (parent[ expando ] = {});
							cache = outerCache[ type ] || [];
							nodeIndex = cache[0] === dirruns && cache[1];
							diff = cache[0] === dirruns && cache[2];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						// Use previously-cached element index if available
						} else if ( useCache && (cache = (elem[ expando ] || (elem[ expando ] = {}))[ type ]) && cache[0] === dirruns ) {
							diff = cache[1];

						// xml :nth-child(...) or :nth-last-child(...) or :nth(-last)?-of-type(...)
						} else {
							// Use the same loop as above to seek `elem` from the start
							while ( (node = ++nodeIndex && node && node[ dir ] ||
								(diff = nodeIndex = 0) || start.pop()) ) {

								if ( ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) && ++diff ) {
									// Cache the index of each encountered element
									if ( useCache ) {
										(node[ expando ] || (node[ expando ] = {}))[ type ] = [ dirruns, diff ];
									}

									if ( node === elem ) {
										break;
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": function( elem ) {
			return elem.disabled === false;
		},

		"disabled": function( elem ) {
			return elem.disabled === true;
		},

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		checkNonElements = base && dir === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from dir caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});
						if ( (oldCache = outerCache[ dir ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							outerCache[ dir ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context !== document && context;
			}

			// Add elements passing elementMatchers directly to results
			// Keep `i` a string if there are no elements so `matchedCount` will be "00" below
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// Apply set filters to unmatched elements
			matchedCount += i;
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is no seed and only one group
	if ( match.length === 1 ) {

		// Take a shortcut and set the context if the root selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				support.getById && context.nodeType === 9 && documentIsHTML &&
				Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( div1 ) {
	// Should return 1, but returns 4 (following)
	return div1.compareDocumentPosition( document.createElement("div") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( div ) {
	div.innerHTML = "<a href='#'></a>";
	return div.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( div ) {
	div.innerHTML = "<input/>";
	div.firstChild.setAttribute( "value", "" );
	return div.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( div ) {
	return div.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;
jQuery.expr[":"] = jQuery.expr.pseudos;
jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;



var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = (/^<(\w+)\s*\/?>(?:<\/\1>|)$/);



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			/* jshint -W018 */
			return !!qualifier.call( elem, i, elem ) !== not;
		});

	}

	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		});

	}

	if ( typeof qualifier === "string" ) {
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}

		qualifier = jQuery.filter( qualifier, elements );
	}

	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) >= 0 ) !== not;
	});
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	return elems.length === 1 && elem.nodeType === 1 ?
		jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
		jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		}));
};

jQuery.fn.extend({
	find: function( selector ) {
		var i,
			len = this.length,
			ret = [],
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter(function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			}) );
		}

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		// Needed because $( selector, context ) becomes $( context ).find( selector )
		ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
		ret.selector = this.selector ? this.selector + " " + selector : selector;
		return ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow(this, selector || [], false) );
	},
	not: function( selector ) {
		return this.pushStack( winnow(this, selector || [], true) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
});


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,

	init = jQuery.fn.init = function( selector, context ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[0] === "<" && selector[ selector.length - 1 ] === ">" && selector.length >= 3 ) {
				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && (match[1] || !context) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[1] ) {
					context = context instanceof jQuery ? context[0] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[1],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[1] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {
							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[2] );

					// Support: Blackberry 4.6
					// gEBID returns nodes no longer in the document (#6963)
					if ( elem && elem.parentNode ) {
						// Inject the element directly into the jQuery object
						this.length = 1;
						this[0] = elem;
					}

					this.context = document;
					this.selector = selector;
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || rootjQuery ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this.context = this[0] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return typeof rootjQuery.ready !== "undefined" ?
				rootjQuery.ready( selector ) :
				// Execute immediately if ready is not present
				selector( jQuery );
		}

		if ( selector.selector !== undefined ) {
			this.selector = selector.selector;
			this.context = selector.context;
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.extend({
	dir: function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;

		while ( (elem = elem[ dir ]) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	},

	sibling: function( n, elem ) {
		var matched = [];

		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}

		return matched;
	}
});

jQuery.fn.extend({
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter(function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[i] ) ) {
					return true;
				}
			}
		});
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
				jQuery( selectors, context || this.context ) :
				0;

		for ( ; i < l; i++ ) {
			for ( cur = this[i]; cur && cur !== context; cur = cur.parentNode ) {
				// Always skip document fragments
				if ( cur.nodeType < 11 && (pos ?
					pos.index(cur) > -1 :

					// Don't pass non-elements to Sizzle
					cur.nodeType === 1 &&
						jQuery.find.matchesSelector(cur, selectors)) ) {

					matched.push( cur );
					break;
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.unique( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.unique(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter(selector)
		);
	}
});

function sibling( cur, dir ) {
	while ( (cur = cur[dir]) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each({
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return jQuery.dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return jQuery.dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return jQuery.dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return jQuery.sibling( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return jQuery.sibling( elem.firstChild );
	},
	contents: function( elem ) {
		return elem.contentDocument || jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {
			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.unique( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
});
var rnotwhite = (/\S+/g);



// String to Object options format cache
var optionsCache = {};

// Convert String-formatted options into Object-formatted ones and store in cache
function createOptions( options ) {
	var object = optionsCache[ options ] = {};
	jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	});
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		( optionsCache[ options ] || createOptions( options ) ) :
		jQuery.extend( {}, options );

	var // Last fire value (for non-forgettable lists)
		memory,
		// Flag to know if list was already fired
		fired,
		// Flag to know if list is currently firing
		firing,
		// First callback to fire (used internally by add and fireWith)
		firingStart,
		// End of the loop when firing
		firingLength,
		// Index of currently firing callback (modified by remove if needed)
		firingIndex,
		// Actual callback list
		list = [],
		// Stack of fire calls for repeatable lists
		stack = !options.once && [],
		// Fire callbacks
		fire = function( data ) {
			memory = options.memory && data;
			fired = true;
			firingIndex = firingStart || 0;
			firingStart = 0;
			firingLength = list.length;
			firing = true;
			for ( ; list && firingIndex < firingLength; firingIndex++ ) {
				if ( list[ firingIndex ].apply( data[ 0 ], data[ 1 ] ) === false && options.stopOnFalse ) {
					memory = false; // To prevent further calls using add
					break;
				}
			}
			firing = false;
			if ( list ) {
				if ( stack ) {
					if ( stack.length ) {
						fire( stack.shift() );
					}
				} else if ( memory ) {
					list = [];
				} else {
					self.disable();
				}
			}
		},
		// Actual Callbacks object
		self = {
			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {
					// First, we save the current length
					var start = list.length;
					(function add( args ) {
						jQuery.each( args, function( _, arg ) {
							var type = jQuery.type( arg );
							if ( type === "function" ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && type !== "string" ) {
								// Inspect recursively
								add( arg );
							}
						});
					})( arguments );
					// Do we need to add the callbacks to the
					// current firing batch?
					if ( firing ) {
						firingLength = list.length;
					// With memory, if we're not firing then
					// we should call right away
					} else if ( memory ) {
						firingStart = start;
						fire( memory );
					}
				}
				return this;
			},
			// Remove a callback from the list
			remove: function() {
				if ( list ) {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
							// Handle firing indexes
							if ( firing ) {
								if ( index <= firingLength ) {
									firingLength--;
								}
								if ( index <= firingIndex ) {
									firingIndex--;
								}
							}
						}
					});
				}
				return this;
			},
			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ? jQuery.inArray( fn, list ) > -1 : !!( list && list.length );
			},
			// Remove all callbacks from the list
			empty: function() {
				list = [];
				firingLength = 0;
				return this;
			},
			// Have the list do nothing anymore
			disable: function() {
				list = stack = memory = undefined;
				return this;
			},
			// Is it disabled?
			disabled: function() {
				return !list;
			},
			// Lock the list in its current state
			lock: function() {
				stack = undefined;
				if ( !memory ) {
					self.disable();
				}
				return this;
			},
			// Is it locked?
			locked: function() {
				return !stack;
			},
			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( list && ( !fired || stack ) ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					if ( firing ) {
						stack.push( args );
					} else {
						fire( args );
					}
				}
				return this;
			},
			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},
			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


jQuery.extend({

	Deferred: function( func ) {
		var tuples = [
				// action, add listener, listener list, final state
				[ "resolve", "done", jQuery.Callbacks("once memory"), "resolved" ],
				[ "reject", "fail", jQuery.Callbacks("once memory"), "rejected" ],
				[ "notify", "progress", jQuery.Callbacks("memory") ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				then: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;
					return jQuery.Deferred(function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {
							var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
							// deferred[ done | fail | progress ] for forwarding actions to newDefer
							deferred[ tuple[1] ](function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.done( newDefer.resolve )
										.fail( newDefer.reject )
										.progress( newDefer.notify );
								} else {
									newDefer[ tuple[ 0 ] + "With" ]( this === promise ? newDefer.promise() : this, fn ? [ returned ] : arguments );
								}
							});
						});
						fns = null;
					}).promise();
				},
				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Keep pipe for back-compat
		promise.pipe = promise.then;

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 3 ];

			// promise[ done | fail | progress ] = list.add
			promise[ tuple[1] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(function() {
					// state = [ resolved | rejected ]
					state = stateString;

				// [ reject_list | resolve_list ].disable; progress_list.lock
				}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
			}

			// deferred[ resolve | reject | notify ]
			deferred[ tuple[0] ] = function() {
				deferred[ tuple[0] + "With" ]( this === deferred ? promise : this, arguments );
				return this;
			};
			deferred[ tuple[0] + "With" ] = list.fireWith;
		});

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( subordinate /* , ..., subordinateN */ ) {
		var i = 0,
			resolveValues = slice.call( arguments ),
			length = resolveValues.length,

			// the count of uncompleted subordinates
			remaining = length !== 1 || ( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,

			// the master Deferred. If resolveValues consist of only a single Deferred, just use that.
			deferred = remaining === 1 ? subordinate : jQuery.Deferred(),

			// Update function for both resolve and progress values
			updateFunc = function( i, contexts, values ) {
				return function( value ) {
					contexts[ i ] = this;
					values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( values === progressValues ) {
						deferred.notifyWith( contexts, values );
					} else if ( !( --remaining ) ) {
						deferred.resolveWith( contexts, values );
					}
				};
			},

			progressValues, progressContexts, resolveContexts;

		// Add listeners to Deferred subordinates; treat others as resolved
		if ( length > 1 ) {
			progressValues = new Array( length );
			progressContexts = new Array( length );
			resolveContexts = new Array( length );
			for ( ; i < length; i++ ) {
				if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
					resolveValues[ i ].promise()
						.done( updateFunc( i, resolveContexts, resolveValues ) )
						.fail( deferred.reject )
						.progress( updateFunc( i, progressContexts, progressValues ) );
				} else {
					--remaining;
				}
			}
		}

		// If we're not waiting on anything, resolve the master
		if ( !remaining ) {
			deferred.resolveWith( resolveContexts, resolveValues );
		}

		return deferred.promise();
	}
});


// The deferred used on DOM ready
var readyList;

jQuery.fn.ready = function( fn ) {
	// Add the callback
	jQuery.ready.promise().done( fn );

	return this;
};

jQuery.extend({
	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Hold (or release) the ready event
	holdReady: function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	},

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );

		// Trigger any bound ready events
		if ( jQuery.fn.triggerHandler ) {
			jQuery( document ).triggerHandler( "ready" );
			jQuery( document ).off( "ready" );
		}
	}
});

/**
 * The ready event handler and self cleanup method
 */
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed, false );
	window.removeEventListener( "load", completed, false );
	jQuery.ready();
}

jQuery.ready.promise = function( obj ) {
	if ( !readyList ) {

		readyList = jQuery.Deferred();

		// Catch cases where $(document).ready() is called after the browser event has already occurred.
		// We once tried to use readyState "interactive" here, but it caused issues like the one
		// discovered by ChrisS here: http://bugs.jquery.com/ticket/12282#comment:15
		if ( document.readyState === "complete" ) {
			// Handle it asynchronously to allow scripts the opportunity to delay ready
			setTimeout( jQuery.ready );

		} else {

			// Use the handy event callback
			document.addEventListener( "DOMContentLoaded", completed, false );

			// A fallback to window.onload, that will always work
			window.addEventListener( "load", completed, false );
		}
	}
	return readyList.promise( obj );
};

// Kick off the DOM ready check even if the user does not
jQuery.ready.promise();




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = jQuery.access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			jQuery.access( elems, fn, i, key[i], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {
			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn( elems[i], key, raw ? value : value.call( elems[i], i, fn( elems[i], key ) ) );
			}
		}
	}

	return chainable ?
		elems :

		// Gets
		bulk ?
			fn.call( elems ) :
			len ? fn( elems[0], key ) : emptyGet;
};


/**
 * Determines whether an object can have data
 */
jQuery.acceptData = function( owner ) {
	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	/* jshint -W018 */
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};


function Data() {
	// Support: Android<4,
	// Old WebKit does not have Object.preventExtensions/freeze method,
	// return new empty object instead with no [[set]] accessor
	Object.defineProperty( this.cache = {}, 0, {
		get: function() {
			return {};
		}
	});

	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;
Data.accepts = jQuery.acceptData;

Data.prototype = {
	key: function( owner ) {
		// We can accept data for non-element nodes in modern browsers,
		// but we should not, see #8335.
		// Always return the key for a frozen object.
		if ( !Data.accepts( owner ) ) {
			return 0;
		}

		var descriptor = {},
			// Check if the owner object already has a cache key
			unlock = owner[ this.expando ];

		// If not, create one
		if ( !unlock ) {
			unlock = Data.uid++;

			// Secure it in a non-enumerable, non-writable property
			try {
				descriptor[ this.expando ] = { value: unlock };
				Object.defineProperties( owner, descriptor );

			// Support: Android<4
			// Fallback to a less secure definition
			} catch ( e ) {
				descriptor[ this.expando ] = unlock;
				jQuery.extend( owner, descriptor );
			}
		}

		// Ensure the cache object
		if ( !this.cache[ unlock ] ) {
			this.cache[ unlock ] = {};
		}

		return unlock;
	},
	set: function( owner, data, value ) {
		var prop,
			// There may be an unlock assigned to this node,
			// if there is no entry for this "owner", create one inline
			// and set the unlock as though an owner entry had always existed
			unlock = this.key( owner ),
			cache = this.cache[ unlock ];

		// Handle: [ owner, key, value ] args
		if ( typeof data === "string" ) {
			cache[ data ] = value;

		// Handle: [ owner, { properties } ] args
		} else {
			// Fresh assignments by object are shallow copied
			if ( jQuery.isEmptyObject( cache ) ) {
				jQuery.extend( this.cache[ unlock ], data );
			// Otherwise, copy the properties one-by-one to the cache object
			} else {
				for ( prop in data ) {
					cache[ prop ] = data[ prop ];
				}
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		// Either a valid cache is found, or will be created.
		// New caches will be created and the unlock returned,
		// allowing direct access to the newly created
		// empty data object. A valid owner object must be provided.
		var cache = this.cache[ this.key( owner ) ];

		return key === undefined ?
			cache : cache[ key ];
	},
	access: function( owner, key, value ) {
		var stored;
		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				((key && typeof key === "string") && value === undefined) ) {

			stored = this.get( owner, key );

			return stored !== undefined ?
				stored : this.get( owner, jQuery.camelCase(key) );
		}

		// [*]When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i, name, camel,
			unlock = this.key( owner ),
			cache = this.cache[ unlock ];

		if ( key === undefined ) {
			this.cache[ unlock ] = {};

		} else {
			// Support array or space separated string of keys
			if ( jQuery.isArray( key ) ) {
				// If "name" is an array of keys...
				// When data is initially created, via ("key", "val") signature,
				// keys will be converted to camelCase.
				// Since there is no way to tell _how_ a key was added, remove
				// both plain key and camelCase key. #12786
				// This will only penalize the array argument path.
				name = key.concat( key.map( jQuery.camelCase ) );
			} else {
				camel = jQuery.camelCase( key );
				// Try the string as a key before any manipulation
				if ( key in cache ) {
					name = [ key, camel ];
				} else {
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					name = camel;
					name = name in cache ?
						[ name ] : ( name.match( rnotwhite ) || [] );
				}
			}

			i = name.length;
			while ( i-- ) {
				delete cache[ name[ i ] ];
			}
		}
	},
	hasData: function( owner ) {
		return !jQuery.isEmptyObject(
			this.cache[ owner[ this.expando ] ] || {}
		);
	},
	discard: function( owner ) {
		if ( owner[ this.expando ] ) {
			delete this.cache[ owner[ this.expando ] ];
		}
	}
};
var data_priv = new Data();

var data_user = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /([A-Z])/g;

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = data === "true" ? true :
					data === "false" ? false :
					data === "null" ? null :
					// Only convert to a number if it doesn't change the string
					+data + "" === data ? +data :
					rbrace.test( data ) ? jQuery.parseJSON( data ) :
					data;
			} catch( e ) {}

			// Make sure we set the data so it isn't changed later
			data_user.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend({
	hasData: function( elem ) {
		return data_user.hasData( elem ) || data_priv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return data_user.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		data_user.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to data_priv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return data_priv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		data_priv.remove( elem, name );
	}
});

jQuery.fn.extend({
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = data_user.get( elem );

				if ( elem.nodeType === 1 && !data_priv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE11+
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice(5) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					data_priv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each(function() {
				data_user.set( this, key );
			});
		}

		return access( this, function( value ) {
			var data,
				camelKey = jQuery.camelCase( key );

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {
				// Attempt to get data from the cache
				// with the key as-is
				data = data_user.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to get data from the cache
				// with the key camelized
				data = data_user.get( elem, camelKey );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, camelKey, undefined );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each(function() {
				// First, attempt to store a copy or reference of any
				// data that might've been store with a camelCased key.
				var data = data_user.get( this, camelKey );

				// For HTML5 data-* attribute interop, we have to
				// store property names with dashes in a camelCase form.
				// This might not apply to all properties...*
				data_user.set( this, camelKey, value );

				// *... In the case of properties that might _actually_
				// have dashes, we need to also store a copy of that
				// unchanged property.
				if ( key.indexOf("-") !== -1 && data !== undefined ) {
					data_user.set( this, key, value );
				}
			});
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each(function() {
			data_user.remove( this, key );
		});
	}
});


jQuery.extend({
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = data_priv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || jQuery.isArray( data ) ) {
					queue = data_priv.access( elem, type, jQuery.makeArray(data) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return data_priv.get( elem, key ) || data_priv.access( elem, key, {
			empty: jQuery.Callbacks("once memory").add(function() {
				data_priv.remove( elem, [ type + "queue", key ] );
			})
		});
	}
});

jQuery.fn.extend({
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[0], type );
		}

		return data === undefined ?
			this :
			this.each(function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[0] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			});
	},
	dequeue: function( type ) {
		return this.each(function() {
			jQuery.dequeue( this, type );
		});
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},
	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = data_priv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
});
var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;

var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHidden = function( elem, el ) {
		// isHidden might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;
		return jQuery.css( elem, "display" ) === "none" || !jQuery.contains( elem.ownerDocument, elem );
	};

var rcheckableType = (/^(?:checkbox|radio)$/i);



(function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Safari<=5.1
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Safari<=5.1, Android<4.2
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE<=11+
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
})();
var strundefined = typeof undefined;



support.focusinBubbles = "onfocusin" in window;


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu)|click/,
	rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)$/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = data_priv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !(events = elemData.events) ) {
			events = elemData.events = {};
		}
		if ( !(eventHandle = elemData.handle) ) {
			eventHandle = elemData.handle = function( e ) {
				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== strundefined && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[t] ) || [];
			type = origType = tmp[1];
			namespaces = ( tmp[2] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend({
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join(".")
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !(handlers = events[ type ]) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup || special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle, false );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = data_priv.hasData( elem ) && data_priv.get( elem );

		if ( !elemData || !(events = elemData.events) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[t] ) || [];
			type = origType = tmp[1];
			namespaces = ( tmp[2] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[2] && new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector || selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown || special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			delete elemData.handle;
			data_priv.remove( elem, "events" );
		}
	},

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split(".") : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf(".") >= 0 ) {
			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split(".");
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf(":") < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join(".");
		event.namespace_re = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === (elem.ownerDocument || document) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( (cur = eventPath[i++]) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( data_priv.get( cur, "events" ) || {} )[ event.type ] && data_priv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && jQuery.acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( (!special._default || special._default.apply( eventPath.pop(), data ) === false) &&
				jQuery.acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	dispatch: function( event ) {

		// Make a writable jQuery.Event from the native event object
		event = jQuery.event.fix( event );

		var i, j, ret, matched, handleObj,
			handlerQueue = [],
			args = slice.call( arguments ),
			handlers = ( data_priv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[0] = event;
		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( (matched = handlerQueue[ i++ ]) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( (handleObj = matched.handlers[ j++ ]) && !event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.namespace_re || event.namespace_re.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( (jQuery.event.special[ handleObj.origType ] || {}).handle || handleObj.handler )
							.apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( (event.result = ret) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, matches, sel, handleObj,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		// Black-hole SVG <use> instance trees (#13180)
		// Avoid non-left-click bubbling in Firefox (#3861)
		if ( delegateCount && cur.nodeType && (!event.button || event.type !== "click") ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.disabled !== true || event.type !== "click" ) {
					matches = [];
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matches[ sel ] === undefined ) {
							matches[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) >= 0 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matches[ sel ] ) {
							matches.push( handleObj );
						}
					}
					if ( matches.length ) {
						handlerQueue.push({ elem: cur, handlers: matches });
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		if ( delegateCount < handlers.length ) {
			handlerQueue.push({ elem: this, handlers: handlers.slice( delegateCount ) });
		}

		return handlerQueue;
	},

	// Includes some event props shared by KeyEvent and MouseEvent
	props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),

	fixHooks: {},

	keyHooks: {
		props: "char charCode key keyCode".split(" "),
		filter: function( event, original ) {

			// Add which for key events
			if ( event.which == null ) {
				event.which = original.charCode != null ? original.charCode : original.keyCode;
			}

			return event;
		}
	},

	mouseHooks: {
		props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
		filter: function( event, original ) {
			var eventDoc, doc, body,
				button = original.button;

			// Calculate pageX/Y if missing and clientX/Y available
			if ( event.pageX == null && original.clientX != null ) {
				eventDoc = event.target.ownerDocument || document;
				doc = eventDoc.documentElement;
				body = eventDoc.body;

				event.pageX = original.clientX + ( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) - ( doc && doc.clientLeft || body && body.clientLeft || 0 );
				event.pageY = original.clientY + ( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) - ( doc && doc.clientTop  || body && body.clientTop  || 0 );
			}

			// Add which for click: 1 === left; 2 === middle; 3 === right
			// Note: button is not normalized, so don't use it
			if ( !event.which && button !== undefined ) {
				event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
			}

			return event;
		}
	},

	fix: function( event ) {
		if ( event[ jQuery.expando ] ) {
			return event;
		}

		// Create a writable copy of the event object and normalize some properties
		var i, prop, copy,
			type = event.type,
			originalEvent = event,
			fixHook = this.fixHooks[ type ];

		if ( !fixHook ) {
			this.fixHooks[ type ] = fixHook =
				rmouseEvent.test( type ) ? this.mouseHooks :
				rkeyEvent.test( type ) ? this.keyHooks :
				{};
		}
		copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;

		event = new jQuery.Event( originalEvent );

		i = copy.length;
		while ( i-- ) {
			prop = copy[ i ];
			event[ prop ] = originalEvent[ prop ];
		}

		// Support: Cordova 2.5 (WebKit) (#13255)
		// All events should have a target; Cordova deviceready doesn't
		if ( !event.target ) {
			event.target = document;
		}

		// Support: Safari 6.0+, Chrome<28
		// Target should not be a text node (#504, #13143)
		if ( event.target.nodeType === 3 ) {
			event.target = event.target.parentNode;
		}

		return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
	},

	special: {
		load: {
			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {
			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {
			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return jQuery.nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	},

	simulate: function( type, elem, event, bubble ) {
		// Piggyback on a donor event to simulate a different one.
		// Fake originalEvent to avoid donor's stopPropagation, but if the
		// simulated event prevents default then we do the same on the donor.
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true,
				originalEvent: {}
			}
		);
		if ( bubble ) {
			jQuery.event.trigger( e, null, elem );
		} else {
			jQuery.event.dispatch.call( elem, e );
		}
		if ( e.isDefaultPrevented() ) {
			event.preventDefault();
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle, false );
	}
};

jQuery.Event = function( src, props ) {
	// Allow instantiation without the 'new' keyword
	if ( !(this instanceof jQuery.Event) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&
				// Support: Android<4.0
				src.returnValue === false ?
			returnTrue :
			returnFalse;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && e.preventDefault ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && e.stopPropagation ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && e.stopImmediatePropagation ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Create mouseenter/leave events using mouseover/out and event-time checks
// Support: Chrome 15+
jQuery.each({
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mousenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || (related !== target && !jQuery.contains( target, related )) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
});

// Support: Firefox, Chrome, Safari
// Create "bubbling" focus and blur events
if ( !support.focusinBubbles ) {
	jQuery.each({ focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ), true );
			};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = data_priv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				data_priv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = data_priv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					data_priv.remove( doc, fix );

				} else {
					data_priv.access( doc, fix, attaches );
				}
			}
		};
	});
}

jQuery.fn.extend({

	on: function( types, selector, data, fn, /*INTERNAL*/ one ) {
		var origFn, type;

		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				this.on( type, selector, data, types[ type ], one );
			}
			return this;
		}

		if ( data == null && fn == null ) {
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return this;
		}

		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return this.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		});
	},
	one: function( types, selector, data, fn ) {
		return this.on( types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {
			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {
			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {
			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each(function() {
			jQuery.event.remove( this, types, fn, selector );
		});
	},

	trigger: function( type, data ) {
		return this.each(function() {
			jQuery.event.trigger( type, data, this );
		});
	},
	triggerHandler: function( type, data ) {
		var elem = this[0];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
});


var
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
	rtagName = /<([\w:]+)/,
	rhtml = /<|&#?\w+;/,
	rnoInnerhtml = /<(?:script|style|link)/i,
	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptType = /^$|\/(?:java|ecma)script/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,

	// We have to close these tags to support XHTML (#13200)
	wrapMap = {

		// Support: IE9
		option: [ 1, "<select multiple='multiple'>", "</select>" ],

		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

		_default: [ 0, "", "" ]
	};

// Support: IE9
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: 1.x compatibility
// Manipulating tables requires a tbody
function manipulationTarget( elem, content ) {
	return jQuery.nodeName( elem, "table" ) &&
		jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?

		elem.getElementsByTagName("tbody")[0] ||
			elem.appendChild( elem.ownerDocument.createElement("tbody") ) :
		elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute("type");
	}

	return elem;
}

// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		data_priv.set(
			elems[ i ], "globalEval", !refElements || data_priv.get( refElements[ i ], "globalEval" )
		);
	}
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( data_priv.hasData( src ) ) {
		pdataOld = data_priv.access( src );
		pdataCur = data_priv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( data_user.hasData( src ) ) {
		udataOld = data_user.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		data_user.set( dest, udataCur );
	}
}

function getAll( context, tag ) {
	var ret = context.getElementsByTagName ? context.getElementsByTagName( tag || "*" ) :
			context.querySelectorAll ? context.querySelectorAll( tag || "*" ) :
			[];

	return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
		jQuery.merge( [ context ], ret ) :
		ret;
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

jQuery.extend({
	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	buildFragment: function( elems, context, scripts, selection ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;

		for ( ; i < l; i++ ) {
			elem = elems[ i ];

			if ( elem || elem === 0 ) {

				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
					// Support: QtWebKit, PhantomJS
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );

				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement("div") );

					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + elem.replace( rxhtmlTag, "<$1></$2>" ) + wrap[ 2 ];

					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}

					// Support: QtWebKit, PhantomJS
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );

					// Remember the top-level container
					tmp = fragment.firstChild;

					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}

		// Remove wrapper from fragment
		fragment.textContent = "";

		i = 0;
		while ( (elem = nodes[ i++ ]) ) {

			// #4087 - If origin and destination elements are the same, and this is
			// that element, do not do anything
			if ( selection && jQuery.inArray( elem, selection ) !== -1 ) {
				continue;
			}

			contains = jQuery.contains( elem.ownerDocument, elem );

			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );

			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}

			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( (elem = tmp[ j++ ]) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}

		return fragment;
	},

	cleanData: function( elems ) {
		var data, elem, type, key,
			special = jQuery.event.special,
			i = 0;

		for ( ; (elem = elems[ i ]) !== undefined; i++ ) {
			if ( jQuery.acceptData( elem ) ) {
				key = elem[ data_priv.expando ];

				if ( key && (data = data_priv.cache[ key ]) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}
					if ( data_priv.cache[ key ] ) {
						// Discard any remaining `private` data
						delete data_priv.cache[ key ];
					}
				}
			}
			// Discard any remaining `user` data
			delete data_user.cache[ elem[ data_user.expando ] ];
		}
	}
});

jQuery.fn.extend({
	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each(function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				});
		}, null, value, arguments.length );
	},

	append: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		});
	},

	prepend: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		});
	},

	before: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		});
	},

	after: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		});
	},

	remove: function( selector, keepData /* Internal Use Only */ ) {
		var elem,
			elems = selector ? jQuery.filter( selector, this ) : this,
			i = 0;

		for ( ; (elem = elems[i]) != null; i++ ) {
			if ( !keepData && elem.nodeType === 1 ) {
				jQuery.cleanData( getAll( elem ) );
			}

			if ( elem.parentNode ) {
				if ( keepData && jQuery.contains( elem.ownerDocument, elem ) ) {
					setGlobalEval( getAll( elem, "script" ) );
				}
				elem.parentNode.removeChild( elem );
			}
		}

		return this;
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; (elem = this[i]) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map(function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		});
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = value.replace( rxhtmlTag, "<$1></$2>" );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var arg = arguments[ 0 ];

		// Make the changes, replacing each context element with the new content
		this.domManip( arguments, function( elem ) {
			arg = this.parentNode;

			jQuery.cleanData( getAll( this ) );

			if ( arg ) {
				arg.replaceChild( elem, this );
			}
		});

		// Force removal if there was no new content (e.g., from empty arguments)
		return arg && (arg.length || arg.nodeType) ? this : this.remove();
	},

	detach: function( selector ) {
		return this.remove( selector, true );
	},

	domManip: function( args, callback ) {

		// Flatten any nested arrays
		args = concat.apply( [], args );

		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = this.length,
			set = this,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );

		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return this.each(function( index ) {
				var self = set.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				self.domManip( args, callback );
			});
		}

		if ( l ) {
			fragment = jQuery.buildFragment( args, this[ 0 ].ownerDocument, false, this );
			first = fragment.firstChild;

			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}

			if ( first ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;

				// Use the original fragment for the last item instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;

					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );

						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
							// Support: QtWebKit
							// jQuery.merge because push.apply(_, arraylike) throws
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}

					callback.call( this[ i ], node, i );
				}

				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;

					// Reenable scripts
					jQuery.map( scripts, restoreScript );

					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!data_priv.access( node, "globalEval" ) && jQuery.contains( doc, node ) ) {

							if ( node.src ) {
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
							}
						}
					}
				}
			}
		}

		return this;
	}
});

jQuery.each({
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: QtWebKit
			// .get() because push.apply(_, arraylike) throws
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
});


var iframe,
	elemdisplay = {};

/**
 * Retrieve the actual display of a element
 * @param {String} name nodeName of the element
 * @param {Object} doc Document object
 */
// Called only from within defaultDisplay
function actualDisplay( name, doc ) {
	var style,
		elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),

		// getDefaultComputedStyle might be reliably used only on attached element
		display = window.getDefaultComputedStyle && ( style = window.getDefaultComputedStyle( elem[ 0 ] ) ) ?

			// Use of this method is a temporary fix (more like optimization) until something better comes along,
			// since it was removed from specification and supported only in FF
			style.display : jQuery.css( elem[ 0 ], "display" );

	// We don't have any data stored on the element,
	// so use "detach" method as fast way to get rid of the element
	elem.detach();

	return display;
}

/**
 * Try to determine the default display value of an element
 * @param {String} nodeName
 */
function defaultDisplay( nodeName ) {
	var doc = document,
		display = elemdisplay[ nodeName ];

	if ( !display ) {
		display = actualDisplay( nodeName, doc );

		// If the simple way fails, read from inside an iframe
		if ( display === "none" || !display ) {

			// Use the already-created iframe if possible
			iframe = (iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" )).appendTo( doc.documentElement );

			// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
			doc = iframe[ 0 ].contentDocument;

			// Support: IE
			doc.write();
			doc.close();

			display = actualDisplay( nodeName, doc );
			iframe.detach();
		}

		// Store the correct default display
		elemdisplay[ nodeName ] = display;
	}

	return display;
}
var rmargin = (/^margin/);

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {
		// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		if ( elem.ownerDocument.defaultView.opener ) {
			return elem.ownerDocument.defaultView.getComputedStyle( elem, null );
		}

		return window.getComputedStyle( elem, null );
	};



function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		style = elem.style;

	computed = computed || getStyles( elem );

	// Support: IE9
	// getPropertyValue is only needed for .css('filter') (#12537)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];
	}

	if ( computed ) {

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// Support: iOS < 6
		// A tribute to the "awesome hack by Dean Edwards"
		// iOS < 6 (at least) returns percentage for a larger set of values, but width seems to be reliably pixels
		// this is against the CSSOM draft spec: http://dev.w3.org/csswg/cssom/#resolved-values
		if ( rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?
		// Support: IE
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {
	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {
				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return (this.get = hookFn).apply( this, arguments );
		}
	};
}


(function() {
	var pixelPositionVal, boxSizingReliableVal,
		docElem = document.documentElement,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	if ( !div.style ) {
		return;
	}

	// Support: IE9-11+
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;" +
		"position:absolute";
	container.appendChild( div );

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computePixelPositionAndBoxSizingReliable() {
		div.style.cssText =
			// Support: Firefox<29, Android 2.3
			// Vendor-prefix box-sizing
			"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;" +
			"box-sizing:border-box;display:block;margin-top:1%;top:1%;" +
			"border:1px;padding:1px;width:4px;position:absolute";
		div.innerHTML = "";
		docElem.appendChild( container );

		var divStyle = window.getComputedStyle( div, null );
		pixelPositionVal = divStyle.top !== "1%";
		boxSizingReliableVal = divStyle.width === "4px";

		docElem.removeChild( container );
	}

	// Support: node.js jsdom
	// Don't assume that getComputedStyle is a property of the global object
	if ( window.getComputedStyle ) {
		jQuery.extend( support, {
			pixelPosition: function() {

				// This test is executed only once but we still do memoizing
				// since we can use the boxSizingReliable pre-computing.
				// No need to check if the test was already performed, though.
				computePixelPositionAndBoxSizingReliable();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				if ( boxSizingReliableVal == null ) {
					computePixelPositionAndBoxSizingReliable();
				}
				return boxSizingReliableVal;
			},
			reliableMarginRight: function() {

				// Support: Android 2.3
				// Check if div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container. (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				// This support function is only executed once so no memoizing is needed.
				var ret,
					marginDiv = div.appendChild( document.createElement( "div" ) );

				// Reset CSS: box-sizing; display; margin; border; padding
				marginDiv.style.cssText = div.style.cssText =
					// Support: Firefox<29, Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
					"box-sizing:content-box;display:block;margin:0;border:0;padding:0";
				marginDiv.style.marginRight = marginDiv.style.width = "0";
				div.style.width = "1px";
				docElem.appendChild( container );

				ret = !parseFloat( window.getComputedStyle( marginDiv, null ).marginRight );

				docElem.removeChild( container );
				div.removeChild( marginDiv );

				return ret;
			}
		});
	}
})();


// A method for quickly swapping in/out CSS properties to get correct calculations.
jQuery.swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var
	// Swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),
	rrelNum = new RegExp( "^([+-])=(" + pnum + ")", "i" ),

	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "O", "Moz", "ms" ];

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( style, name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in style ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[0].toUpperCase() + name.slice(1),
		origName = name,
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in style ) {
			return name;
		}
	}

	return origName;
}

function setPositiveNumber( elem, value, subtract ) {
	var matches = rnumsplit.exec( value );
	return matches ?
		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i = extra === ( isBorderBox ? "border" : "content" ) ?
		// If we already have the right measurement, avoid augmentation
		4 :
		// Otherwise initialize for horizontal or vertical properties
		name === "width" ? 1 : 0,

		val = 0;

	for ( ; i < 4; i += 2 ) {
		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {
			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {
			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with offset property, which is equivalent to the border-box value
	var valueIsBorderBox = true,
		val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
		styles = getStyles( elem ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Some non-html elements return undefined for offsetWidth, so check for null/undefined
	// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	if ( val <= 0 || val == null ) {
		// Fall back to computed then uncomputed css if necessary
		val = curCSS( elem, name, styles );
		if ( val < 0 || val == null ) {
			val = elem.style[ name ];
		}

		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test(val) ) {
			return val;
		}

		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );

		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	}

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

function showHide( elements, show ) {
	var display, elem, hidden,
		values = [],
		index = 0,
		length = elements.length;

	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		values[ index ] = data_priv.get( elem, "olddisplay" );
		display = elem.style.display;
		if ( show ) {
			// Reset the inline display of this element to learn if it is
			// being hidden by cascaded rules or not
			if ( !values[ index ] && display === "none" ) {
				elem.style.display = "";
			}

			// Set elements which have been overridden with display: none
			// in a stylesheet to whatever the default browser style is
			// for such an element
			if ( elem.style.display === "" && isHidden( elem ) ) {
				values[ index ] = data_priv.access( elem, "olddisplay", defaultDisplay(elem.nodeName) );
			}
		} else {
			hidden = isHidden( elem );

			if ( display !== "none" || !hidden ) {
				data_priv.set( elem, "olddisplay", hidden ? display : jQuery.css( elem, "display" ) );
			}
		}
	}

	// Set the display of most of the elements in a second loop
	// to avoid the constant reflow
	for ( index = 0; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}
		if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
			elem.style.display = show ? values[ index ] || "" : "none";
		}
	}

	return elements;
}

jQuery.extend({

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			style = elem.style;

		name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( style, origName ) );

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && (ret = rrelNum.exec( value )) ) {
				value = ( ret[1] + 1 ) * ret[2] + parseFloat( jQuery.css( elem, name ) );
				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number, add 'px' to the (except for certain CSS properties)
			if ( type === "number" && !jQuery.cssNumber[ origName ] ) {
				value += "px";
			}

			// Support: IE9-11+
			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !("set" in hooks) || (value = hooks.set( elem, value, extra )) !== undefined ) {
				style[ name ] = value;
			}

		} else {
			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks && (ret = hooks.get( elem, false, extra )) !== undefined ) {
				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name );

		// Make sure that we're working with the right name
		name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( elem.style, origName ) );

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || jQuery.isNumeric( num ) ? num || 0 : val;
		}
		return val;
	}
});

jQuery.each([ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) && elem.offsetWidth === 0 ?
					jQuery.swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, name, extra );
					}) :
					getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var styles = extra && getStyles( elem );
			return setPositiveNumber( elem, value, extra ?
				augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				) : 0
			);
		}
	};
});

// Support: Android 2.3
jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
	function( elem, computed ) {
		if ( computed ) {
			return jQuery.swap( elem, { "display": "inline-block" },
				curCSS, [ elem, "marginRight" ] );
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each({
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split(" ") : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
});

jQuery.fn.extend({
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( jQuery.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	},
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each(function() {
			if ( isHidden( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		});
	}
});


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || "swing";
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			if ( tween.elem[ tween.prop ] != null &&
				(!tween.elem.style || tween.elem.style[ tween.prop ] == null) ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );
			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {
			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.style && ( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null || jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE9
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	}
};

jQuery.fx = Tween.prototype.init;

// Back Compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, timerId,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rfxnum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" ),
	rrun = /queueHooks$/,
	animationPrefilters = [ defaultPrefilter ],
	tweeners = {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value ),
				target = tween.cur(),
				parts = rfxnum.exec( value ),
				unit = parts && parts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

				// Starting value computation is required for potential unit mismatches
				start = ( jQuery.cssNumber[ prop ] || unit !== "px" && +target ) &&
					rfxnum.exec( jQuery.css( tween.elem, prop ) ),
				scale = 1,
				maxIterations = 20;

			if ( start && start[ 3 ] !== unit ) {
				// Trust units reported by jQuery.css
				unit = unit || start[ 3 ];

				// Make sure we update the tween properties later on
				parts = parts || [];

				// Iteratively approximate from a nonzero starting point
				start = +target || 1;

				do {
					// If previous iteration zeroed out, double until we get *something*.
					// Use string for doubling so we don't accidentally see scale as unchanged below
					scale = scale || ".5";

					// Adjust and apply
					start = start / scale;
					jQuery.style( tween.elem, prop, start + unit );

				// Update scale, tolerating zero or NaN from tween.cur(),
				// break the loop if scale is unchanged or perfect, or if we've just had enough
				} while ( scale !== (scale = tween.cur() / target) && scale !== 1 && --maxIterations );
			}

			// Update tween properties
			if ( parts ) {
				start = tween.start = +start || +target || 0;
				tween.unit = unit;
				// If a +=/-= token was provided, we're doing a relative animation
				tween.end = parts[ 1 ] ?
					start + ( parts[ 1 ] + 1 ) * parts[ 2 ] :
					+parts[ 2 ];
			}

			return tween;
		} ]
	};

// Animations created synchronously will run synchronously
function createFxNow() {
	setTimeout(function() {
		fxNow = undefined;
	});
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4 ; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( tweeners[ prop ] || [] ).concat( tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( (tween = collection[ index ].call( animation, prop, value )) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	/* jshint validthis: true */
	var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHidden( elem ),
		dataShow = data_priv.get( elem, "fxshow" );

	// Handle queue: false promises
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always(function() {
			// Ensure the complete handler is called before this completes
			anim.always(function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			});
		});
	}

	// Height/width overflow pass
	if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
		// Make sure that nothing sneaks out
		// Record all 3 overflow attributes because IE9-10 do not
		// change the overflow attribute when overflowX and
		// overflowY are set to the same value
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Set display property to inline-block for height/width
		// animations on inline elements that are having width/height animated
		display = jQuery.css( elem, "display" );

		// Test default display if display is currently "none"
		checkDisplay = display === "none" ?
			data_priv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;

		if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
			style.display = "inline-block";
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always(function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		});
	}

	// show/hide pass
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.exec( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// If there is dataShow left over from a stopped hide or show and we are going to proceed with show, we should pretend to be hidden
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );

		// Any non-fx value stops us from restoring the original display value
		} else {
			display = undefined;
		}
	}

	if ( !jQuery.isEmptyObject( orig ) ) {
		if ( dataShow ) {
			if ( "hidden" in dataShow ) {
				hidden = dataShow.hidden;
			}
		} else {
			dataShow = data_priv.access( elem, "fxshow", {} );
		}

		// Store state if its toggle - enables .stop().toggle() to "reverse"
		if ( toggle ) {
			dataShow.hidden = !hidden;
		}
		if ( hidden ) {
			jQuery( elem ).show();
		} else {
			anim.done(function() {
				jQuery( elem ).hide();
			});
		}
		anim.done(function() {
			var prop;

			data_priv.remove( elem, "fxshow" );
			for ( prop in orig ) {
				jQuery.style( elem, prop, orig[ prop ] );
			}
		});
		for ( prop in orig ) {
			tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );

			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = tween.start;
				if ( hidden ) {
					tween.end = tween.start;
					tween.start = prop === "width" || prop === "height" ? 1 : 0;
				}
			}
		}

	// If this is a noop like .hide().hide(), restore an overwritten display value
	} else if ( (display === "none" ? defaultDisplay( elem.nodeName ) : display) === "inline" ) {
		style.display = display;
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( jQuery.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = animationPrefilters.length,
		deferred = jQuery.Deferred().always( function() {
			// Don't match elem in the :animated selector
			delete tick.elem;
		}),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
				// Support: Android 2.3
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length ; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ]);

			if ( percent < 1 && length ) {
				return remaining;
			} else {
				deferred.resolveWith( elem, [ animation ] );
				return false;
			}
		},
		animation = deferred.promise({
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, { specialEasing: {} }, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,
					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		}),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length ; index++ ) {
		result = animationPrefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		})
	);

	// attach callbacks from options
	return animation.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );
}

jQuery.Animation = jQuery.extend( Animation, {

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.split(" ");
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length ; index++ ) {
			prop = props[ index ];
			tweeners[ prop ] = tweeners[ prop ] || [];
			tweeners[ prop ].unshift( callback );
		}
	},

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			animationPrefilters.unshift( callback );
		} else {
			animationPrefilters.push( callback );
		}
	}
});

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
		opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend({
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHidden ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate({ opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {
				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || data_priv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each(function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = data_priv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && (type == null || timers[ index ].queue === type) ) {
					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		});
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each(function() {
			var index,
				data = data_priv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		});
	}
});

jQuery.each([ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
});

// Generate shortcuts for custom animations
jQuery.each({
	slideDown: genFx("show"),
	slideUp: genFx("hide"),
	slideToggle: genFx("toggle"),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
});

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];
		// Checks the timer has not already been removed
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	if ( timer() ) {
		jQuery.fx.start();
	} else {
		jQuery.timers.pop();
	}
};

jQuery.fx.interval = 13;

jQuery.fx.start = function() {
	if ( !timerId ) {
		timerId = setInterval( jQuery.fx.tick, jQuery.fx.interval );
	}
};

jQuery.fx.stop = function() {
	clearInterval( timerId );
	timerId = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,
	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = setTimeout( next, time );
		hooks.stop = function() {
			clearTimeout( timeout );
		};
	});
};


(function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: iOS<=5.1, Android<=4.2+
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE<=11+
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: Android<=2.3
	// Options inside disabled selects are incorrectly marked as disabled
	select.disabled = true;
	support.optDisabled = !opt.disabled;

	// Support: IE<=11+
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
})();


var nodeHook, boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend({
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each(function() {
			jQuery.removeAttr( this, name );
		});
	}
});

jQuery.extend({
	attr: function( elem, name, value ) {
		var hooks, ret,
			nType = elem.nodeType;

		// don't get/set attributes on text, comment and attribute nodes
		if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === strundefined ) {
			return jQuery.prop( elem, name, value );
		}

		// All attributes are lowercase
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			name = name.toLowerCase();
			hooks = jQuery.attrHooks[ name ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
		}

		if ( value !== undefined ) {

			if ( value === null ) {
				jQuery.removeAttr( elem, name );

			} else if ( hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ) {
				return ret;

			} else {
				elem.setAttribute( name, value + "" );
				return value;
			}

		} else if ( hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ) {
			return ret;

		} else {
			ret = jQuery.find.attr( elem, name );

			// Non-existent attributes return null, we normalize to undefined
			return ret == null ?
				undefined :
				ret;
		}
	},

	removeAttr: function( elem, value ) {
		var name, propName,
			i = 0,
			attrNames = value && value.match( rnotwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( (name = attrNames[i++]) ) {
				propName = jQuery.propFix[ name ] || name;

				// Boolean attributes get special treatment (#10870)
				if ( jQuery.expr.match.bool.test( name ) ) {
					// Set corresponding property to false
					elem[ propName ] = false;
				}

				elem.removeAttribute( name );
			}
		}
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					jQuery.nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	}
});

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {
			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};
jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle;
		if ( !isXML ) {
			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ name ];
			attrHandle[ name ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				name.toLowerCase() :
				null;
			attrHandle[ name ] = handle;
		}
		return ret;
	};
});




var rfocusable = /^(?:input|select|textarea|button)$/i;

jQuery.fn.extend({
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each(function() {
			delete this[ jQuery.propFix[ name ] || name ];
		});
	}
});

jQuery.extend({
	propFix: {
		"for": "htmlFor",
		"class": "className"
	},

	prop: function( elem, name, value ) {
		var ret, hooks, notxml,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		notxml = nType !== 1 || !jQuery.isXMLDoc( elem );

		if ( notxml ) {
			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			return hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ?
				ret :
				( elem[ name ] = value );

		} else {
			return hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ?
				ret :
				elem[ name ];
		}
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {
				return elem.hasAttribute( "tabindex" ) || rfocusable.test( elem.nodeName ) || elem.href ?
					elem.tabIndex :
					-1;
			}
		}
	}
});

if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {
			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		}
	};
}

jQuery.each([
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
});




var rclass = /[\t\r\n\f]/g;

jQuery.fn.extend({
	addClass: function( value ) {
		var classes, elem, cur, clazz, j, finalValue,
			proceed = typeof value === "string" && value,
			i = 0,
			len = this.length;

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( j ) {
				jQuery( this ).addClass( value.call( this, j, this.className ) );
			});
		}

		if ( proceed ) {
			// The disjunction here is for better compressibility (see removeClass)
			classes = ( value || "" ).match( rnotwhite ) || [];

			for ( ; i < len; i++ ) {
				elem = this[ i ];
				cur = elem.nodeType === 1 && ( elem.className ?
					( " " + elem.className + " " ).replace( rclass, " " ) :
					" "
				);

				if ( cur ) {
					j = 0;
					while ( (clazz = classes[j++]) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( elem.className !== finalValue ) {
						elem.className = finalValue;
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, clazz, j, finalValue,
			proceed = arguments.length === 0 || typeof value === "string" && value,
			i = 0,
			len = this.length;

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( j ) {
				jQuery( this ).removeClass( value.call( this, j, this.className ) );
			});
		}
		if ( proceed ) {
			classes = ( value || "" ).match( rnotwhite ) || [];

			for ( ; i < len; i++ ) {
				elem = this[ i ];
				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( elem.className ?
					( " " + elem.className + " " ).replace( rclass, " " ) :
					""
				);

				if ( cur ) {
					j = 0;
					while ( (clazz = classes[j++]) ) {
						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) >= 0 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = value ? jQuery.trim( cur ) : "";
					if ( elem.className !== finalValue ) {
						elem.className = finalValue;
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( i ) {
				jQuery( this ).toggleClass( value.call(this, i, this.className, stateVal), stateVal );
			});
		}

		return this.each(function() {
			if ( type === "string" ) {
				// Toggle individual class names
				var className,
					i = 0,
					self = jQuery( this ),
					classNames = value.match( rnotwhite ) || [];

				while ( (className = classNames[ i++ ]) ) {
					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( type === strundefined || type === "boolean" ) {
				if ( this.className ) {
					// store className if set
					data_priv.set( this, "__className__", this.className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				this.className = this.className || value === false ? "" : data_priv.get( this, "__className__" ) || "";
			}
		});
	},

	hasClass: function( selector ) {
		var className = " " + selector + " ",
			i = 0,
			l = this.length;
		for ( ; i < l; i++ ) {
			if ( this[i].nodeType === 1 && (" " + this[i].className + " ").replace(rclass, " ").indexOf( className ) >= 0 ) {
				return true;
			}
		}

		return false;
	}
});




var rreturn = /\r/g;

jQuery.fn.extend({
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[0];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] || jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks && "get" in hooks && (ret = hooks.get( elem, "value" )) !== undefined ) {
					return ret;
				}

				ret = elem.value;

				return typeof ret === "string" ?
					// Handle most common string cases
					ret.replace(rreturn, "") :
					// Handle cases where value is null/undef or number
					ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each(function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( jQuery.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				});
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !("set" in hooks) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		});
	}
});

jQuery.extend({
	valHooks: {
		option: {
			get: function( elem ) {
				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :
					// Support: IE10-11+
					// option.text throws exceptions (#14686, #14858)
					jQuery.trim( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one" || index < 0,
					values = one ? null : [],
					max = one ? index + 1 : options.length,
					i = index < 0 ?
						max :
						one ? index : 0;

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// IE6-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&
							// Don't return options that are disabled or in a disabled optgroup
							( support.optDisabled ? !option.disabled : option.getAttribute( "disabled" ) === null ) &&
							( !option.parentNode.disabled || !jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];
					if ( (option.selected = jQuery.inArray( option.value, values ) >= 0) ) {
						optionSet = true;
					}
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
});

// Radios and checkboxes getter/setter
jQuery.each([ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( jQuery.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery(elem).val(), value ) >= 0 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute("value") === null ? "on" : elem.value;
		};
	}
});




// Return jQuery for attributes-only inclusion


jQuery.each( ("blur focus focusin focusout load resize scroll unload click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup error contextmenu").split(" "), function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
});

jQuery.fn.extend({
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	},

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {
		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ? this.off( selector, "**" ) : this.off( types, selector || "**", fn );
	}
});


var nonce = jQuery.now();

var rquery = (/\?/);



// Support: Android 2.3
// Workaround failure to string-cast null input
jQuery.parseJSON = function( data ) {
	return JSON.parse( data + "" );
};


// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, tmp;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE9
	try {
		tmp = new DOMParser();
		xml = tmp.parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rhash = /#.*$/,
	rts = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,
	rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Document location
	ajaxLocation = window.location.href,

	// Segment location into parts
	ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];

		if ( jQuery.isFunction( func ) ) {
			// For each dataType in the dataTypeExpression
			while ( (dataType = dataTypes[i++]) ) {
				// Prepend if requested
				if ( dataType[0] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					(structure[ dataType ] = structure[ dataType ] || []).unshift( func );

				// Otherwise append
				} else {
					(structure[ dataType ] = structure[ dataType ] || []).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[ dataTypeOrTransport ] ) {
				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		});
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || (deep = {}) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {
		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[0] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}
		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},
		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

		// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {
								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s[ "throws" ] ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return { state: "parsererror", error: conv ? e : "No conversion from " + prev + " to " + current };
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend({

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: ajaxLocation,
		type: "GET",
		isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",
		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /xml/,
			html: /html/,
			json: /json/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": jQuery.parseJSON,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,
			// URL without anti-cache param
			cacheURL,
			// Response headers
			responseHeadersString,
			responseHeaders,
			// timeout handle
			timeoutTimer,
			// Cross-domain detection vars
			parts,
			// To know if global events are to be dispatched
			fireGlobals,
			// Loop variable
			i,
			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),
			// Callbacks context
			callbackContext = s.context || s,
			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context && ( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,
			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks("once memory"),
			// Status-dependent callbacks
			statusCode = s.statusCode || {},
			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},
			// The jqXHR state
			state = 0,
			// Default abort message
			strAbort = "canceled",
			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( state === 2 ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( (match = rheaders.exec( responseHeadersString )) ) {
								responseHeaders[ match[1].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return state === 2 ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					var lname = name.toLowerCase();
					if ( !state ) {
						name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( !state ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( state < 2 ) {
							for ( code in map ) {
								// Lazy-add the new callback in a way that preserves old ones
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						} else {
							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR ).complete = completeDeferred.add;
		jqXHR.success = jqXHR.done;
		jqXHR.error = jqXHR.fail;

		// Remove hash character (#7531: and string promotion)
		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || ajaxLocation ) + "" ).replace( rhash, "" )
			.replace( rprotocol, ajaxLocParts[ 1 ] + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];

		// A cross-domain request is in order when we have a protocol:host:port mismatch
		if ( s.crossDomain == null ) {
			parts = rurl.exec( s.url.toLowerCase() );
			s.crossDomain = !!( parts &&
				( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
					( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
						( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
			);
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( state === 2 ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger("ajaxStart");
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		cacheURL = s.url;

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add anti-cache in url if needed
			if ( s.cache === false ) {
				s.url = rts.test( cacheURL ) ?

					// If there is already a '_' parameter, set its value
					cacheURL.replace( rts, "$1_=" + nonce++ ) :

					// Otherwise add one to the end
					cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
			}
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[0] ] ?
				s.accepts[ s.dataTypes[0] ] + ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend && ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		for ( i in { success: 1, error: 1, complete: 1 } ) {
			jqXHR[ i ]( s[ i ] );
		}

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}
			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = setTimeout(function() {
					jqXHR.abort("timeout");
				}, s.timeout );
			}

			try {
				state = 1;
				transport.send( requestHeaders, done );
			} catch ( e ) {
				// Propagate exception as error if not done
				if ( state < 2 ) {
					done( -1, e );
				// Simply rethrow otherwise
				} else {
					throw e;
				}
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Called once
			if ( state === 2 ) {
				return;
			}

			// State is "done" now
			state = 2;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader("Last-Modified");
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader("etag");
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {
				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger("ajaxStop");
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
});

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {
		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		return jQuery.ajax({
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		});
	};
});


jQuery._evalUrl = function( url ) {
	return jQuery.ajax({
		url: url,
		type: "GET",
		dataType: "script",
		async: false,
		global: false,
		"throws": true
	});
};


jQuery.fn.extend({
	wrapAll: function( html ) {
		var wrap;

		if ( jQuery.isFunction( html ) ) {
			return this.each(function( i ) {
				jQuery( this ).wrapAll( html.call(this, i) );
			});
		}

		if ( this[ 0 ] ) {

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map(function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			}).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each(function( i ) {
				jQuery( this ).wrapInner( html.call(this, i) );
			});
		}

		return this.each(function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		});
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each(function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call(this, i) : html );
		});
	},

	unwrap: function() {
		return this.parent().each(function() {
			if ( !jQuery.nodeName( this, "body" ) ) {
				jQuery( this ).replaceWith( this.childNodes );
			}
		}).end();
	}
});


jQuery.expr.filters.hidden = function( elem ) {
	// Support: Opera <= 12.12
	// Opera reports offsetWidths and offsetHeights less than zero on some elements
	return elem.offsetWidth <= 0 && elem.offsetHeight <= 0;
};
jQuery.expr.filters.visible = function( elem ) {
	return !jQuery.expr.filters.hidden( elem );
};




var r20 = /%20/g,
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( jQuery.isArray( obj ) ) {
		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {
				// Treat each array item as a scalar.
				add( prefix, v );

			} else {
				// Item is non-scalar (array or object), encode its numeric index.
				buildParams( prefix + "[" + ( typeof v === "object" ? i : "" ) + "]", v, traditional, add );
			}
		});

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {
		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {
		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, value ) {
			// If value is a function, invoke it and return its value
			value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
			s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
		};

	// Set traditional to true for jQuery <= 1.3.2 behavior.
	if ( traditional === undefined ) {
		traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		});

	} else {
		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" ).replace( r20, "+" );
};

jQuery.fn.extend({
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map(function() {
			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		})
		.filter(function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		})
		.map(function( i, elem ) {
			var val = jQuery( this ).val();

			return val == null ?
				null :
				jQuery.isArray( val ) ?
					jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					}) :
					{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		}).get();
	}
});


jQuery.ajaxSettings.xhr = function() {
	try {
		return new XMLHttpRequest();
	} catch( e ) {}
};

var xhrId = 0,
	xhrCallbacks = {},
	xhrSuccessStatus = {
		// file protocol always yields status code 0, assume 200
		0: 200,
		// Support: IE9
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

// Support: IE9
// Open requests must be manually aborted on unload (#5280)
// See https://support.microsoft.com/kb/2856746 for more info
if ( window.attachEvent ) {
	window.attachEvent( "onunload", function() {
		for ( var key in xhrCallbacks ) {
			xhrCallbacks[ key ]();
		}
	});
}

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport(function( options ) {
	var callback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr(),
					id = ++xhrId;

				xhr.open( options.type, options.url, options.async, options.username, options.password );

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers["X-Requested-With"] ) {
					headers["X-Requested-With"] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							delete xhrCallbacks[ id ];
							callback = xhr.onload = xhr.onerror = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {
								complete(
									// file: protocol always yields status 0; see #8605, #14207
									xhr.status,
									xhr.statusText
								);
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,
									// Support: IE9
									// Accessing binary-data responseText throws an exception
									// (#11426)
									typeof xhr.responseText === "string" ? {
										text: xhr.responseText
									} : undefined,
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				xhr.onerror = callback("error");

				// Create the abort callback
				callback = xhrCallbacks[ id ] = callback("abort");

				try {
					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {
					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
});




// Install script dataType
jQuery.ajaxSetup({
	accepts: {
		script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /(?:java|ecma)script/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
});

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
});

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {
	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery("<script>").prop({
					async: true,
					charset: s.scriptCharset,
					src: s.url
				}).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
});




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup({
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
});

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" && !( s.contentType || "" ).indexOf("application/x-www-form-urlencoded") && rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters["script json"] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always(function() {
			// Restore preexisting value
			window[ callbackName ] = overwritten;

			// Save back as free
			if ( s[ callbackName ] ) {
				// make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		});

		// Delegate to script
		return "script";
	}
});




// data: string of html
// context (optional): If specified, the fragment will be created in this context, defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}
	context = context || document;

	var parsed = rsingleTag.exec( data ),
		scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[1] ) ];
	}

	parsed = jQuery.buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


// Keep a copy of the old load method
var _load = jQuery.fn.load;

/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	if ( typeof url !== "string" && _load ) {
		return _load.apply( this, arguments );
	}

	var selector, type, response,
		self = this,
		off = url.indexOf(" ");

	if ( off >= 0 ) {
		selector = jQuery.trim( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax({
			url: url,

			// if "type" variable is undefined, then "GET" method will be used
			type: type,
			dataType: "html",
			data: params
		}).done(function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery("<div>").append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		}).complete( callback && function( jqXHR, status ) {
			self.each( callback, response || [ jqXHR.responseText, status, jqXHR ] );
		});
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [ "ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend" ], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
});




jQuery.expr.filters.animated = function( elem ) {
	return jQuery.grep(jQuery.timers, function( fn ) {
		return elem === fn.elem;
	}).length;
};




var docElem = window.document.documentElement;

/**
 * Gets a window from an element
 */
function getWindow( elem ) {
	return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
}

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf("auto") > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {
			options = options.call( elem, i, curOffset );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend({
	offset: function( options ) {
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each(function( i ) {
					jQuery.offset.setOffset( this, options, i );
				});
		}

		var docElem, win,
			elem = this[ 0 ],
			box = { top: 0, left: 0 },
			doc = elem && elem.ownerDocument;

		if ( !doc ) {
			return;
		}

		docElem = doc.documentElement;

		// Make sure it's not a disconnected DOM node
		if ( !jQuery.contains( docElem, elem ) ) {
			return box;
		}

		// Support: BlackBerry 5, iOS 3 (original iPhone)
		// If we don't have gBCR, just use 0,0 rather than error
		if ( typeof elem.getBoundingClientRect !== strundefined ) {
			box = elem.getBoundingClientRect();
		}
		win = getWindow( doc );
		return {
			top: box.top + win.pageYOffset - docElem.clientTop,
			left: box.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0}, because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {
			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {
			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
			parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	offsetParent: function() {
		return this.map(function() {
			var offsetParent = this.offsetParent || docElem;

			while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) && jQuery.css( offsetParent, "position" ) === "static" ) ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || docElem;
		});
	}
});

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {
			var win = getWindow( elem );

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : window.pageXOffset,
					top ? val : window.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length, null );
	};
});

// Support: Safari<7+, Chrome<37+
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );
				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
});


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name }, function( defaultExtra, funcName ) {
		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {
					// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
					// isn't a whole lot we can do. See pull request at this URL for discussion:
					// https://github.com/jquery/jquery/pull/764
					return elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?
					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable, null );
		};
	});
});


// The number of elements contained in the matched element set
jQuery.fn.size = function() {
	return this.length;
};

jQuery.fn.andSelf = jQuery.fn.addBack;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var
	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( typeof noGlobal === strundefined ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;

}));


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(124);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(125),
    createAssigner = __webpack_require__(138);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(9),
    isObjectLike = __webpack_require__(5);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(7);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(103),
    listCacheDelete = __webpack_require__(104),
    listCacheGet = __webpack_require__(105),
    listCacheHas = __webpack_require__(106),
    listCacheSet = __webpack_require__(107);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(14);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(109);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(4),
    stubFalse = __webpack_require__(119);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(40)(module)))

/***/ }),
/* 27 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 28 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(23),
    stackClear = __webpack_require__(126),
    stackDelete = __webpack_require__(127),
    stackGet = __webpack_require__(128),
    stackHas = __webpack_require__(129),
    stackSet = __webpack_require__(130);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(161),
    Map = __webpack_require__(37),
    Promise = __webpack_require__(162),
    Set = __webpack_require__(163),
    WeakMap = __webpack_require__(164),
    baseGetTag = __webpack_require__(9),
    toSource = __webpack_require__(58);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(113);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 *
 * @module pageMeta
 * @description This module provides data from the page's meta tags when the page is loaded.
 *
 */

/* global module */

(function(root, factory) {

    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}

}(this, function() {

    'use strict';

    var meta = document.querySelectorAll('meta');
    var metaSet = Array.prototype.slice.call(meta);
    var exports = {};

    // iterate over all the meta tags assigning them to exports.
    metaSet.forEach(function(meta, index) {

        var key = meta.getAttribute('name') || meta.getAttribute('property');

        if (key) {

            var overrideKey = 'bam-override-' + key + '=';
            var overrideIndex = window.location.href.indexOf(overrideKey);

            if (overrideIndex !== -1) {

                var overrideVal = window.location.href.substr(overrideIndex+overrideKey.length);
                var nextAmp = overrideVal.indexOf('&');

                if (nextAmp !== -1) {
                    overrideVal = overrideVal.substr(0, nextAmp);
                }

                exports[key] = overrideVal;

            } else {

                exports[key] = meta.getAttribute('content');

            }

            switch(meta.getAttribute('data-type')) {
                case 'json':
                    exports[key] = JSON.parse(exports[key]);
            }

        }

    });

    return exports;

}));


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(2),
    isKey = __webpack_require__(34),
    stringToPath = __webpack_require__(89),
    toString = __webpack_require__(31);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(2),
    isSymbol = __webpack_require__(21);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(92),
    mapCacheDelete = __webpack_require__(108),
    mapCacheGet = __webpack_require__(110),
    mapCacheHas = __webpack_require__(111),
    mapCacheSet = __webpack_require__(112);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(9),
    isObject = __webpack_require__(3);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(7),
    root = __webpack_require__(4);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(116);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(118),
    isObjectLike = __webpack_require__(5);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(120),
    baseUnary = __webpack_require__(43),
    nodeUtil = __webpack_require__(44);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 42 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 43 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(57);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(40)(module)))

/***/ }),
/* 45 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(47),
    eq = __webpack_require__(14);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(64);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(68);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(62);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(148),
    baseMatchesProperty = __webpack_require__(166),
    identity = __webpack_require__(28),
    isArray = __webpack_require__(2),
    property = __webpack_require__(170);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(160),
    stubArray = __webpack_require__(77);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_RESULT__;(function (factory) {
    var undef = 'undefined';
    var root = typeof window !== undef ? window : typeof global !== undef ? global : this;
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
            return factory(root);
        }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
})(function(globalChannel){
    var doc = document;
    if(globalChannel.MessageChannel){
        var Switchboard=MessageChannel;
    } else {
        var switchboardType="div";
        var Switchboard = function(){
            this.port1=doc.createElement(switchboardType);
        }
        Switchboard.prototype = {
            port1 : null,
            port2 : null
        };
    }
    return Switchboard;
});

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(10)))

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_RESULT__;(function (factory) {
    var undef;
    var root = typeof window !== undef ? window : typeof global !== undef ? global : this;
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
            return factory(root);
        }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
})(function(root){
    var EVENT = "Events";
    var EMPTY = "";
    var eventOpts = {
        bubbles : false,
        cancelable : false
    };

    var doc = root.document;

    // Partial Map polyfill.
    // Note: This is only designed to work with strings and functions.
    //       More complex data-structures won't create useful keys (uses .toString).
    function FakeMap(){
        this.store={};
    }
    
    FakeMap.prototype = {
        get: function (key) {
            return this.store[(key||EMPTY).toString()];
        },
        set: function (key, value) {
            this.store[(key||EMPTY).toString()] = value;  
        },
        has: function (key) {
            return ((key||EMPTY).toString()) in this.store;
        },
        delete: function (key) {
            delete this.store[(key||EMPTY).toString()];
        },
        forEach: function (cb, scope) {
            var key;
            var store = this.store;
            for (key in store) {
                cb.call(scope||this,store[key], key, this);
            }
        }
    }

    // Use Map where available, otherwise FakeMap will do.
    var ConsumerMap = root.Map || FakeMap;

    function TopicHandler (scope, consumer, autoRemove, topics, name) {
        this.scope = scope;
        this.originalConsumer = consumer;
        this.name = name;
        // If the handler is a .one handler, use handleEventOnce.
        if (autoRemove) {
            this.handleEvent = this.handleEventOnce;
            this.topics = topics;
        }
    }

    TopicHandler.prototype = {
        handleEvent: function (e) {
            return this.originalConsumer.call(this.scope, e.data,e);
        },
        handleEventOnce: function (e) {
            removeTopicListener(this.scope, this.topics, this.name, this.originalConsumer);
            return this.originalConsumer.call(this.scope, e.data,e);
        }
    }

    // Use CustomEvent constructor when available, otherwise fallback to document.createEvent
    var createEvent = Topic.createEvent = typeof CustomEvent === 'function' ? function (eventKey, customKey) {
            var evt = new CustomEvent(eventKey, eventOpts);
            evt.originalType = customKey || eventKey
            return evt;
        } : function (eventKey, customKey) {
            var evt = doc.createEvent(EVENT);
            evt.initEvent(eventKey, eventOpts.bubbles, eventOpts.cancelable);
            evt.originalType = customKey || eventKey
            return evt;
        };

    /**
     * @memberOf Topic
     */
    function Topic (name, hub) {
        this.name = name;
        this.consumers = new ConsumerMap();
        this.consumerCount = 0;
        this.hub = hub;
    } 

    /**
     * @memberOf Topic
     */
    Topic.prototype.publish = function (msg, customName) {
        var evt = createEvent(this.name, customName);
        evt.data = msg;
        this.hub.dispatchEvent(evt);
    };
    /**
     * @memberOf Topic
     */
    Topic.prototype.addConsumer = function (scope, consumer, autoRemove, topics) {
        var id=consumer;
        var hub = this.hub;
        var queue=this.consumers.get(id);
        var handler = new TopicHandler(scope, consumer, autoRemove, topics, this.name);

        if(queue){
            this.removeConsumer(scope, consumer);
        } else {
            queue = [];
        }

        queue.push(handler);
        this.consumerCount++;
        this.consumers.set(id, queue);
        hub.addEventListener(this.name, handler, false, true);
    };
        

    Topic.prototype.removeConsumer = function (scope, consumer) {
        var id=consumer;
        var cons=this.consumers.get(id);
        var name=this.name;
        var con;

        if (cons) {
            var len=cons.length;
            var i=0;
            for(; i<len; i++){
                con=cons[i];
                if (con.originalConsumer === consumer && (!scope || con.scope === scope )) {
                    this.hub.removeEventListener(name, con, false, true);
                    cons.splice(i, 1);
                    if (!cons.length) {
                       this.consumers.delete(id);
                    }
                    this.consumerCount--;
                    break;
                }
            }
        }
    };

    Topic.prototype.removeAllConsumers = function () {
        var key;
        var consumers = this.consumers;
        var name = this.name;
        var queue;
        var i;
        var len;

        consumers.forEach(removeHelper, this);
        this.consumerCount = 0;
    };

    function removeHelper (queue, key, map) {
        var i = 0;
        var len = queue.length;
        var hub = this.hub;
        var name = this.name;

        for(; i < len; i++){
            hub.removeEventListener(name, queue[i], false, true);
        }
        map.delete(key);
    }


    function publishTopic (topic, msg, customName){
        return topic && topic.publish(msg, customName);
    }
    Topic.publishTopic = publishTopic;

    function addTopicListener (scope, hub, topics, topicName, callback, autoRemove) {
        if(!callback){
            throw new Error('message-service : no listener specified for topic : ' + topicName);
            return;
        }
        var topic = topics[topicName] || (topics[topicName] = new Topic(topicName, hub));
        topic.addConsumer(scope, callback, autoRemove, topics);
    }
    Topic.addTopicListener = addTopicListener;

    function removeTopicListener (scope, topics, topicName, callback) {
        var topic = topics[topicName];
        if(topic && callback) {
            topic.removeConsumer(scope, callback);
            if(topic.consumerCount <= 0){
                delete topics[topicName];
            }
        }
    };
    Topic.removeTopicListener = removeTopicListener;

    function removeAllTopicListeners (topics, topicName) {
        var topic = topics[topicName];
        if(topic){
            topic.removeAllConsumers();
            delete topics[topicName];
        }
    }
    Topic.removeAllTopicListeners = removeAllTopicListeners;

    return Topic;
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(10)))

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(55);


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(59),
    baseEach = __webpack_require__(60),
    castFunction = __webpack_require__(63),
    isArray = __webpack_require__(2);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(33),
    toKey = __webpack_require__(15);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(10)))

/***/ }),
/* 58 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 59 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(115),
    createBaseEach = __webpack_require__(123);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(117),
    isArguments = __webpack_require__(39),
    isArray = __webpack_require__(2),
    isBuffer = __webpack_require__(26),
    isIndex = __webpack_require__(27),
    isTypedArray = __webpack_require__(41);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 62 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(28);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(7);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(47),
    eq = __webpack_require__(14);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(4);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(40)(module)))

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(48);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(4);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 69 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(132),
    getPrototype = __webpack_require__(49),
    isPrototype = __webpack_require__(45);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 71 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(150),
    isObjectLike = __webpack_require__(5);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(151),
    arraySome = __webpack_require__(154),
    cacheHas = __webpack_require__(155);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(75),
    getSymbols = __webpack_require__(51),
    keys = __webpack_require__(11);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(76),
    isArray = __webpack_require__(2);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 76 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 77 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(3);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 79 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(76),
    getPrototype = __webpack_require__(49),
    getSymbols = __webpack_require__(51),
    stubArray = __webpack_require__(77);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(147),
    baseEach = __webpack_require__(60),
    baseIteratee = __webpack_require__(50),
    baseReduce = __webpack_require__(173),
    isArray = __webpack_require__(2);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(174);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(38),
    castFunction = __webpack_require__(63),
    keysIn = __webpack_require__(17);

/**
 * Iterates over own and inherited enumerable string keyed properties of an
 * object and invokes `iteratee` for each property. The iteratee is invoked
 * with three arguments: (value, key, object). Iteratee functions may exit
 * iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forInRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forIn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
 */
function forIn(object, iteratee) {
  return object == null
    ? object
    : baseFor(object, castFunction(iteratee), keysIn);
}

module.exports = forIn;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
    if (true) {
        // AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(18),
            __webpack_require__(192),
            __webpack_require__(194)
        ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
})(this, function($, Wiretap, MediaTimer, TokenHelpers) {
    'use strict';

    /**
     * WiretapVideo - Analytics tracking for video player events.
     * @param {object}   trackingConfig A JSON object of events to track.
     * @param {function} tokenHelpers   (optional) Function helpers to replace tracking event tokens.
     * @param {object}   pageConfig     (optional) Additional static page data.
     * @constructor
     */
    function WiretapVideo(trackingConfig, tokenHelpers, pageConfig) {
        WiretapVideo.prototype.super.constructor.call(
            this,
            trackingConfig,
            tokenHelpers,
            pageConfig
        );

        this.bandwagon = this.pageConfig.bandwagon;

        if (!this.bandwagon) {
            return;
        }

        this.screens = {};
        this.PlayerEvents = this.bandwagon.getRegisteredEventsByKey(
            'PLAYER_EVENTS'
        );
        this.AdEvents = this.bandwagon.getRegisteredEventsByKey('AD_EVENTS');
        this.ApplicationEvents = this.bandwagon.getRegisteredEventsByKey(
            'APPLICATION_EVENTS'
        );

        _initListeners.call(this);

        // Remove duration tracking temporarily.
        if (this.trackingConfig.intervals) {
            this.mediaTimer = new MediaTimer(this);
        }
    }

    // Inherit from Wiretap
    WiretapVideo.prototype = Object.create(Wiretap);
    WiretapVideo.prototype.constructor = WiretapVideo;
    WiretapVideo.prototype.super = Wiretap.prototype;

    /**
     * Track an event from the player's dispatcher.
     * @param  {object} proxyData Tracking config properties, namely: trackObj.
     * @param  {object} eventData Data passed from the dispatchd event.
     * @param  {object} e         The player event.
     */
    WiretapVideo.prototype.trackEventHandler = function(
        proxyData,
        eventData,
        e
    ) {
        var trackObj;

        if (!proxyData.trackObj) {
            return false;
        }

        // Get the right props from the single tracking_event call, based on impression key.
        if (
            e.type === 'trackingEvent' &&
            eventData.data &&
            eventData.data.impressionKey
        ) {
            var subEvents = proxyData.trackObj.wire.events;

            // Find the event w/ the fired impressionKey.
            for (var s in subEvents) {
                if (!subEvents.hasOwnProperty(s) || !subEvents[s].wire) {
                    continue;
                }
                if (
                    subEvents[s].wire.impressionKey ===
                    eventData.data.impressionKey
                ) {
                    trackObj = subEvents[s];
                    break;
                } else {
                    s++;
                }
            }

            if (!trackObj) {
                return false;
            }
        } else {
            trackObj = proxyData.trackObj;
        }

        var adobeObj = this.setTrackingProps(
            $.extend(true, {}, trackObj),
            eventData
        );

        if (adobeObj) {
            this.prototype.track(adobeObj);
        }
    };

    /**
     * Set the variables inside the tracking event object.
     * Should be overridden by the custom section implementations.
     * @param  {object} trackObj  Config properties.
     * @param  {object} eventData The player event data.
     */
    WiretapVideo.prototype.setTrackingProps = function(trackObj, eventData) {
        var _this = this;
        var screenData = {};

        screenData.player = eventData ? eventData.player : {};
        screenData.config = screenData.player.config || {};
        screenData.clip = screenData.player.clip || {};
        screenData.meta = screenData.clip.metaData || {};
        screenData.dynamicVars = {};

        if (screenData.meta.game_pk) {
            screenData.dynamicVars = this.getScreenDataForContentId(
                String(screenData.meta.game_pk)
            );
        } else if (screenData.clip.content_id) {
            screenData.dynamicVars = this.getScreenDataForContentId(
                String(screenData.clip.content_id)
            );
        }

        // Loop each property in the tracking object.
        $.each(trackObj, function(prop, value) {
            value = value.toString();

            // Parse @KEY@
            if (value.indexOf('@') !== -1) {
                trackObj[prop] = replaceTokens.call(_this, value, screenData);
            }

            // Remove any bad props.
            if (trackObj[prop] == 'undefined' || trackObj[prop] == null) {
                delete trackObj[prop];
            }
        });

        return trackObj;
    };

    /**
     * Set data for a screen.
     * @param data The screen's data, including the contentId.
     */
    WiretapVideo.prototype.setScreenDataForContentId = function(data) {
        if (data && data.contentId) {
            var id = String(data.contentId);

            this.screens[id] = data;
        }
    };

    /**
     * Look up the screen data in a local cache based on contentId.
     * @param   contentId {string} The current contentId
     * @returns           {{}}
     */
    WiretapVideo.prototype.getScreenDataForContentId = function(contentId) {
        var screenData = {};

        if (contentId) {
            var id = String(contentId);

            if (this.screens[id]) {
                screenData = this.screens[id];
            }
        }

        return screenData;
    };

    // ==================
    // Private Functions
    // ==================

    /**
     * Replace each token variable within a prop value.
     * @param str
     * @param screenData
     */
    function replaceTokens(str, screenData) {
        var matches = str.match(/@\w+@/g);
        var fnKey;

        // Call util function with the key.
        // Lookup the function to use from tokenHelpers.
        matches.forEach(
            function(match) {
                fnKey = match.substr(1, match.length - 2);
                str = str.replace(
                    match,
                    $.proxy(this.tokenHelpers[fnKey], this, screenData)
                );
            }.bind(this)
        );

        return str;
    }

    /**
     * Initialize player event listeners for automated tracking.
     */
    function _initListeners() {
        var _this = this;
        var dispatcher;
        var eventHandler;

        $.each(_this.trackingConfig.containers, function(bandwagonKey, events) {
            dispatcher = _this.bandwagon.getInstanceByKey(bandwagonKey);

            if (!dispatcher) {
                return true;
            }

            for (var e in events) {
                var trackObj = events[e];
                if (
                    !trackObj.wire ||
                    !(
                        _this.PlayerEvents[trackObj.wire.pEventKey] ||
                        _this.AdEvents[trackObj.wire.pEventKey] ||
                        _this.ApplicationEvents[trackObj.wire.pEventKey]
                    )
                ) {
                    continue;
                }

                // TRACKING_EVENT subEvents
                if (trackObj.wire.events) {
                    // Add defaults to all event sub-tracking objects.
                    var subEvents = trackObj.wire.events;

                    // Extend the Tracking_Event controls
                    for (var s in subEvents) {
                        if (
                            !subEvents.hasOwnProperty(s) ||
                            !subEvents[s].wire
                        ) {
                            continue;
                        }
                        if (subEvents[s].wire.defaults) {
                            $.extend(
                                subEvents[s],
                                _this.trackingConfig.defaults[
                                    subEvents[s].wire.defaults
                                ]
                            );
                        }
                    }

                    trackObj.wire.events = subEvents;
                } else {
                    if (trackObj.wire.defaults) {
                        $.extend(
                            trackObj,
                            _this.trackingConfig.defaults[
                                trackObj.wire.defaults
                            ]
                        );
                    }
                }

                eventHandler = $.proxy(_this.trackEventHandler, _this, {
                    trackObj: trackObj
                });

                if (trackObj.wire.eventsModel === 'AdEvents') {
                    dispatcher.on(
                        _this.AdEvents[trackObj.wire.pEventKey],
                        eventHandler
                    );
                } else if (trackObj.wire.eventsModel === 'ApplicationEvents') {
                    dispatcher.on(
                        _this.ApplicationEvents[trackObj.wire.pEventKey],
                        eventHandler
                    );
                } else {
                    // Default is PlayerEvents
                    dispatcher.on(
                        _this.PlayerEvents[trackObj.wire.pEventKey],
                        eventHandler
                    );
                }
            } // End forEvents.
        });
    }

    //return instance || new WiretapVideo;
    return WiretapVideo;
});


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function ( root, factory ) {
    if ( true ) {
        // AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(18)
        ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}

})( this, function ( $ ) {
    /**
     * Helper functions for replacing track prop tokens.
     */
    var MLBTokenHelpers = {
        'SITE_NAME': function ( screenData ) {
            return this.pageConfig.teamDisplay || 'Major League Baseball';
        },
        'AD_BLOCK_CONTEXT_ERROR': function ( screenData ) {
            //s.prop14 = Major League Baseball: Video Tray: AdBlock: Playback Error - Disable Ad Block
            var teamCode = this.pageConfig.teamAbbrev || 'MLB';

            var playerContext = teamCode + ": " + this.pageConfig.playerContext;
            if ( !playerContext ) {
                playerContext = teamCode + ": Video Playback Page";
            }

            playerContext = playerContext.replace(/\+/g, '%20');
            playerContext = decodeURIComponent(playerContext);

            return playerContext + ": AdBlock On";

        },
        // MEDIA.
        'MEDIA_SPONSOR': function ( screenData ) {
            return 'MLB';
        },
        'MEDIA_TOPIC_NAME': function ( screenData ) {
            return this.pageConfig.topicName;
        },
        'MEDIA_SYSTEM_AUTO_PLAY': function ( screenData ) {
            return this.pageConfig.systemAutoPlay;
        },
        'MEDIA_EMBED_HOST': function ( screenData ) {
            return (this.embedParent && this.embedParent.hostname) ? this.embedParent.hostname : getEmbedParent.call( this, 'hostname' );
        },

        'MEDIA_STREAM_TITLE': function ( screenData ) {
            var streamTitle = "";

            if ( screenData.meta && Object.keys( screenData.meta ).length ) { // Highlights|VPP|Embed: seoTitle.
                streamTitle = screenData.meta.seoTitle || screenData.meta.title || screenData.meta.blurb || "";
            } else if ( screenData.clip && Object.keys( screenData.clip ).length ) {
                streamTitle = screenData.clip.seoTitle || screenData.clip.title || screenData.clip.blurb || "";
            }

            if ( streamTitle == "" && screenData.dynamicVars.title ) {
                streamTitle = screenData.dynamicVars.title;
            }

            return streamTitle;
        },
        'MEDIA_STREAM_ID': function ( screenData ) {
            var streamId = null;

            if ( screenData.player.playerStateHelper ) {
                streamId = screenData.player.playerStateHelper._state.clip.content_id + '|' + screenData.player.playerStateHelper._state.clip.metaData.currentPlaybackScenario;
            } else if ( screenData.clip && screenData.meta ) {
                streamId = screenData.clip.content_id + '|' + screenData.meta.currentPlaybackScenario;
            }

            return streamId;
        },
        'MEDIA_PLAYER_CONTEXT': function ( screenData ) {
            var teamCode = this.pageConfig.teamAbbrev || 'MLB';

            var playerContext = this.pageConfig.playerContext;
            if ( !playerContext ) {
                playerContext = "Video Playback Page";
            } else if ( typeof playerContext === 'string' ) {
                if ( playerContext.indexOf('_articles') > -1 ) {
                    playerContext = "Embedded Article Player";
                } else if (playerContext.indexOf("_mixed_feed") > -1) {
                    playerContext = teamCode + " Mixed Panel Player";
                } else if (playerContext.indexOf("_video_tray") > -1) {
                    playerContext = teamCode + " Video Tray";
                }
            }

            playerContext = playerContext.replace(/\+/g, '%20');
            playerContext = decodeURIComponent(playerContext);

            return playerContext || null;
        },
        'MEDIA_PlAYER_LOCATION' : function ( screenData ) {
            var teamCode = this.pageConfig.teamAbbrev || 'MLB';

            var playerLocation = this.pageConfig.playerLocation || this.pageConfig.playerContext;
            if ( !playerLocation ) {
                playerLocation = "Video Embed Player";
            }

            playerLocation = playerLocation.replace(/\+/g, '%20');
            playerLocation = decodeURIComponent(playerLocation);

            return playerLocation || null;
        },
        'MEDIA_INDEX_NAME': function ( screenData ) {
            // TODO.
            //playerFlavor   : _config.topicName,
            //videoIndex     : clip.metaData.indexName

            var keywords = screenData.meta.keywords || {};

            for ( var keyword in keywords ) {
                if ( keywords[keyword] && keywords[keyword].type == 'mlbtax' ) {
                    return keywords[keyword].displayName;
                }
            }

            return null;
        },
        'CURRENT_TIME_STAMP': function() {
            //date format is taken from /site-core/AppMeasurement-mlb.js, for prop35
            var d = new Date();
            return (d.getUTCMonth() + 1) + '/' + d.getUTCDate() + '/' + d.getUTCFullYear() + ' ' + (d.getUTCHours() - 4) + ':' + d.getUTCMinutes() + ':' + d.getUTCSeconds();
        },
        'MEDIA_EMBED_HOST': function ( screenData ) {
            return (this.embedParent && this.embedParent.hostname) ? this.embedParent.hostname : getEmbedParent.call( this, 'hostname' );
        },
        'GAMEDAY_GAME_ID': function ( screenData ) {
            return screenData.meta.game_id ? screenData.meta.game_id : null;
        },
        'GAMEDAY_GAME_PK': function ( screenData ) {
            return screenData.meta.game_pk ? screenData.meta.game_pk : null;
        },
        'MEDIA_PLAYER_VERSION': function ( screenData ) {
            var versionName;
            var playerType = screenData.player.toString();

            switch ( playerType ) {
                case 'MultiViewFlashPlayer':
                case 'FlashPlayer':
                    versionName = 'flash';
                    break;
                case 'HTML5Player':
                    versionName = 'html5';
                    break;
                case 'DashPlayer':
                    versionName = 'html5:DashPlayer';
                    break;
                case 'PrimetimePlayer':
                    versionName = 'html5:PrimetimePlayer';
                    break;
                default:
                    versionName = 'Player version not found';
            }

            return versionName;
        }
    };


    /**
     * Get the embed's parent window information.
     * @param returnValue
     * @returns {*}
     */
    function getEmbedParent( returnValue ) {
        var host;
        var locale = 'nil';

        if ( window === window.parent && window.parent.location ) {
            host = window.parent.location;
        } else {
            host      = document.createElement( 'a' );
            host.href = document.referrer;
        }

        this.embedParent = {
            hostname: host.hostname,
            locale:   locale
        };

        if ( returnValue ) {
            return this.embedParent[ returnValue ];
        } else {
            return this.embedParent;
        }
    }


    return MLBTokenHelpers;
} );

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(196),
    findIndex = __webpack_require__(197);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(13);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 88 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(90);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(91);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(35);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(93),
    ListCache = __webpack_require__(23),
    Map = __webpack_require__(37);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(94),
    hashDelete = __webpack_require__(99),
    hashGet = __webpack_require__(100),
    hashHas = __webpack_require__(101),
    hashSet = __webpack_require__(102);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(22);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(36),
    isMasked = __webpack_require__(96),
    isObject = __webpack_require__(3),
    toSource = __webpack_require__(58);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(97);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(4);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 98 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 99 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(22);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(22);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(22);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 103 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(24);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(24);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(24);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(24);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(25);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 109 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(25);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(25);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(25);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(13),
    arrayMap = __webpack_require__(114),
    isArray = __webpack_require__(2),
    isSymbol = __webpack_require__(21);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 114 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(38),
    keys = __webpack_require__(11);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 116 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 117 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(9),
    isObjectLike = __webpack_require__(5);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 119 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(9),
    isLength = __webpack_require__(42),
    isObjectLike = __webpack_require__(5);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(45),
    nativeKeys = __webpack_require__(122);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(62);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(12);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(46),
    castPath = __webpack_require__(33),
    isIndex = __webpack_require__(27),
    isObject = __webpack_require__(3),
    toKey = __webpack_require__(15);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(29),
    assignMergeValue = __webpack_require__(65),
    baseFor = __webpack_require__(38),
    baseMergeDeep = __webpack_require__(131),
    isObject = __webpack_require__(3),
    keysIn = __webpack_require__(17),
    safeGet = __webpack_require__(71);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(23);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 127 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 128 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 129 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(23),
    Map = __webpack_require__(37),
    MapCache = __webpack_require__(35);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(65),
    cloneBuffer = __webpack_require__(66),
    cloneTypedArray = __webpack_require__(67),
    copyArray = __webpack_require__(69),
    initCloneObject = __webpack_require__(70),
    isArguments = __webpack_require__(39),
    isArray = __webpack_require__(2),
    isArrayLikeObject = __webpack_require__(133),
    isBuffer = __webpack_require__(26),
    isFunction = __webpack_require__(36),
    isObject = __webpack_require__(3),
    isPlainObject = __webpack_require__(134),
    isTypedArray = __webpack_require__(41),
    safeGet = __webpack_require__(71),
    toPlainObject = __webpack_require__(135);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(3);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(12),
    isObjectLike = __webpack_require__(5);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(9),
    getPrototype = __webpack_require__(49),
    isObjectLike = __webpack_require__(5);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(16),
    keysIn = __webpack_require__(17);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(3),
    isPrototype = __webpack_require__(45),
    nativeKeysIn = __webpack_require__(137);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 137 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(139),
    isIterateeCall = __webpack_require__(146);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(28),
    overRest = __webpack_require__(140),
    setToString = __webpack_require__(142);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(141);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 141 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(143),
    shortOut = __webpack_require__(145);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(144),
    defineProperty = __webpack_require__(64),
    identity = __webpack_require__(28);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 144 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 145 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(14),
    isArrayLike = __webpack_require__(12),
    isIndex = __webpack_require__(27),
    isObject = __webpack_require__(3);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 147 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(149),
    getMatchData = __webpack_require__(165),
    matchesStrictComparable = __webpack_require__(79);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(29),
    baseIsEqual = __webpack_require__(72);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(29),
    equalArrays = __webpack_require__(73),
    equalByTag = __webpack_require__(156),
    equalObjects = __webpack_require__(159),
    getTag = __webpack_require__(30),
    isArray = __webpack_require__(2),
    isBuffer = __webpack_require__(26),
    isTypedArray = __webpack_require__(41);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(35),
    setCacheAdd = __webpack_require__(152),
    setCacheHas = __webpack_require__(153);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 152 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 153 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 154 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 155 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(13),
    Uint8Array = __webpack_require__(68),
    eq = __webpack_require__(14),
    equalArrays = __webpack_require__(73),
    mapToArray = __webpack_require__(157),
    setToArray = __webpack_require__(158);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 157 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 158 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(74);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 160 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(7),
    root = __webpack_require__(4);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(7),
    root = __webpack_require__(4);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(7),
    root = __webpack_require__(4);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(7),
    root = __webpack_require__(4);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(78),
    keys = __webpack_require__(11);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(72),
    get = __webpack_require__(0),
    hasIn = __webpack_require__(167),
    isKey = __webpack_require__(34),
    isStrictComparable = __webpack_require__(78),
    matchesStrictComparable = __webpack_require__(79),
    toKey = __webpack_require__(15);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(168),
    hasPath = __webpack_require__(169);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 168 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(33),
    isArguments = __webpack_require__(39),
    isArray = __webpack_require__(2),
    isIndex = __webpack_require__(27),
    isLength = __webpack_require__(42),
    toKey = __webpack_require__(15);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(171),
    basePropertyDeep = __webpack_require__(172),
    isKey = __webpack_require__(34),
    toKey = __webpack_require__(15);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 171 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(56);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 173 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(29),
    arrayEach = __webpack_require__(59),
    assignValue = __webpack_require__(46),
    baseAssign = __webpack_require__(175),
    baseAssignIn = __webpack_require__(176),
    cloneBuffer = __webpack_require__(66),
    copyArray = __webpack_require__(69),
    copySymbols = __webpack_require__(177),
    copySymbolsIn = __webpack_require__(178),
    getAllKeys = __webpack_require__(74),
    getAllKeysIn = __webpack_require__(179),
    getTag = __webpack_require__(30),
    initCloneArray = __webpack_require__(180),
    initCloneByTag = __webpack_require__(181),
    initCloneObject = __webpack_require__(70),
    isArray = __webpack_require__(2),
    isBuffer = __webpack_require__(26),
    isMap = __webpack_require__(185),
    isObject = __webpack_require__(3),
    isSet = __webpack_require__(187),
    keys = __webpack_require__(11);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(16),
    keys = __webpack_require__(11);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(16),
    keysIn = __webpack_require__(17);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(16),
    getSymbols = __webpack_require__(51);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(16),
    getSymbolsIn = __webpack_require__(80);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(75),
    getSymbolsIn = __webpack_require__(80),
    keysIn = __webpack_require__(17);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 180 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(48),
    cloneDataView = __webpack_require__(182),
    cloneRegExp = __webpack_require__(183),
    cloneSymbol = __webpack_require__(184),
    cloneTypedArray = __webpack_require__(67);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(48);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 183 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(13);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(186),
    baseUnary = __webpack_require__(43),
    nodeUtil = __webpack_require__(44);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(30),
    isObjectLike = __webpack_require__(5);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(188),
    baseUnary = __webpack_require__(43),
    nodeUtil = __webpack_require__(44);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(30),
    isObjectLike = __webpack_require__(5);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_RESULT__;(function (factory) {
    var undef = 'undefined';
    var root = typeof window !== undef ? window : typeof global !== undef ? global : this;
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module ) {
            return factory(
                root, 
                __webpack_require__(52),
                __webpack_require__(53),
                __webpack_require__(190)
            );
        }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
})(function(globalChannel, Switchboard, Topic, ChannelBroker){
    var ALL_TOPICS = '*';

    function getTargetContext (target) {
        var targetContext;
        if (target && target.postMessage) {
            targetContext = target;
        } else if (target instanceof Node) {
            targetContext = target.window || target.contentWindow;
        }
        return targetContext;

    }
    function MessageService (bindTo) {
        var messageService = this;
        var rebind = bindTo || this;

        if(bindTo){
            var method;
            for( method in _proto_){
                bindTo[method]=this[method].bind(messageService);
            }
        }

        var switchboard = this.switchboard = new Switchboard();
        var hub = this.hub = switchboard.port1;
        var dock = this.dock = switchboard.port2;
        var hub = this.hub;
        var topics = this.topics = {};
        var specialRepeater = new Switchboard().port1;

        var allTopicsRepeater = this.allTopicsRepeater = new Topic(ALL_TOPICS, specialRepeater);
  
        function allTopicsListener(msg, evt){
            Topic.publishTopic(topics[ALL_TOPICS], msg, evt.originalType);
        }

        allTopicsRepeater.addConsumer(this, allTopicsListener, false, {});

        this.channelBroker = new ChannelBroker(this.dock, this);

        // Adding/removing listeners requires special scoping
        // Best to just apply these to the instance to support binding to 
        // custom objects
        rebind.on = rebind.addListener =  function (topicName, callback ) {
            Topic.addTopicListener(this, hub, topics, topicName, callback, false);
        };
            
        rebind.off = rebind.removeListener = function (topicName, callback) {
            Topic.removeTopicListener(this, topics, topicName, callback);
        };

        rebind.one = rebind.once = function(topicName, callback) {
            Topic.addTopicListener(this, hub, topics, topicName, callback, true);
        };
    }

    var _proto_ = MessageService.prototype = {

        publish: function (topicName, msg, localOnly) {
            var result = Topic.publishTopic(this.topics[topicName], msg);

            Topic.publishTopic(this.allTopicsRepeater, msg, topicName);

            if(localOnly!==true){
                this.channelBroker.publish(topicName, msg)
            }
            return result;
        },

        publishChannel: function (topicName, msg) {
            return this.channelBroker.publish(topicName, msg);
        },
            
        removeAllListeners: function (topicName) {
            var topic;
            var topics = this.topics;
            if (topicName) {
                Topic.removeAllTopicListeners(topics, topicName);
            } else {
                for (topic in topics) {
                    Topic.removeAllTopicListeners(topics, topic);
                }
            }
        },

        getTopics: function (topicName) {
            return this.topics;
        },

        hasListeners: function (topicName) {
            var topic = this.topics[topicName];
 
            if (topicName && topic) {
                return !!topic.consumerCount;
            }
            return false;
        },

        openChannel: function (target, _id, initData) {
            var targetContext = getTargetContext(target);
            var id = _id || "global";

            if (targetContext && targetContext.postMessage) {
                return this.channelBroker.connect(targetContext, id, initData);
            }
            return false;
        },

        closeChannel: function (target, _id) {
            var targetContext = getTargetContext(target);
            var id = _id || "global";

            if (targetContext && targetContext.postMessage) {
                this.channelBroker.disconnect(targetContext, id);
                return true;
            }
            return false;
        }
    };

    /**
     * Generate the MessageService api and bind it to object obj.
     * Limit the scope of operation to the DOM element target. (Defaults to window)
     * @param  {mixed}  [obj]   Any object decendent of Object to apply
     *                          the MessageService api.
     * @return {mixed}          obj is returned after binding operation is complete
     */
    var create = function (obj) {

        var messageService = new MessageService(obj);
        messageService.sharedMessageService = sharedMessageService;
        return obj || messageService;
    };
    /**
     * Generate the MessageService api for "global" operations
     * @see  bind
     */
    var sharedMessageService = create();

    sharedMessageService.sharedMessageService = sharedMessageService;

    sharedMessageService.bind = function (obj) {
        if(!obj){
            throw new Error("Binding object not specified");
            return;
        }
        return create(obj);
    };
    sharedMessageService.create = create;
    return sharedMessageService;
});

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(10)))

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_RESULT__;(function (factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module ) {
            return factory(
                __webpack_require__(191),
                __webpack_require__(52),
                __webpack_require__(53)
            );
        }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
})(function (Channel, Switchboard, Topic) {
    var undef = 'undefined';
    var globalChannel = typeof window !== undef ? window : typeof global !== undef ? global : this;

    var CHANNELMESSAGE_REPEATER = Channel.events.CHANNELMESSAGE_REPEATER;

    function disconnectHelper (channel) {
        if(channel.target && channel.target === this){
            channel.disconnect();
            return true;
        }
        return false;
    }

    function ChannelBroker(dock, messageService){
        this.hub = dock;
        this.topics = messageService.topics;
        this.messageService = messageService;
        if(dock === null){
            this.isMessageChannel = false;
            this.hub = new Switchboard().port1
        }
        this.channelTopics = {};
        this.channels = {};
    }

    ChannelBroker.prototype = {
        isMessageChannel : true,
        
        publish : function(topicName, msg){
            var repeatEvent = Topic.createEvent(CHANNELMESSAGE_REPEATER);
            repeatEvent.data = {topic : topicName, msg : msg};
            this.hub.dispatchEvent(repeatEvent);
        },

        connect : function(target, handshake, data){
            var channels = this.channels;
            var openedChannels = channels[handshake] || (channels[handshake]=[]);
            var channel = new Channel(target, handshake, data, this);

            if(channel.connect()) {
                openedChannels.push(channel);
                return channel;
            }
            return false;
        },

        disconnect : function(target, handshake){
            var channels = this.channels;
            var openedChannels = channels[handshake];

            if(openedChannels && openedChannels.length){
                openChannels.some(disconnectHelper,target);
            }
        }
    }
    return ChannelBroker;
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(10)))

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_RESULT__;(function (factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module ) {
            return factory(
                __webpack_require__(52),
                __webpack_require__(53)
            );
        }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
})(function(Switchboard, Topic){
    var undef = 'undefined';
    var globalChannel = typeof window !== undef ? window : typeof global !== undef ? global : this;

    var MESSAGE = "message";
    var MSG = "msg";
    var CHANNELMESSAGE = "MessageService::channel";
    var CHANNELMESSAGE_REPEATER = "MessageService::channel::repeater";
    var CHANNELMESSAGE_READY = "channel::ready";
    var CHANNELMESSAGE_ERROR = "channel::error";
    var CHANNELMESSAGE_COMPLETE = "MessageService::channel::complete";
    var CHANNELMESSAGE_DISCONNECT = "MessageService::channel::disconnect";
    var CHANNELMESSAGE_CLOSED = "channel::closed";
    var ORIGIN = "*";

    function Channel (target, handshake, initData, broker) {
        var that = this;
        this.target = target;
        this.handshake = handshake;
        this.initData = initData;
        this.initDataFromTarget = null;
        this.hub = broker.hub;
        this.messageService = broker.messageService;
        this.topics = broker.topics;
        this.channelTopics = broker.channelTopics;
        this.status = 'pending';
        this.isMessageChannel = broker.isMessageChannel;
        this.handshakeMessageCallback = function (e) {
            that.handshakeMessage(e);
        }

        this.channelRepeaterCallback = function (e) {
            that.channelRepeater(e);
        }

        this.channelConfirmationCallback = function (e) {
            that.channelConfirmation(e);
        }
    }

    Channel.events = {
        CHANNELMESSAGE: CHANNELMESSAGE,
        CHANNELMESSAGE_REPEATER: CHANNELMESSAGE_REPEATER,
        CHANNELMESSAGE_READY: CHANNELMESSAGE_READY,
        CHANNELMESSAGE_ERROR: CHANNELMESSAGE_ERROR,
        CHANNELMESSAGE_COMPLETE: CHANNELMESSAGE_COMPLETE,
        CHANNELMESSAGE_DISCONNECT: CHANNELMESSAGE_DISCONNECT,
        CHANNELMESSAGE_CLOSED: CHANNELMESSAGE_CLOSED
    };

    Channel.prototype = {

        publish: function (topic, message) {
            this.repeatToChannel({ topic: topic, msg: message});
        },

        acceptInvitation: function (port, initDataFromTarget){
            if(this.target && this.handshake && this.isMessageChannel){
                var topics = this.topics;
                var sharePort;
                var target = this.target;

                if(!port){
                    var channel = new Switchboard();
                    port = channel.port1;
                    sharePort = channel.port2;
                    this.initDataFromTarget = initDataFromTarget;
                }
                port.start();
                this.port = port;

                port.addEventListener(MESSAGE, this.channelRepeaterCallback, false);
                Topic.addTopicListener(this, this.hub, this.channelTopics, CHANNELMESSAGE_REPEATER, this.repeatToChannel, false);

                // Send port to open channel, and your initData
                if(sharePort){
                    port.addEventListener(MESSAGE, this.channelConfirmationCallback, false);
                    target.postMessage({ type : CHANNELMESSAGE, handshake : this.handshake, initData : this.initData }, ORIGIN, [sharePort]);
                } else {
                    this.status = 'ready';
                    globalChannel.removeEventListener(MESSAGE,this.handshakeMessage,false);
                    port.postMessage({ type : CHANNELMESSAGE_COMPLETE, handshake : this.handshake });
                    this.messageService.publish(CHANNELMESSAGE_READY, { id : this.handshake, data : initDataFromTarget }, true);
                }
            }
        },

        handshakeMessage: function (e) {
            var trustedMessage = this.handshakeListener(this.target, e);
            if(trustedMessage){
                // Channel handshake moving forward
                if (trustedMessage === CHANNELMESSAGE) {
                    this.acceptInvitation(e.ports && e.ports[0], e.data && e.data.initData);
                } else if (trustedMessage === CHANNELMESSAGE_REPEATER){
                    var data = e.data;
                    // Handshake not complete, but we've got an incoming authorized message
                    if(data && data.topic && data.hasOwnProperty(MSG)){
                        Topic.publishTopic(this.topics[data.topic], data.msg)
                    }
                }
            }
        },

        channelRepeater: function (e) {
            var data = e.data;
            if (data && data.topic && data.hasOwnProperty(MSG)) {
                Topic.publishTopic(this.topics[data.topic], data.msg);
            } else {
                if (this.handshakeListener(this.port, e) === CHANNELMESSAGE_DISCONNECT) {
                    this.disconnect();
                }
            }
        },

        repeatToChannel: function (data, evt) {
            var target = this.target;
            var port = this.port;
            // Target has disappeared or closed - shut it down
            if(!target || target.closed===true){
                this.disconnect();
                return;
            }
            if(data && data.topic && data.hasOwnProperty(MSG)){
                port.postMessage({topic : data.topic, msg: data.msg});
            }
        },

        channelConfirmation: function (e) {
            if(this.handshakeListener(this.port, e) === CHANNELMESSAGE_COMPLETE){
                globalChannel.removeEventListener(MESSAGE,this.handshakeMessageCallback,false);
                this.port.removeEventListener(MESSAGE,this.channelConfirmationCallback,false);
                this.status = 'ready';
                this.messageService.publish(CHANNELMESSAGE_READY, { id : this.handshake, data : this.initDataFromTarget }, true);
            }
        },

        connect: function () {
            var targetable = true;
            var channelErr;
            // If we're connecting two instance in the same context
            // we don't want to bother with postMessage.
            if(this.target === globalChannel){
                
            }

            globalChannel.addEventListener(MESSAGE, this.handshakeMessageCallback, false);
            try {
                this.target.postMessage({ type : CHANNELMESSAGE, handshake : this.handshake, initData : this.initData },ORIGIN);
            } catch (channelErr) {
                targetable = false;
                channelError = channelErr;
            } finally {
                if(!targetable){
                    this.disconnect();
                    // Let the service instance know there was an error, and keep the message local
                    this.messageService.publish(CHANNELMESSAGE_ERROR, {
                        id : this.handshake,
                        data : channelError
                    }, true);
                }
            }
            return targetable;
        },

        disconnect: function () {
            var port = this.port;

            globalChannel.removeEventListener(MESSAGE, this.handshakeMessageCallback, false);                
            Topic.removeTopicListener(this, this.channelTopics, CHANNELMESSAGE_REPEATER, this.repeatToChannel);

            this.status = 'closed';

            if (port) {
                port.removeEventListener(MESSAGE, this.channelRepeaterCallback, false);
                port.postMessage({ type : CHANNELMESSAGE_DISCONNECT, handshake : this.handshake });
                port.close();
            }
            
            this.messageService.publish(CHANNELMESSAGE_CLOSED, {
                id: this.handshake,
                data: this
            }, true);
        },

        handshakeListener: function (expectedTarget, message) {
            var data = message.data;
            var handshake = this.handshake;

            if(data && ( 
                data.type === CHANNELMESSAGE || 
                data.type === CHANNELMESSAGE_REPEATER || 
                data.type === CHANNELMESSAGE_COMPLETE ||
                data.type === CHANNELMESSAGE_DISCONNECT
                ) && handshake===data.handshake && expectedTarget === (message.source || message.srcElement)){
                return data.type;
            }
            return false;
        }
    }
    return Channel;
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(10)))

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
    if (true) {
        // AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(18), __webpack_require__(193)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
})(this, function($, TokenHelpers) {
    'use strict';

    /**
     * Wiretap - Base class for Analytics tracking.
     * @param {object}   trackingConfig A JSON object of events to track.
     * @param {function} tokenHelpers   (optional) Function helpers to replace tracking event tokens.
     * @param {object}   pageConfig     (optional) Additional static page data.
     * @constructor
     */
    function Wiretap(trackingConfig, tokenHelpers, pageConfig) {
        this.pageContextData =
            (window.adobeAnalytics && window.adobeAnalytics.contextData) || {};
        this.trackingConfig =
            (typeof trackingConfig === 'string'
                ? JSON.parse(trackingConfig)
                : trackingConfig) || {};
        this.tokenHelpers = TokenHelpers;
        this.pageConfig = pageConfig || {};

        if (tokenHelpers) {
            if (typeof tokenHelpers === 'function') {
                this.setTrackingProps = tokenHelpers; // TODO: < 2.0.0 implementation.
            } else if (typeof tokenHelpers === 'object') {
                $.extend(this.tokenHelpers, tokenHelpers); // ~2.0.0 implementation.
            }
        }
    }

    Wiretap.prototype = {
        constructor: Wiretap,

        /**
         * Remove non-tracking properties from the tracking object,
         * and Fire the tracking call
         * @param {object} trackObj Params for the track-event call.
         */
        track: function(trackObj) {
            delete trackObj.wire;

            //TODO - missing the meta partial that loads the Adobe Async call.
            if (typeof window.trackAsync === 'function') {
                window.trackAsync(trackObj);
            }
        },

        /**
         * Function to be called when an event should trigger a tracking request.
         * @param {object} data The tracking object.
         */
        trackEventHandler: function(data) {
            this.track(data);
        },

        /**
         * Set the variables inside the tracking event object.
         * Should be overridden by the custom section implementations.
         * @param  {object} trackObj Config properties.
         */
        setTrackingProps: function(trackObj) {
            return trackObj;
        }
    };

    return Wiretap;
});


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function ( root, factory ) {
    if ( true ) {
        // AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(18)
        ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}

})( this, function ( $ ) {

    /**
     * Helper functions for replacing track prop tokens.
     */
    var TokenHelpers = {
        // GENERIC.

        'SITE_TRAFFIC': function ( screenData ) {
            return this.pageConfig.siteTraffic || '[Site traffic - unavailable]';
        },
        'SITE_LANG_LOCALE': function ( screenData ) {
            return this.pageConfig.langLocale || '[Lang locale - unavailable]';
        },
        'TEAM_ABBREV': function ( screenData ) {
            return this.pageConfig.teamAbbrev || '[Team - unavailable]';
        },

        // GAMEDAY.

        'GAMEDAY_GAME_ID': function ( screenData ) {
            return undefined;
        },
        'GAMEDAY_GAME_PK': function ( screenData ) {
            return ( ( screenData.dynamicVars && screenData.dynamicVars.game ) ? screenData.dynamicVars.game.gamePk : screenData.meta.game_pk ) || 'none';
        },

        // MEDIA.

        'MEDIA_IPID': function ( screenData ) {
            // TODO - This is wrong, should be 'ipid' not 'content_id'. Update analytics.html
            //return window.adobeAnalytics.contextData['media.ipid'];
            return screenData.player.clip.content_id;
        },
        'MEDIA_PLAYER_FORMAT': function ( screenData ) {
            return screenData.player.toString();
        },
        'MEDIA_PLAYER_VERSION': function ( screenData ) {
            var versionName;
            var playerType = screenData.player.toString();

            switch ( playerType ) {
                case 'MultiViewFlashPlayer':
                case 'FlashPlayer':
                    versionName = screenData.config.flash ? ( screenData.config.flash.name + '_' + screenData.config.flash.release ) : 'fvp';
                    break;
                case 'HTML5Player':
                    versionName = 'HTML5';
                    break;
                case 'DashPlayer':
                    versionName = 'HTML5:DashPlayer';
                    break;
                case 'PrimetimePlayer':
                    versionName = 'HTML5:PrimetimePlayer';
                    break;
                default:
                    versionName = 'Player version not found';
            }

            return versionName;
        },
        'MEDIA_PLAYER_CONTEXT': function ( screenData ) {
            var playerContext = this.pageConfig.playerContext || this.pageConfig.location;

            if ( !playerContext ) {
                playerContext = "Video Playback Page";
            }

            return playerContext;
        },
        'MEDIA_COMPONENT_LOCATION': function ( screenData ) {
            var location = '';
            var section  = this.pageConfig.section;

            if ( 'embed' === section ) {
                location = ( this.pageConfig.playerContext ) ? this.pageConfig.playerContext : this.pageConfig.location;
                location = ( location ) ? location : 'Embedded Player';
            } else if ( 'vpp' === section ) {
                location = 'Video Playback Page';
            } else if ( 'nhltv' === section ) {
                location = 'Media Player';
            }

            return location;
        },
        'MEDIA_STREAM_ID': function ( screenData ) {
            // TODO - the playbackScenario is not right.
            return screenData.clip.content_id + '|' + screenData.config.playbackScenario;
        },
        'MEDIA_STREAM_VIDEO': function ( screenData ) {
            var streamVideo = 'none';

            if ( Array.isArray( screenData.meta.keywordsDisplay ) ) {
                var keywords = $.map( screenData.meta.keywordsDisplay, function ( obj, i ) {
                    if ( obj && obj.displayName ) {
                        return obj.displayName;
                    }
                    return null;
                } );
                streamVideo = keywords.join( '|' );
            }

            return streamVideo;
        },
        'MEDIA_STREAM_PLAYER': function ( screenData ) {
            // TODO - window.databootstap.topic vs. window.databootstap.
            return this.pageConfig.topic ? this.pageConfig.topic.title : 'none';
        },
        'MEDIA_STREAM_TYPE': function ( screenData ) {
            var playback;

            if ( screenData.clip.isHighlight ) {
                playback = "VOD";
            } else if ( screenData.clip.isAudioOnly ) {
                playback = "Audio";
            } else if ( screenData.clip.isLive === true ) {
                playback = "Live";
            } else if ( screenData.clip.isLive === false ) {
                playback = "Archive";
            } else {
                playback = "VOD";
            }

            return playback;
        }

        // TODO - DYNAMIC WiretapApp
        //'INDEX': function ( screenData ) {
        //    //if ( value.match( /@INDEX_\w+@/ ) ) {
        //    var parent = ( trackObj.wire && trackObj.wire.parent ) ? trackObj.wire.parent : null;
        //    return setIndex( value, $el, parent );
        //},
        //'TEXT': function ( screenData ) {
        //    return setText( value, $el );
        //}
        //'TEAM_ABBREV': function ( screenData ) {
        //    replacement = appVars.teamAbbrev ? appVars.teamAbbrev : '[Team - unavailable]';
        //    value = value.replace( /@TEAM_ABBREV@/, replacement );
        //}
        //if ( value.match( /@SITE_TRAFFIC@/ ) ) {
        //    replacement = appVars.siteTraffic ? appVars.siteTraffic : '[Site traffic - unavailable]';
        //    value = value.replace( /@SITE_TRAFFIC@/, replacement );
        //}
        //if ( value.match( /@SITE_NAME@/ ) ) {
        //    replacement = appVars.teamDisplay ? appVars.teamDisplay : 'National Hockey League';
        //    value = value.replace( /@SITE_NAME@/, replacement );
        //}
        //if ( value.match( /@MEDIA_SPONSOR@/ ) ) {
        //    replacement = 'NHL';
        //    value = value.replace( /@MEDIA_SPONSOR@/, replacement );
        //}
        //if ( value.match( /@LANG_LOCALE@/ ) ) {
        //    replacement = appVars.langLocale ? appVars.langLocale : '[Lang locale - unavailable]';
        //    value = value.replace( /@LANG_LOCALE@/, replacement );
        //}
    };

    /**
     * Set variable with the text content of an element or parent.
     * @param $el       The active DOM element.
     * @param parent    The parent or grandparent element.
     */
    function setText( $el, parent ) {
        var text = (parent) ? $el.parents( parent.s ).text() : $el.text();

        return text.trim().replace( /\s+/g, ' ' );
    }

    /**
     * Set variable with the index number of an element or parent.
     * @param value     The tracking value.
     * @param $el       The active DOM element.
     * @param zeroIndex Start at 0 or 1.
     * @param parent    The parent or grandparent element.
     */
    function setIndex( value, $el, parent, zeroIndex ) {
        var index;
        var offset;

        if ( value.match( /@INDEX_\d+_PARENT@/ ) && parent ) {
            index = $el.parents( parent.s ).index();
        } else {
            index = $el.index();
        }

        if ( value.match( /@INDEX_0/ ) ) {
            offset = 0;
        } else if ( value.match(/@INDEX_1/) ) {
            offset = 1;
        }

        // TODO - support the case with multiple unique replacements within a single prop value.
        //return value.replace( /@INDEX_\w+@/g, index + offset );
        return index + offset;
    }


    return TokenHelpers;
} );


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function ( root, factory ) {
    if ( true ) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(18)
        ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
} )( this, function ( $ ) {
    function MediaTimer ( wiretapVideo ) {
        if ( ! wiretapVideo ) {
            return;
        }

        this.wiretapVideo   = wiretapVideo;
        this.dispatcher     = this.wiretapVideo.bandwagon.getInstanceByKey( '#video-player' );
        this.intervalEvents = this.wiretapVideo.trackingConfig.intervals;
        this.eventDefaults  = this.wiretapVideo.trackingConfig.defaults;

        _initListeners.call( this );
    }

    MediaTimer.prototype = {
        init: function () {
            if ( ! this.player || ! this.player.clip ) {
                return;
            }

            this.clip         = this.player.clip;
            this.videoLength  = this.player.clip.duration ? this.player.clip.duration * 1000 : 0;
            this.isTracking   = false;
            this.totalTime    = 0;
            this.hasTracked   = false;
            this.mediaStarted = true;

            this.start();
        },
        start: function () {
            if ( ! this.isTracking && this.mediaStarted ) {
                this.startTime = new Date();
                this.isTracking = true;
            }
        },
        stop: function () {
            if ( this.isTracking ) {
                this.stopTime = new Date();
                this.isTracking = false;
                this.setInterval();
            }
        },
        setInterval: function () {
            var interval = 0;
            if ( this.startTime && this.stopTime ) {
                interval = this.stopTime - this.startTime;
            }

            this.totalTime += interval;
            this.startTime = null;
            this.stopTime = null;
        },
        startTracking: function ( data, event ) {
            if ( this.isTracking ) { // Track previous media.
                this.stop();
                this.track();
            }

            this.player = data.player || this.player;

            this.init();
        },
        track: function () {
            if ( this.hasTracked || ! this.videoLength ) {
                return;
            }

            var self = this;
            var adobeObj = {};

            if ( this.isTracking ) {
                this.stop();
            }

            // TODO - an event like onBeforeChangeVidSrc would be better.
            // Track using the timer's active clip, not the player's current clip.
            var player = $.extend( {}, self.player );
            player.clip = self.clip;
            var clipDuration = player.clip.metaData.duration;
            var durationSplit = clipDuration.split(':');
            var clipDurationSeconds = 0;

            if (durationSplit.length === 3) {
                clipDurationSeconds = (+durationSplit[0]) * 60 * 60 + (+durationSplit[1]) * 60 + (+durationSplit[2]);
            } else if (durationSplit.length === 2) {
                clipDurationSeconds = (+durationSplit[0]) * 60 + (+durationSplit[1]);
            } else {
                clipDurationSeconds = (+durationSplit[1]);
            }

            var clipDurationMinutes = _getMinutes(clipDurationSeconds);
            var clipDurationSecondsModulo = _getSeconds(clipDurationSeconds);

            $.each( self.intervalEvents, function( index, event ) {
                var eventTime = clipDurationSeconds * event.wire.duration;
                var eventTimeMinutes = _getMinutes(eventTime);
                var eventTimeSeconds = _getSeconds(eventTime);
                if ( self.videoLength >= self.videoLength * event.wire.duration ) {
                    var trackObj = $.extend( {}, self.eventDefaults[ event.wire.defaults ], event );

                    self.wiretapVideo.setTrackingProps( trackObj, { player: player } );
                    if ( trackObj ) {
                        self.wiretapVideo.prototype.track( trackObj );
                    }
                }
            } );

            this.isTracking = false;
            this.hasTracked = true;
            this.mediaStarted = false;
        }
    };

    function _getMinutes(time) {
        var mins = Math.floor(time / 60).toString();
        if (mins < 10) {
            return '0' + mins;
        } else {
            return mins;
        }
    }

    function _getSeconds(time) {
        var secs = Math.floor(time % 60).toString();
        if (secs < 10) {
            return '0' + secs;
        } else {
            return secs;
        }
    }

    function _initListeners() {
        // Init and start timer.
        this.dispatcher.on( this.wiretapVideo.PlayerEvents['MEDIA_START'], this.startTracking.bind( this ) );

        // Start timer.
        this.dispatcher.on( this.wiretapVideo.PlayerEvents['MEDIA_RESUME'], this.start.bind( this ) );
        this.dispatcher.on( this.wiretapVideo.AdEvents['AD_COMPLETE'], this.start.bind( this ) );

        // Stop timer.
        this.dispatcher.on( this.wiretapVideo.PlayerEvents['MEDIA_PAUSED'], this.stop.bind( this ) );
        this.dispatcher.on( this.wiretapVideo.AdEvents['AD_START'], this.stop.bind( this ) );

        // Track.
        this.dispatcher.on( this.wiretapVideo.PlayerEvents['MEDIA_COMPLETE'], this.track.bind( this ) );
        window.addEventListener( "beforeunload", this.track.bind( this ) );
    }

    return MediaTimer;
});

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

!function(n,t){ true?module.exports=t():undefined}("undefined"!=typeof self?self:this,function(){return function(n){var t={};function e(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return n[r].call(o.exports,o,o.exports,e),o.l=!0,o.exports}return e.m=n,e.c=t,e.d=function(n,t,r){e.o(n,t)||Object.defineProperty(n,t,{configurable:!1,enumerable:!0,get:r})},e.n=function(n){var t=n&&n.__esModule?function(){return n.default}:function(){return n};return e.d(t,"a",t),t},e.o=function(n,t){return Object.prototype.hasOwnProperty.call(n,t)},e.p="",e(e.s=0)}([function(n,t,e){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),e.d(t,"Location",function(){return a}),e.d(t,"parseQueryParameters",function(){return c}),e.d(t,"parseEncodedQueryParameters",function(){return f}),e.d(t,"parseFragmentIdentifiers",function(){return s});var r=new RegExp("([^&\\?]+?)=([^&]*)","ig"),o=decodeURIComponent,i={true:!0,false:!1,null:null};function u(n){var t=void 0;return"string"==typeof n&&(t=isNaN(n)?n in i?i[n]:n:parseFloat(n)),t}function a(n){var t=(n=function(n){for(var t=["constructor","hash","host","hostname","href","origin","pathname","port","protocol","search"],e={},r=0,o=t.length;r<o;r++)e[t[r]]=n?n[t[r]]:window.location[t[r]];return e.toString=function(){return this.href},e}(n)).search||"",e=c(t);return n.getParam=function(n){return""+n in e?e[n]:null},n.getParams=function(n){return c(t,n)},n.isSecure=function(){return/^https/i.test(n.protocol)},n.getDomain=function(){var t=n.hostname.split(".");return t[t.length-2]},n}function c(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:window.location.search,t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],e={},i=void 0,a=void 0;return"string"==typeof n&&n.replace(r,function(){i=arguments[1],a=t?u(o(arguments[2])):o(arguments[2]),i in e?Array.isArray(e[i])?e[i].push(a):e[i]=[e[i],a]:e[i]=a}),e}function f(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:window.location.search,t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],e={},i=void 0,a=void 0;return"string"==typeof n&&n.replace(r,function(){i=arguments[1],a=t?u(o(arguments[2])):o(arguments[2]),i in e?Array.isArray(e[i])?e[i].push(a):e[i]=[e[i],a]:e[i]=a}),e}function s(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:window.location.hash,t=arguments[1];return c(n.substring(n.indexOf("#")+1),t)}}])});

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(50),
    isArrayLike = __webpack_require__(12),
    keys = __webpack_require__(11);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(198),
    baseIteratee = __webpack_require__(50),
    toInteger = __webpack_require__(199);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 198 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(200);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(201);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(3),
    isSymbol = __webpack_require__(21);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external {"commonjs":"mlb-media-player","commonjs2":"mlb-media-player","amd":"mlb-media-player","root":"MediaPlayer"}
var external_commonjs_mlb_media_player_commonjs2_mlb_media_player_amd_mlb_media_player_root_MediaPlayer_ = __webpack_require__(1);

// CONCATENATED MODULE: ./src/js/advertising/base-advertising-plugin.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }


/**
 *
 * @module BaseAdvertisingPlugin
 * @desc
 * @class BaseAdvertisingPlugin
 *
 */

var BaseAdvertisingPlugin =
/*#__PURE__*/
function (_AbstractPlugin) {
  _inherits(BaseAdvertisingPlugin, _AbstractPlugin);

  function BaseAdvertisingPlugin(config, observationCenter) {
    var _this;

    _classCallCheck(this, BaseAdvertisingPlugin);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BaseAdvertisingPlugin).call(this, config, observationCenter));
    _this.ready = false;
    _this.adManager = null;
    _this.adPlaying = false;
    _this.pluginDidError = false;
    return _this;
  }

  _createClass(BaseAdvertisingPlugin, [{
    key: "requestAd",
    value: function requestAd(adVideoElement, adContainer) {
      this.adPlaying = false;
    }
  }, {
    key: "startMidRoll",
    value: function startMidRoll() {
      throw new Error('Implement startMidRoll()');
    }
  }, {
    key: "endMidRoll",
    value: function endMidRoll() {
      throw new Error('Implement endMidRoll()');
    }
  }, {
    key: "endPreRoll",
    value: function endPreRoll() {
      throw new Error('Implement endPreRoll()');
    }
  }, {
    key: "setClip",
    value: function setClip() {
      throw new Error('Implement setClip()');
    }
  }, {
    key: "resumeAd",
    value: function resumeAd() {
      throw new Error('Implement resumeAd()');
    }
  }, {
    key: "setSize",
    value: function setSize(width, height, isFullScreen) {
      throw new Error('Implement setSize()');
    }
  }, {
    key: "setVolume",
    value: function setVolume(pct) {
      throw new Error('Implement setVolume()');
    }
  }, {
    key: "mute",
    value: function mute() {
      throw new Error('Implement mute()');
    }
  }, {
    key: "unmute",
    value: function unmute() {
      throw new Error('Implement unmute()');
    }
  }, {
    key: "getCurrentTimeInSecs",
    value: function getCurrentTimeInSecs() {
      return 0;
    }
  }, {
    key: "getDurationInSecs",
    value: function getDurationInSecs() {
      return 0;
    }
  }, {
    key: "initializeForAutoPlayPermission",
    value: function initializeForAutoPlayPermission(adVideoElement, adContainer) {
      throw new Error('Implement initializeForAutoPlayPermission(adVideoElement, adContainer)');
    }
    /**
     *
     * Utility function for returning the name of the class.
     * @return string The class type.
     *
     */

  }, {
    key: "toString",
    value: function toString() {
      return 'BaseAdvertisingPlugin';
    }
  }]);

  return BaseAdvertisingPlugin;
}(external_commonjs_mlb_media_player_commonjs2_mlb_media_player_amd_mlb_media_player_root_MediaPlayer_["AbstractPlugin"]);

/* harmony default export */ var base_advertising_plugin = (BaseAdvertisingPlugin);
// CONCATENATED MODULE: ./src/js/advertising/advertising-plugin-events.js
/**
 *
 * @module AdvertisingPluginEvents enum
 * @desc Ad evnt enum
 *
 */
/* harmony default export */ var advertising_plugin_events = ({
  AD_AUTOPLAY_BLOCKED: 'adAutoPlayBlocked',
  AD_PLUGIN_LOADED: 'adPluginLoaded',
  AD_REQUEST_STARTED: 'adRequestStarted',
  AD_REQUEST_COMPLETE: 'adRequestComplete',
  AD_PLUGIN_ERROR: 'adPluginError',
  AD_ERROR: 'adError',
  AD_START: 'adStart',
  AD_COMPLETE: 'adComplete',
  AD_PREROLL_START: 'adPreRollStart',
  AD_PREROLL_COMPLETE: 'adPreRollComplete',
  AD_DEFAULT_COMPANION: 'adDefaultCompanion',
  AD_COMPANION: 'adCompanion',
  AD_TIME_UPDATE_ELAPSED: 'adTimeUpdateElapsed',
  AD_TIME_UPDATE_REMAINING: 'adTimeUpdateRemaining',
  AD_BLOCK_DETECTED: 'adBlockDetected',
  ALL_ADS_COMPLETED: 'allAdsCompleted',
  AD_LOADED: 'adLoaded'
});
// EXTERNAL MODULE: /Users/crosby/_projects/_web-media/mlb-media-player/web-media-playback/node_modules/lodash/get.js
var get = __webpack_require__(0);
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /Users/crosby/_projects/_web-media/mlb-media-player/web-media-playback/node_modules/lodash/toString.js
var lodash_toString = __webpack_require__(31);
var toString_default = /*#__PURE__*/__webpack_require__.n(lodash_toString);

// EXTERNAL MODULE: /Users/crosby/_projects/_web-media/mlb-media-player/web-media-playback/node_modules/lodash/each.js
var each = __webpack_require__(54);
var each_default = /*#__PURE__*/__webpack_require__.n(each);

// CONCATENATED MODULE: ./src/js/utils/device.js
function device_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function device_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function device_createClass(Constructor, protoProps, staticProps) { if (protoProps) device_defineProperties(Constructor.prototype, protoProps); if (staticProps) device_defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Detect and classify some device specific information via userAgent.
 * Detects browser, browser version, os, form-factor.
 * @name Device
 */
var OPEN = '(';
var CLOSE = ')';
var CASE = 'i';
var PIPE = '|';
var OTHER = 'desktop'; //treating other as desktop - chromebooks were getting classified as other

var VERSION = 'version';
var EMPTY = "";

var Regex = function Regex(regex, flags) {
  return new RegExp(regex, flags || CASE);
};

var ios = "iP(?:hone|ad|od)";
var bb = "(?:BlackBerry|BB10| RIM )";
var android = "Android";
var windows = "Windows";
var winpdsk = "WPDesktop"; //Windows Phone Desktop Mode

var winpold = windows + " Phone";
var winphone = "Trident(?:.*?Touch(?:.*?Mobile))";
var linux = "Linux(?!.*Android)";
var mac = "Macintosh";
var chromebook = "CrOS";
var desktop = OPEN + "?:" + [mac, windows, linux, chromebook].join(PIPE) + CLOSE;
var rSEP = /[\._]/;
var rPLATFORM = {
  windowsphone: Regex(winphone + PIPE + winpold + PIPE + winpdsk),
  windows: Regex(windows),
  ios: Regex(ios),
  blackberry: Regex(bb),
  android: Regex(android),
  linux: Regex(linux),
  macintosh: Regex(mac),
  chromebook: Regex(chromebook)
};
var rmsFORMFACTOR = {
  /*
      * Microsoft platform specific form factor tests to address their UA nonsense without affecting other platforms
      * treating Xbox as Tablet to avoid Flash issues / push into apps when appropriate
      */
  desktop: /(?:Windows NT(?!.*WPDesktop)(?!.*Xbox))/i,
  tablet: Regex(OPEN + ['Tablet|iPad', '\\sNT.*?' + winphone, android + '(?!.*Mobi)', 'silk', bb + '.*?Tablet', 'xbox'].join(PIPE) + CLOSE),
  phone: Regex(OPEN + ['Mobi|Mobile', 'WPDesktop', ios, winphone, bb].join(PIPE) + CLOSE)
};
var rFORMFACTOR = {
  /* Use Mobi for android partial match to also include Opara mobile for android
      * @todo NT+winp can report incorrect matches for touch enabled win 8 desktop */
  tablet: Regex(OPEN + ['Tablet|iPad', '\\sNT.*?' + winphone, android + '(?!.*Mobi)', 'silk', bb + '.*?Tablet'].join(PIPE) + CLOSE),
  phone: Regex(OPEN + ['Mobi|Mobile', ios, winphone, bb].join(PIPE) + CLOSE),
  desktop: Regex(desktop)
};
var rBROWSER = {
  msie: /msie|iemobile|trident/i,
  edge: /edge/i,
  android: /android(?!.+(?:chrome|silk))/i,
  chrome: /chrome|crios/i,
  firefox: /firefox/i,
  opera: /opera(?!.*?mini)\//i,
  operamini: /opera mini/i,
  silk: /silk/i,
  safari: /safari/i
};
var rBROWSERCORE = {
  webkit: /AppleWebKit/i,
  gecko: /gecko\//i,
  trident: /trident/i,
  edge: /Edge/i
};
var rNOTPOLYFILL = /\[\s*native code\s*\]/;
var FORMFACTORS = {
  desktop: "desktop",
  other: OTHER,
  phone: "phone",
  tablet: "tablet"
};
var deviceCache = {};

var safeArray = function safeArray(ar, index) {
  return ar && index ? ar[index] : ar;
};

var version = function version(vstr) {
  var varr = vstr.split(rSEP).slice(0, 3);

  if (vstr && varr.length < 2) {
    varr.push(0);
  }

  return varr.join('.');
};

var Device =
/*#__PURE__*/
function () {
  /**
   * Build a device descriptor object via a userAgent string.
   * Identifies the platform, browser name and version, and os version.
   * Attempts to classify the device's form factor as either Phone, Tablet, or Desktop.
   * Parsed devices are cached internally to reduce processing, and provide a mechanism
   * for updating properties on the fly as need (@see getOrientation).
   * @constructor
   * @param {string} [ua] Optional userAgent string to consume. Defaults to navigator.userAgent.
   */
  function Device(ua) {
    device_classCallCheck(this, Device);

    ua = ua || navigator.userAgent;

    if (deviceCache[ua]) {
      return deviceCache[ua];
    }

    if (!(this instanceof Device)) {
      return new Device(ua);
    }

    deviceCache[ua] = this;
    this.userAgent = ua;
    this.is = {};
    this.platform = this.getPlatform();
    this.platformVersion = this.getPlatformVersion();
    this.browser = this.getBrowser();
    this.browserVersion = this.getBrowserVersion();
    this.formFactor = this.getFormFactor();
  }
  /**
   * Determine os from a known set of values.  If not readily classifiable,
   * the platform will be 'other'.
   * @see  rPLATFORMS
   * @return {string} Platform name or 'other'.
   */


  device_createClass(Device, [{
    key: "getPlatform",
    value: function getPlatform() {
      return this.test(rPLATFORM) || OTHER;
    }
    /**
     * Attempt to determing the version of the parsed platform.
     * Version will be formatted as MAJOR.MINOR.PATCH (if availble).
     * @return {string} Version string of the determined platform.  In unknown, value is "".
     */

  }, {
    key: "getPlatformVersion",
    value: function getPlatformVersion() {
      return version(this.match(Regex("(?:" + (this.is.blackberry ? VERSION : this.platform) + "|" + winpold + "|OS)[^\\d]+([\\d\\.\\_]+)", "ig"), 1));
    }
    /**
     * Determine the browser name from the defined set.
     * @see  rBrowser
     * @return {string} Matched browser name from rBrowser. Defaults to 'other'.
     */

  }, {
    key: "getBrowser",
    value: function getBrowser() {
      this.test(rBROWSERCORE);
      return this.test(rBROWSER) || OTHER;
    }
    /**
     * Attempt to match the device to the form factor set {tablet, phone, desktop, other} where possible.
     * @return {string} Form factor label, or 'other'.
     */

  }, {
    key: "getFormFactor",
    value: function getFormFactor() {
      var formFactorTest = ""; //different tests per platform?

      if (this.is.msie) {
        formFactorTest = rmsFORMFACTOR;
      } else {
        formFactorTest = rFORMFACTOR;
      }

      return FORMFACTORS[this.test(formFactorTest)] || FORMFACTORS.other;
    }
    /**
     * Parse out the browser version as a MAJOR.MINOR.PATCH formatted string.
     * @note  BUILD fragment is discarded.
     * @return {string} Parsed version string of the form MAJOR.MINOR.PATCH.
     */

  }, {
    key: "getBrowserVersion",
    value: function getBrowserVersion() {
      var searchBrowser = this.browser,
          delimiter = "[\\/\\s]";

      if (this.is.chrome && this.is.ios) {
        searchBrowser = "crios";
      } else if (this.is.opera) {
        searchBrowser = VERSION;
      } else if (this.is.msie) {
        searchBrowser = searchBrowser + PIPE + "IEMobile" + PIPE + "rv";
        delimiter = "[\\/\\:\\s]";
      }

      return version(this.match(Regex("(?:" + searchBrowser + PIPE + VERSION + ")" + delimiter + "([\\d\\.]+)", "i"), 1));
    }
    /**
     * Helper method for safely running regex matches against the instances userAgent.
     * @param  {regexp}    regex Regex to match.
     * @param  {number}    [index] Optional captured match to return.  If no index is supplied,
     *                            the entire match set is return as an array.
     * @return {mixed}      String when used with index, or array of matches.
     */

  }, {
    key: "match",
    value: function match(regex, index) {
      return safeArray(regex.exec(this.userAgent), index) || EMPTY;
    }
  }, {
    key: "test",
    value: function test(map) {
      var key,
          check,
          result,
          ua = this.userAgent;

      for (key in map) {
        check = map[key].test(ua);
        this.is[key] = this.is[key] || check && !result;

        if (check && !result) {
          result = key;
        }
      }

      return result;
    }
  }]);

  return Device;
}();

/* harmony default export */ var device = (Device);
// CONCATENATED MODULE: ./src/js/utils/script-loader.js
function script_loader_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function script_loader_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function script_loader_createClass(Constructor, protoProps, staticProps) { if (protoProps) script_loader_defineProperties(Constructor.prototype, protoProps); if (staticProps) script_loader_defineProperties(Constructor, staticProps); return Constructor; }


/**
 *
 * @module ScriptLoader
 * @desc
 * @class ScriptLoader
 *
 */

var script_loader_ScriptLoader =
/*#__PURE__*/
function () {
  function ScriptLoader() {
    script_loader_classCallCheck(this, ScriptLoader);
  }

  script_loader_createClass(ScriptLoader, null, [{
    key: "getAPI",
    value: function getAPI(scriptUrl, scriptLocation) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        var exists = document.querySelector("[src=\"".concat(scriptUrl, "\"]"));
        script.src = scriptUrl;

        script.onload = function () {
          var scriptObj = get_default()(window, scriptLocation);

          if (scriptObj) {
            return resolve(scriptObj);
          } else {
            return reject(new Error("Could not load script ".concat(scriptUrl)));
          }
        };

        if (!exists) {
          script.onerror = reject;
          script.type = "text/javascript";
          document.getElementsByTagName("body")[0].appendChild(script);
        }
      });
    }
  }]);

  return ScriptLoader;
}();

/* harmony default export */ var script_loader = (script_loader_ScriptLoader);
// CONCATENATED MODULE: ./src/js/advertising/freewheel/freewheel-plugin.js
function freewheel_plugin_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { freewheel_plugin_typeof = function _typeof(obj) { return typeof obj; }; } else { freewheel_plugin_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return freewheel_plugin_typeof(obj); }

function freewheel_plugin_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function freewheel_plugin_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function freewheel_plugin_createClass(Constructor, protoProps, staticProps) { if (protoProps) freewheel_plugin_defineProperties(Constructor.prototype, protoProps); if (staticProps) freewheel_plugin_defineProperties(Constructor, staticProps); return Constructor; }

function freewheel_plugin_possibleConstructorReturn(self, call) { if (call && (freewheel_plugin_typeof(call) === "object" || typeof call === "function")) { return call; } return freewheel_plugin_assertThisInitialized(self); }

function freewheel_plugin_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get2(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get2 = Reflect.get; } else { _get2 = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get2(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = freewheel_plugin_getPrototypeOf(object); if (object === null) break; } return object; }

function freewheel_plugin_getPrototypeOf(o) { freewheel_plugin_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return freewheel_plugin_getPrototypeOf(o); }

function freewheel_plugin_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) freewheel_plugin_setPrototypeOf(subClass, superClass); }

function freewheel_plugin_setPrototypeOf(o, p) { freewheel_plugin_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return freewheel_plugin_setPrototypeOf(o, p); }









/**
 *
 * @module FreewheelPlugin
 * @desc
 * @class FreewheelPlugin
 *
 */

var freewheel_plugin_FreewheelPlugin =
/*#__PURE__*/
function (_BaseAdvertisingPlugi) {
  freewheel_plugin_inherits(FreewheelPlugin, _BaseAdvertisingPlugi);

  function FreewheelPlugin(config, obsvervationCenter) {
    var _this;

    freewheel_plugin_classCallCheck(this, FreewheelPlugin);

    _this = freewheel_plugin_possibleConstructorReturn(this, freewheel_plugin_getPrototypeOf(FreewheelPlugin).call(this, config, obsvervationCenter));
    _this.pluginSubject = _this.observationCenter.pluginSubject;
    _this.videoAdContainerId = get_default()(_this.config, 'videoAdContainerId', 'ad-container');
    _this.adContainer = undefined;
    _this.controls = get_default()(_this.config, 'controls', false);
    _this.autoplay = get_default()(_this.config, 'autoplay', true);
    _this.muted = get_default()(_this.config, 'muted', true);
    _this.playsInline = get_default()(_this.config, 'playsinline', true);
    _this.scriptUrl = get_default()(_this.config, 'freewheel.adManager', 'https://mssl.fwmrm.net/p/release/latest-JS/adm/prd/AdManager.js');
    _this.context = null;
    _this.siteSection = get_default()(_this.config, 'freewheel.siteSection');
    _this.networkId = get_default()(_this.config, 'freewheel.siteSectionNetwork');
    _this.fallbackNetwork = get_default()(_this.config, 'freewheel.fallbackNetwork');
    _this.topicId = get_default()(_this.config, 'freewheel.topicId');
    _this.prerollSlots = [];
    _this.midrollSlots = [];
    _this.overlaySlots = [];
    _this.postrollSlots = [];
    _this.sourceUrlQueue = [];
    _this.currentPlayingSlotType = null;
    _this.deviceManager = new device();
    _this.videoAdNode = undefined;
    /**
     *
     * @type {boolean}
     * @desc This flag is used by admins to end midrolls early, flag is change to true in endMidRoll()
     *
     */

    _this.endMidRolls = false;

    _this.initAdContainer();

    return _this;
  }

  freewheel_plugin_createClass(FreewheelPlugin, [{
    key: "createVideoAdPlaybackNode",
    value: function createVideoAdPlaybackNode() {
      var videoAdNode = document.createElement('video');
      videoAdNode.setAttribute('id', 'paid-interruption-player');
      videoAdNode.controls = this.controls;
      videoAdNode.autoplay = this.autoplay;
      videoAdNode.muted = this.muted;
      videoAdNode.playsinline = this.playsInline;
      return videoAdNode;
    }
    /**
     *
     * @desc Initialize and create the ad container and video node. Also attaches the video node to the DOM
     * as a child of the ad container. The video node is prepended to the children of the adContainer
     *
     */

  }, {
    key: "initAdContainer",
    value: function initAdContainer() {
      this.adContainer = document.getElementById(this.videoAdContainerId);

      if (!this.adContainer) {
        throw new Error("An element with the id ".concat(this.videoAdContainerId, " is required for ad playback"));
      }

      this.videoAdNode = this.createVideoAdPlaybackNode();
      this.adContainer.style.display = 'none';
      this.adContainer.innerHTML = ''; // Clear all the children

      this.adContainer.appendChild(this.videoAdNode); // Add the video node
    }
    /**
     *
     * @desc Subscribe to the ObservationCenter messages
     *
     */

  }, {
    key: "subscribeToMessages",
    value: function subscribeToMessages() {
      var _this2 = this;

      var PlayerEvents = external_commonjs_mlb_media_player_commonjs2_mlb_media_player_amd_mlb_media_player_root_MediaPlayer_["MediaPlayerEvents"][this.mediaPlayer.player.playerTypeConfig.playerType]; // Player subscriptions

      var playerSubscription = this.observationCenter.playerSubject.subscribe(function (data) {
        switch (data.type) {
          case PlayerEvents.VOLUME_CHANGE:
            {
              var volume = get_default()(data, 'event.target.volume');

              var muted = get_default()(data, 'event.target.muted');

              _this2.onVolumeChanged(volume, muted);

              break;
            }

          case PlayerEvents.MEDIA_COMPLETE:
            {
              _this2.onContentVideoEnded();

              break;
            }

          case PlayerEvents.TIME_UPDATE:
            {
              _this2.onContentVideoTimeUpdated();

              break;
            }
        }
      }); // Plugin subscriptions

      var pluginSubscription = this.observationCenter.pluginSubject.subscribe(function (data) {
        switch (data.type) {
          case advertising_plugin_events.AD_START:
            {
              _this2.mediaPlayer.setIsAdPlaying(true);

              _this2.adContainer.style.display = '';
              break;
            }

          case advertising_plugin_events.AD_COMPLETE:
            {
              _this2.mediaPlayer.setIsAdPlaying(false);

              _this2.adContainer.style.display = 'none';
              break;
            }

          case advertising_plugin_events.AD_ERROR:
          case advertising_plugin_events.AD_PLUGIN_ERROR:
          case advertising_plugin_events.AD_BLOCK_DETECTED:
            {
              _this2.pluginDidError = true;

              _this2.mediaPlayer.setIsAdPlaying(false);

              _this2.destroy();

              break;
            }
        }
      });
      this.subscriptions.push(playerSubscription);
      this.subscriptions.push(pluginSubscription);
    }
    /**
     *
     * @desc Unsubscribe from the event stream
     * @private
     *
     */

  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      this.subscriptions.forEach(function (subscription) {
        subscription.unsubscribe();
      });
    }
  }, {
    key: "setMediaPlayer",
    value: function setMediaPlayer(mediaPlayer) {
      var _this3 = this;

      /* If we have a mediaPlayer, we need to unsubscribe from the event streams
          because we're going to resubscribe shorlty for the new player */
      if (this.mediaPlayer) {
        this.unsubscribe();
      } // Set so subscribeToMessages has a reference


      this.mediaPlayer = mediaPlayer; // init the freewheel plugin

      return this.init().then(function () {
        _this3.subscribeToMessages(); // Let the super know (this also calls pluginReady())


        _get2(freewheel_plugin_getPrototypeOf(FreewheelPlugin.prototype), "setMediaPlayer", _this3).call(_this3, mediaPlayer);
      });
    }
    /**
     *
     * @desc Initialize the plugin.
     *
     */

  }, {
    key: "init",
    value: function init() {
      var _this4 = this;

      return Promise.resolve(get_default()(window, 'tv.freewheel.SDK')).then(function (currentFreewheelSDK) {
        if (!currentFreewheelSDK) {
          return script_loader.getAPI(_this4.scriptUrl, 'tv.freewheel.SDK');
        } // console.log('load ad manager');


        return currentFreewheelSDK;
      }).then(function (freewheelSDK) {
        // console.log('ad manager loaded');
        if (!_this4.freewheelSDK) {
          _this4.freewheelSDK = freewheelSDK;
        }

        _this4._onScriptLoaded();
      }).catch(function (error) {
        console.log('ad manager error', error); // Dispatch error message

        _this4.pluginSubject.next({
          type: advertising_plugin_events.AD_PLUGIN_ERROR,
          error: error
        });
      });
    }
    /**
     *
     * @desc Request an Ad from the Freewheel server for playback.
     * @param {object} metadata metadata used to set Freewheel request and context properties
     *
     */

  }, {
    key: "requestAd",
    value: function requestAd(metadata) {
      var _this5 = this;

      var playerElement = this.videoAdNode;
      this.setClip(metadata);

      _get2(freewheel_plugin_getPrototypeOf(FreewheelPlugin.prototype), "requestAd", this).call(this, playerElement);

      if (this.ready) {
        if (!this.adManager) {
          this.shouldPlayPreroll = false;
          console.error('NO AD MANAGER. Ad blocker enabled?'); // Send AD_ERROR message

          this.pluginSubject.next({
            type: advertising_plugin_events.AD_BLOCK_DETECTED,
            result: result
          });
          return;
        }

        var duration = get_default()(this, 'config.freewheel.duration', 600);

        this.context = this.adManager.newContext();
        this.context.setProfile(this.config.freewheel.adProfile);
        this.context.setSiteSection(this.siteSection, this.networkId, Math.floor(Math.random() * 10000), this.freewheelSDK.ID_TYPE_CUSTOM, this.fallbackNetwork);
        this.context.setVideoAsset(get_default()(this.clip, 'content_id', 'MP4'), duration, this.networkId);

        if (typeof this.topicId !== 'undefined') {
          var site = this.topicId.substr(0, this.topicId.indexOf('/'));
          var player = this.topicId.slice(this.topicId.lastIndexOf('/') + 1, this.topicId.length);
          var section = this.topicId.slice(this.topicId.indexOf('/') + 1, this.topicId.lastIndexOf('/'));
          this.context.addKeyValue('topicID', this.topicId);
          this.context.addKeyValue('player', player);
          this.context.addKeyValue('site', site);
          this.context.addKeyValue('section', section);
        } else {
          this.context.addKeyValue('player', 'embed');
          this.context.addKeyValue('site', this.config.freewheel.site);
        }

        this.context.addKeyValue('deviceType', this.deviceManager.formFactor.toLowerCase());
        this.addCustomFreewheelProperties();
        /**
         *
         * 1.x has this (this.context.setContentVideoElement) method as this.context.registerVideoDisplayBase.
         * It appears that the different is the current method takes a video element
         * and the previous one takes a div id.
         *
         */
        //this.context.registerVideoDisplayBase('media-player');

        this.context.setContentVideoElement(playerElement);
        this.context.addTemporalSlot('Preroll_1', this.freewheelSDK.ADUNIT_PREROLL, 0); // Submit request.

        try {
          // Listen to AdManager Events
          this.context.addEventListener(this.freewheelSDK.EVENT_REQUEST_COMPLETE, function (event) {
            _this5._onRequestComplete(event);
          });
          this.context.addEventListener(this.freewheelSDK.EVENT_AD, function (event) {
            _this5._onAdEvent(event);
          });
          this.pluginSubject.next({
            type: advertising_plugin_events.AD_REQUEST_STARTED
          });
          this.context.submitRequest();
        } catch (e) {
          // Send AD_ERROR message
          console.log('requestAd error: ', e);
          this.pluginSubject.next({
            type: advertising_plugin_events.AD_ERROR,
            e: e
          });
        }
      } else {
        //if FreewheelPlugin is ready and this is getting triggered when it doesn't have a clip object,
        //this wreaks havoc on the player
        if (this.ready) {
          // Send AD_COMPLETE message
          this.pluginSubject.next({
            type: advertising_plugin_events.AD_COMPLETE,
            player: this.player
          });
          return;
        } else {
          var self = this;
          window.setTimeout(function () {
            self.requestAd(playerElement);
          }, 500);
        }
      }
    }
  }, {
    key: "addCustomFreewheelProperties",

    /**
     *
     * @desc Copy properties from clip.freewheelProps into the clip
     * @private
     *
     */
    value: function addCustomFreewheelProperties() {
      try {
        //Reading values from ClipReader is preferred for the decoupling from knowing about the clip
        var clipReader = this.player.utils.getClipReader();
        var freewheelProps = clipReader.getFreewheelProps(this.clip);
      } catch (e) {
        //Couldn't use ClipReader. Manually look for the properties. This is not preferred as the keys on the clip might change, but here for legacy support
        var freewheelProps = get_default()(this.clip, 'freewheelProps');
      }

      each_default()(freewheelProps, function (value, key) {
        this.context.addKeyValue(key, toString_default()(value));
      }.bind(this));
    }
    /**
     *
     * @desc Called to begin playback of the pre-roll ad.
     * @private
     *
     */

  }, {
    key: "_actualPlayback",
    value: function _actualPlayback() {
      if (this.prerollSlots.length) {
        this.prerollSlots[0].play();
      } else {
        this.pluginSubject.next({
          type: advertising_plugin_events.AD_COMPLETE,
          player: this.player
        });
      }
    }
    /**
     *
     * @desc Called when the video's ended event fires.
     *
     */

  }, {
    key: "onContentVideoEnded",
    value: function onContentVideoEnded() {
      if (this.freewheelSDK && this.currentPlayingSlotType === this.freewheelSDK.TIME_POSITION_CLASS_MIDROLL) {
        console.log('Received content video ended event dispatched from midroll, ignore');
        return;
      }

      this.sourceUrlQueue.shift();
      this.context.setVideoState(this.freewheelSDK.VIDEO_STATE_STOPPED);

      if (this.midrollSlots.length) {
        this.currentPlayingSlotType = this.freewheelSDK.TIME_POSITION_CLASS_MIDROLL;
        this.midrollSlots[0].play();
      } else if (this.sourceUrlQueue.length) {
        this._actualPlayback.call(this);
      } else if (this.postrollSlots && this.postrollSlots.length) {
        this.postrollSlots[0].play();
      } else {
        this.context.setVideoState(this.freewheelSDK.VIDEO_STATE_COMPLETED);
      }
    }
    /**
     *
     * @desc Called when the video's event timeupdate event fires.
     *
     */

  }, {
    key: "onContentVideoTimeUpdated",
    value: function onContentVideoTimeUpdated() {
      if (this.freewheelSDK && this.currentPlayingSlotType === this.freewheelSDK.TIME_POSITION_CLASS_MIDROLL) {
        //TODO fire data
        console.log('Received content video timeUpdate event dispatched when midroll playing, ignore');
        return;
      }

      for (var i = 0; i < this.overlaySlots.length; i++) {
        var slot = this.overlaySlots[i];
        var slotTimePosition = slot.getTimePosition();
        var videoCurrentTime = this.player.currentTime;

        if (videoCurrentTime - slotTimePosition >= 0 && videoCurrentTime - slotTimePosition <= 1 && !this.currentPlayingSlotType) {
          this.overlaySlots.splice(i, 1); // console.log('onContentVideoTimeUpdated timePositionClass: ' + slot.getTimePositionClass());

          slot.play();
          return;
        }
      }
    }
    /**
     *
     * @desc Triggers on HTMLMediaElement timeupdate event.
     * @param {Object} e The timeupdate event data.
     *
     */

  }, {
    key: "onTimeUpdated",
    value: function onTimeUpdated(e) {
      var payload = {
        currentTime: e.target.currentTime
      }; // Send AD_TIME_UPDATE_ELAPSED message

      this.pluginSubject.next({
        type: advertising_plugin_events.AD_TIME_UPDATE_ELAPSED,
        payload: payload
      });
    }
  }, {
    key: "onVolumeChanged",
    value: function onVolumeChanged(volume, muted) {
      var playerElement = this.videoAdNode;

      if (playerElement) {
        playerElement.muted = muted;
        playerElement.volume = volume;
      }
    }
    /**
     *
     * @desc Fires when the Freewheel library script has loaded.
     *
     */

  }, {
    key: "_onScriptLoaded",
    value: function _onScriptLoaded() {
      this.adManager = new this.freewheelSDK.AdManager();
      this.adManager.setNetwork(this.config.freewheel.adNetwork);
      this.adManager.setServer(this.config.freewheel.adServer);
      this.ready = true; // Send AD_PLUGIN_LOADED message

      this.pluginSubject.next({
        type: advertising_plugin_events.AD_PLUGIN_LOADED
      });
    }
    /**
     *
     * @private
     *
     */

  }, {
    key: "_playMidRoll",
    value: function _playMidRoll() {
      if (this.midrollSlots.length) {
        this.midrollSlots[0].play();
      } else {
        // Send AD_COMPLETE message
        this.pluginSubject.next({
          type: advertising_plugin_events.AD_COMPLETE,
          player: this.player
        });
      }
    }
    /**
     *
     * @desc Updates the event streams with ad playback info. This updates both `AD_TIME_UPDATE_REMAINING` and
     * `AD_TIME_UPDATE_ELAPSED` for backwards compatibility with the previous implementation.
     * @param {number} duration the entire duration of the ad break
     * @param {number} currentTime the current time of the current ad playback
     *
     */

  }, {
    key: "updateAdPlaybackInfo",
    value: function updateAdPlaybackInfo(duration, currentTime) {
      this.pluginSubject.next({
        type: advertising_plugin_events.AD_TIME_UPDATE_REMAINING,
        countdown: duration - currentTime,
        duration: duration,
        currentTime: currentTime
      });
      this.pluginSubject.next({
        type: advertising_plugin_events.AD_TIME_UPDATE_ELAPSED,
        countdown: duration - currentTime,
        duration: duration,
        currentTime: currentTime
      });
    }
    /**
     *
     * @desc Monitors ad playback for duration and current time via an interval and is
     * started on slot start and stopped on slot end or error. Updates the plugins subject for
     * `AD_TIME_UPDATE_REMAINING` and `AD_TIME_UPDATE_ELAPSED`
     * @param {object} slot the current ad slot
     *
     */

  }, {
    key: "startSlotCountdown",
    value: function startSlotCountdown(slot) {
      var _this6 = this;

      slot.countdownInterval = setInterval(function () {
        var duration = 0;
        var currentTime = slot.getPlayheadTime();

        _this6.prerollSlots.forEach(function (slot) {
          duration += slot.getTotalDuration();
        });

        _this6.updateAdPlaybackInfo(duration, currentTime);
      }, 1000);
    }
    /**
     *
     * @desc Clears the countdown monitor interval, and updates countdown info to zero for duration
     * and currentTime.
     * @param {object} slot the slot to end countdown monitoring for
     *
     */

  }, {
    key: "endSlotCountdown",
    value: function endSlotCountdown(slot) {
      clearInterval(slot.countdownInterval);
      this.updateAdPlaybackInfo(0, 0);
    }
    /**
     *
     *
     * @esc Called when an ad slot has started to play.
     * @param {Object} e The event data for the request.
     *
     */

  }, {
    key: "_onSlotStarted",
    value: function _onSlotStarted(e) {
      var slot = e.slot;
      var slotTimePositionClass = slot.getTimePositionClass(); // console.log('FreeWheelPlugin onSlotStarted slotTimePositionClass: ' + slotTimePositionClass);

      if (this.prerollSlots.length) {
        this.startSlotCountdown(this.prerollSlots[0]);
      }
    }
    /**
     *
     * @desc Called when an ad slot has started to play.
     * @param {Object} e The event data for the request.
     *
     */

  }, {
    key: "_onAdEvent",
    value: function _onAdEvent(e) {
      if (e.subType === this.freewheelSDK.EVENT_AD_IMPRESSION) {
        var totalDuration = 0;
        this.prerollSlots.forEach(function (slot) {
          totalDuration += slot.getTotalDuration();
        }); // console.log('AD START! Duration', totalDuration);
        // Send AD_START message

        this.pluginSubject.next({
          type: advertising_plugin_events.AD_START,
          duration: totalDuration,
          adDuration: e.slot.getTotalDuration(),
          player: this.player
        });
      }

      if (e.subType === this.freewheelSDK.EVENT_ERROR) {
        this.pluginSubject.next({
          type: advertising_plugin_events.AD_ERROR,
          error: e
        });
        this.endSlotCountdown(e.slot);
      }

      if (e.adInstance.getEventCallbackUrls(tv.freewheel.SDK.EVENT_AD_CLICK, tv.freewheel.SDK.EVENT_TYPE_CLICK).length > 0) {
        var slot = e.target._temporalSlotBase;

        if (slot && slot.parentElement) {
          // console.log('FreewheelPlugin: add the class `freewheel_adClickthru`');
          slot.parentElement.classList.add('freewheel_adClickthru');
        }
      }

      if (e.subType === this.freewheelSDK.EVENT_AD_AUTO_PLAY_BLOCKED) {
        // Send AD_AUTOPLAY_BLOCKED message
        this.pluginSubject.next({
          type: advertising_plugin_events.AD_AUTOPLAY_BLOCKED
        });
      }
    }
    /**
     *
     * @desc Called when an ad slot has ended.
     * @param {Object} e The event data for the request.
     *
     */

  }, {
    key: "_onSlotEnded",
    value: function _onSlotEnded(e) {
      var slot = e.slot;
      var slotTimePositionClass = slot.getTimePositionClass(); // console.log('FreeWheelPlugin onSlotEnded slotTimePositionClass: ' + slotTimePositionClass);

      this.endSlotCountdown(slot);
      var data;

      switch (slotTimePositionClass) {
        case this.freewheelSDK.TIME_POSITION_CLASS_PREROLL:
          if (this.prerollSlots.length) {
            this.prerollSlots.shift();

            if (this.prerollSlots.length) {
              this.prerollSlots[0].play();
            } else {
              this.context.setVideoState(this.freewheelSDK.VIDEO_STATE_PLAYING);
              data = {
                duration: e.slot ? e.slot.getTotalDuration() : null
              }; // Send AD_COMPLETE message

              this.pluginSubject.next({
                type: advertising_plugin_events.AD_COMPLETE,
                player: this.player,
                data: data
              });
            }
          }

          break;

        case this.freewheelSDK.TIME_POSITION_CLASS_MIDROLL:
          if (this.midrollSlots.length) {
            this.midrollSlots.shift();

            if (this.midrollSlots.length && !this.endMidRolls) {
              this.midrollSlots[0].play();
            } else {
              this.currentPlayingSlotType = null;
              this.endMidRolls = false;
              this.context.setVideoState(this.freewheelSDK.VIDEO_STATE_PLAYING);
              data = {
                duration: e.slot ? e.slot.getTotalDuration() : null
              }; // Send AD_COMPLETE message

              this.pluginSubject.next({
                type: advertising_plugin_events.AD_COMPLETE,
                player: this.player,
                data: data
              });
            }
          }

          break;

        case this.freewheelSDK.TIME_POSITION_CLASS_OVERLAY:
          this.currentPlayingSlotType = null;
          break;

        case this.freewheelSDK.TIME_POSITION_CLASS_POSTROLL:
          if (this.postrollSlots.length) {
            this.postrollSlots.shift();

            if (this.postrollSlots.length) {
              this.postrollSlots[0].play();
            } else {
              this.context.setVideoState(this.freewheelSDK.VIDEO_STATE_COMPLETED);

              _onRequestComplete.call(this, {
                // eslint-disable-line no-use-before-define
                success: true
              });
            }
          }

          break;
      }

      var fwClickThru = document.getElementsByClassName('freewheel_adClickthru');

      if (fwClickThru.length > 0) {
        // console.log('FreewheelPlugin: remove class `freewheel_adClickthru`');
        fwClickThru[0].classList.remove('freewheel_adClickthru');
      }
    }
    /**
     *
     * @desc Called when the FW Ad Manager receives a response from the FW system.
     * @param {Object} e The event data for the request.
     *
     */

  }, {
    key: "_onRequestComplete",
    value: function _onRequestComplete(result) {
      var _this7 = this;

      console.log('FreeWheelPlugin - _onRequestComplete', result);
      this.context.removeEventListener(this.freewheelSDK.EVENT_REQUEST_COMPLETE, function () {});

      if (!result.success) {
        // Send AD_ERROR message
        this.pluginSubject.next({
          type: advertising_plugin_events.AD_ERROR,
          result: result
        });
        return;
      }

      this.prerollSlots = [];
      this.midrollSlots = [];
      this.overlaySlots = [];
      this.postrollSlots = [];
      var fwTemporalSlots = this.context.getTemporalSlots();
      var slot = null;

      for (var i = 0; i < fwTemporalSlots.length; i++) {
        slot = fwTemporalSlots[i];

        switch (slot.getTimePositionClass()) {
          case this.freewheelSDK.TIME_POSITION_CLASS_PREROLL:
            this.prerollSlots.push(slot);
            break;

          case this.freewheelSDK.TIME_POSITION_CLASS_MIDROLL:
            this.midrollSlots.push(slot);
            break;

          case this.freewheelSDK.TIME_POSITION_CLASS_OVERLAY:
            this.overlaySlots.push(slot);
            break;

          case this.freewheelSDK.TIME_POSITION_CLASS_POSTROLL:
            this.postrollSlots.push(slot);
            break;
        }
      }

      this.context.addEventListener(this.freewheelSDK.EVENT_SLOT_STARTED, function (event) {
        _this7._onSlotStarted(event);
      });
      this.context.addEventListener(this.freewheelSDK.EVENT_SLOT_ENDED, function (event) {
        _this7._onSlotEnded(event);
      });
      this.sourceUrlQueue = [this.clip];
      var NO_AD_SLOT = 'noAdSlot';
      var timePosition = slot ? slot.getTimePositionClass() : NO_AD_SLOT;

      switch (timePosition) {
        case NO_AD_SLOT:
        case this.freewheelSDK.TIME_POSITION_CLASS_PREROLL:
          this._actualPlayback();

          break;

        case this.freewheelSDK.TIME_POSITION_CLASS_MIDROLL:
          this._playMidRoll();

          break;

        case this.freewheelSDK.TIME_POSITION_CLASS_OVERLAY:
        case this.freewheelSDK.TIME_POSITION_CLASS_POSTROLL:
          break;
      }

      this.pluginSubject.next({
        type: advertising_plugin_events.AD_REQUEST_COMPLETE,
        slots: fwTemporalSlots
      });
    } // =================================================
    // PUBLIC (from previous implementation)
    // =================================================

    /**
     *
     * @desc
     * @param clip
     *
     */

  }, {
    key: "setClip",
    value: function setClip(clip) {
      this.clip = clip;
    }
  }, {
    key: "startMidRoll",
    value: function startMidRoll(playerElement, adContainer, cuePointVO) {
      var _this8 = this;

      if (this.ready && playerElement) {
        if (!cuePointVO) {
          cuePointVO = new CuePointVO();
        }

        var timePosition = cuePointVO.timePosition;
        var breakLength = cuePointVO.breakLength;
        var midRollDuration = cuePointVO.duration;
        var networkId = this.networkId;

        if (this.clip) {
          videoAssetCustomId = this.clip.content_id || videoAssetCustomId;
        }

        this.context = this.adManager.newContext();
        this.context.setProfile(this.config.freewheel.adProfile); //Must set the request mode to REQUEST_MODE_LIVE for midRolls

        this.context.setRequestMode(this.freewheelSDK.REQUEST_MODE_LIVE);
        this.context.setSiteSection(this.siteSection, networkId, Math.floor(Math.random() * 10000), this.freewheelSDK.ID_TYPE_CUSTOM, this.fallbackNetwork);
        this.context.setVideoAsset(get_default()(this.clip, 'content_id', 'MP4'), midRollDuration, networkId); //this.context.registerVideoDisplayBase('media-player');

        this.context.setContentVideoElement(playerElement);
        this.context.addTemporalSlot('Midroll_1', this.freewheelSDK.ADUNIT_MIDROLL, timePosition, null, 1, breakLength, breakLength, null); // Submit request

        try {
          // Listen to AdManager Events
          this.context.addEventListener(this.freewheelSDK.EVENT_REQUEST_COMPLETE, function (event) {
            _this8._onRequestComplete(event);
          });
          this.context.addEventListener(this.freewheelSDK.EVENT_AD, function (event) {
            _this8._onAdEvent(event);
          });
          this.context.submitRequest();
        } catch (error) {
          // Send AD_ERROR message
          this.pluginSubject.next({
            type: advertising_plugin_events.AD_ERROR,
            error: error
          });
        }
      } else {
        var self = this;
        window.setTimeout(function () {
          self.startMidRoll(playerElement, cuePointVO);
        }, 500);
      }
    }
  }, {
    key: "endMidRoll",
    value: function endMidRoll() {
      var slot = this.midrollSlots[0];

      if (slot) {
        //Must set to true otherwise additional midrolls will run after stopping the current playing midroll
        this.endMidRolls = true;
        slot.stop();
      }
    }
  }, {
    key: "endPreRoll",
    value: function endPreRoll() {
      var slot = this.prerollSlots[0];

      if (slot) {
        //Must set to true otherwise additional midrolls will run after stopping the current playing midroll
        this.endPreRolls = true;
        slot.stop();
      }
    }
  }, {
    key: "resumeAd",

    /**
     *
     * @desc Resume a paused preroll if it was stopped because of EVENT_AD_AUTO_PLAY_BLOCKED
     * https://hub.freewheel.tv/display/techdocs/Safari+11+Auto-play+Video+Blocking+and+Solution
     *
     */
    value: function resumeAd() {
      try {
        var currentSlot = this.prerollSlots[0];
        currentSlot.play(); // Send AD_START message

        this.pluginSubject.next({
          type: advertising_plugin_events.AD_START,
          duration: currentSlot.getTotalDuration()
        });
      } catch (error) {
        // TODO: Should we send a message for resume ad failed?
        console.log('resumeAd failed. ' + error.message);
      }
    }
  }, {
    key: "destroy",

    /**
     *
     * @desc Destroy the ad manager.
     *
     */
    value: function destroy() {
      if (this.context) {
        this.context.dispose();
      }

      _get2(freewheel_plugin_getPrototypeOf(FreewheelPlugin.prototype), "destroy", this).call(this);
    }
    /**
     *
     * @desc Utility function for returning the name of the class.
     * @return string The class type.
     *
     */

  }, {
    key: "toString",
    value: function toString() {
      return 'FreewheelPlugin';
    }
  }]);

  return FreewheelPlugin;
}(base_advertising_plugin);

/* harmony default export */ var freewheel_plugin = (freewheel_plugin_FreewheelPlugin);
// EXTERNAL MODULE: /Users/crosby/_projects/_web-media/mlb-media-player/web-media-playback/node_modules/lodash/set.js
var set = __webpack_require__(19);
var set_default = /*#__PURE__*/__webpack_require__.n(set);

// EXTERNAL MODULE: /Users/crosby/_projects/_web-media/mlb-media-player/web-media-playback/node_modules/lodash/merge.js
var merge = __webpack_require__(20);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);

// EXTERNAL MODULE: /Users/crosby/_projects/_web-media/mlb-media-player/web-media-playback/node_modules/lodash/reduce.js
var reduce = __webpack_require__(81);
var reduce_default = /*#__PURE__*/__webpack_require__.n(reduce);

// EXTERNAL MODULE: /Users/crosby/_projects/_web-media/mlb-media-player/web-media-playback/node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(82);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);

// CONCATENATED MODULE: ./src/js/advertising/dfp/dfp-request-builder.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function dfp_request_builder_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function dfp_request_builder_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function dfp_request_builder_createClass(Constructor, protoProps, staticProps) { if (protoProps) dfp_request_builder_defineProperties(Constructor.prototype, protoProps); if (staticProps) dfp_request_builder_defineProperties(Constructor, staticProps); return Constructor; }







var dfp_request_builder_DfpRequestBuilder =
/*#__PURE__*/
function () {
  function DfpRequestBuilder() {
    dfp_request_builder_classCallCheck(this, DfpRequestBuilder);
  }

  dfp_request_builder_createClass(DfpRequestBuilder, null, [{
    key: "build",
    // Documentation: https://support.google.com/dfp_premium/answer/1068325?hl=en

    /**
     *
     * @access public
     * @param {Object} config
     * @param {String} [config.url='https://pubads.g.doubleclick.net/gampad/live/ads']
     * @param {String} [config.sz='400x300|640x480|1920x1280']
     * @param {String} [config.iu='/2605/video_test/riot']
     * @param {String} [config.impl='s']
     * @param {Number} [config.gdfp_req=1]
     * @param {String} [config.env='vp']
     * @param {String} [config.output='vast']
     * @param {Number} [config.unviewed_position_start=1]
     * @param {String} [config.description_url='[description_url]']
     * @param {String} [config.correlator='[timestamp]']
     * @param {Number} [config.pmnd=0]
     * @param {Number} [config.pmxd=60000]
     * @param {Number} [config.pmad=-1]
     * @param {String} [config.vpos='preroll']
     * @param {Number} [config.pod=1]
     * @param {Number} [config.ad_rule=0]
     * @param {String} [config.asset='']
     * @param {String} [config.dfp.additionalParams={}] Optional. Merged if additional param properties exist. Additoinal property specific params.
     * @param {Object} clip
     * @param {Object} [clip.adConfig={}]
     * @param {String} [clip.adConfig.cust_params='']
     * @param {String} [clip.adConfig.vid=''] matchPk, contentId or gamePk based on media type
     * @returns {String} url query param
     * @desc picks off values from config and clip and returns a url query string.<br>
     *     <a href="https://support.google.com/dfp_premium/answer/1068325?hl=en">https://support.google.com/dfp_premium/answer/1068325?hl=en</a>
     * @memberof DFPRequestBuilder
     */
    value: function build(config, clip, cuePointVO) {
      // defaults here are geared towards preroll specification
      var adConfig = cloneDeep_default()(get_default()(clip, 'adConfig', {})); // attempt to get 'url' from the adConfig, then from 'config', defaulting to hardcoded value


      var url = get_default()(adConfig, 'url', get_default()(config, 'url', 'https://pubads.g.doubleclick.net/gampad/live/ads'));

      var mapper = {
        sz: get_default()(config, 'sz', '400x300|640x480|1920x1280'),
        iu: get_default()(config, 'iu'),
        impl: get_default()(config, 'impl', 's'),
        gdfp_req: get_default()(config, 'gdfp_req', 1),
        env: get_default()(config, 'env', 'vp'),
        output: get_default()(config, 'output', 'vast'),
        unviewed_position_start: get_default()(config, 'unviewed_position_start', '1'),
        url: get_default()(config, 'url', '[referrer_url]'),
        description_url: get_default()(config, 'description_url', '[description_url]'),
        correlator: get_default()(config, 'correlator', '[timestamp]'),
        pmnd: get_default()(config, 'pmnd', '0'),
        pmxd: get_default()(config, 'pmxd', '60000'),
        pmad: get_default()(config, 'pmad', '1'),
        vpos: get_default()(config, 'vpos', 'preroll'),
        pp: get_default()(config, 'pp', 'web'),
        pod: get_default()(config, 'pod', '1'),
        ad_rule: get_default()(config, 'ad_rule', '1'),
        asset: get_default()(config, 'asset', '')
      };

      if (config.getDfpParams) {
        mapper = config.getDfpParams(config);
      }

      var additionalParams = get_default()(config, 'additionalParams', {});

      var event = get_default()(cuePointVO, 'event'); // Add the `event` cuepoint data to the custom_params


      if (event !== undefined) {
        set_default()(adConfig, 'cust_params', merge_default()({}, get_default()(adConfig, 'cust_params', {}), {
          evnt: event
        }));
      } // Moving the logic to get the dynamic custom params and add the new one to a new method


      var custParams = DfpRequestBuilder.addCustomParams(adConfig, config);

      if (custParams !== undefined) {
        adConfig.cust_params = DfpRequestBuilder.encodeCustomParams(custParams);
      } // Merge adConfig params & additionalParams


      merge_default()(mapper, adConfig, additionalParams);

      var query = reduce_default()(mapper, function (result, value, key) {
        return result + (result ? '&' : '') + key + '=' + value;
      }, '');

      var rtn = url + '?' + query;
      return rtn;
    }
  }, {
    key: "encodeCustomParams",
    value: function encodeCustomParams(params) {
      var encodedParams = "";

      for (var key in params) {
        if (params.hasOwnProperty(key)) {
          encodedParams = encodedParams + key + "%3D" + params[key] + "%26";
        }
      }

      return encodedParams.substring(0, encodedParams.length - 3);
    }
    /**
     *
     * @desc get dynamic cust_params from the adConfig, and add other values from the config
     *
     */

  }, {
    key: "addCustomParams",
    value: function addCustomParams(adConfig, config) {
      var adConfigCustParams = get_default()(adConfig, 'cust_params', {});

      var configCustParams = get_default()(config, 'cust_params', {});

      var params = merge_default()({}, configCustParams, adConfigCustParams);

      return _objectSpread({}, params, {
        topic: get_default()(config, 'topicId'),
        width: get_default()(config, 'width'),
        height: get_default()(config, 'height')
      });
    }
  }]);

  return DfpRequestBuilder;
}();

/* harmony default export */ var dfp_request_builder = (dfp_request_builder_DfpRequestBuilder);
// CONCATENATED MODULE: ./src/js/advertising/dfp/moat-tracking.js
function moat_tracking_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function moat_tracking_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function moat_tracking_createClass(Constructor, protoProps, staticProps) { if (protoProps) moat_tracking_defineProperties(Constructor.prototype, protoProps); if (staticProps) moat_tracking_defineProperties(Constructor, staticProps); return Constructor; }

var MoatTracking =
/*#__PURE__*/
function () {
  function MoatTracking() {
    moat_tracking_classCallCheck(this, MoatTracking);
  }

  moat_tracking_createClass(MoatTracking, null, [{
    key: "initMoatTracking",
    value: function initMoatTracking(b, h, d) {
      if (!1 === h.hasOwnProperty("partnerCode")) return !1;
      var k = document.createElement("script");
      d = d || b && (typeof b.O !== "undefined" ? b.O.parentNode : document.body) || document.body;
      var f = [],
          c = {
        adsManager: b,
        ids: h,
        imaSDK: !0,
        events: [],
        dispatchEvent: function dispatchEvent(a) {
          var b = this.sendEvent,
              c = this.events;
          b ? (c && (c.push(a), a = c), b(a)) : c.push(a);
        }
      },
          p = {
        complete: "AdVideoComplete",
        firstquartile: "AdVideoFirstQuartile",
        impression: "AdImpression",
        loaded: "AdLoaded",
        midpoint: "AdVideoMidpoint",
        pause: "AdPaused",
        skip: "AdSkipped",
        start: "AdVideoStart",
        thirdquartile: "AdVideoThirdQuartile",
        volumeChange: "AdVolumeChange"
      };

      if (google && google.ima && b) {
        var e = "_moatApi" + Math.floor(1E8 * Math.random()),
            l;

        for (l in google.ima.AdEvent.Type) {
          var n = function n(a) {
            if (c.sendEvent) {
              for (a = f.length - 1; a >= 0; a--) {
                b.removeEventListener(f[a].type, f[a].func);
              }

              c.sendEvent(c.events);
            } else c.events.push({
              type: p[a.type] || a.type,
              adVolume: b.getVolume()
            });
          };

          b.addEventListener(google.ima.AdEvent.Type[l], n);
          f.push({
            type: google.ima.AdEvent.Type[l],
            func: n
          });
        }
      }

      var e = typeof e !== "undefined" ? e : "",
          g,
          m;

      try {
        g = d.ownerDocument, m = g.defaultView || g.parentWindow;
      } catch (a) {
        g = document, m = window;
      }

      m[e] = c;
      k.type = "text/javascript";
      d && d.appendChild(k);
      k.src = "https://z.moatads.com/" + h.partnerCode + "/moatvideo.js#" + e;
      return c;
    }
  }]);

  return MoatTracking;
}();

/* harmony default export */ var moat_tracking = (MoatTracking);
// CONCATENATED MODULE: ./src/js/advertising/dfp/dfp-plugin.js
function dfp_plugin_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { dfp_plugin_typeof = function _typeof(obj) { return typeof obj; }; } else { dfp_plugin_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return dfp_plugin_typeof(obj); }

function dfp_plugin_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function dfp_plugin_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { dfp_plugin_ownKeys(source, true).forEach(function (key) { dfp_plugin_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { dfp_plugin_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function dfp_plugin_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function dfp_plugin_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function dfp_plugin_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function dfp_plugin_createClass(Constructor, protoProps, staticProps) { if (protoProps) dfp_plugin_defineProperties(Constructor.prototype, protoProps); if (staticProps) dfp_plugin_defineProperties(Constructor, staticProps); return Constructor; }

function dfp_plugin_possibleConstructorReturn(self, call) { if (call && (dfp_plugin_typeof(call) === "object" || typeof call === "function")) { return call; } return dfp_plugin_assertThisInitialized(self); }

function dfp_plugin_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function dfp_plugin_get2(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { dfp_plugin_get2 = Reflect.get; } else { dfp_plugin_get2 = function _get(target, property, receiver) { var base = dfp_plugin_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return dfp_plugin_get2(target, property, receiver || target); }

function dfp_plugin_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = dfp_plugin_getPrototypeOf(object); if (object === null) break; } return object; }

function dfp_plugin_getPrototypeOf(o) { dfp_plugin_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return dfp_plugin_getPrototypeOf(o); }

function dfp_plugin_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) dfp_plugin_setPrototypeOf(subClass, superClass); }

function dfp_plugin_setPrototypeOf(o, p) { dfp_plugin_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return dfp_plugin_setPrototypeOf(o, p); }













/**
 *
 * @module DfpPlugin
 * @desc
 * @class DfpPlugin
 *
 */

var dfp_plugin_DfpPlugin =
/*#__PURE__*/
function (_BaseAdvertisingPlugi) {
  dfp_plugin_inherits(DfpPlugin, _BaseAdvertisingPlugi);

  function DfpPlugin(config, obsvervationCenter) {
    var _this;

    dfp_plugin_classCallCheck(this, DfpPlugin);

    _this = dfp_plugin_possibleConstructorReturn(this, dfp_plugin_getPrototypeOf(DfpPlugin).call(this, config, obsvervationCenter));
    _this.googleIMA = undefined;
    _this.scriptUrl = get_default()(_this.config, 'dfp.adManager', 'https://imasdk.googleapis.com/js/sdkloader/ima3.js');
    _this.pluginSubject = _this.observationCenter.pluginSubject;
    _this.videoAdContainerId = get_default()(_this.config, 'videoAdContainerId', 'ad-container');
    _this.adContainer = undefined;
    _this.controls = get_default()(_this.config, 'controls', false);
    _this.autoplay = get_default()(_this.config, 'autoplay', true);
    _this.muted = get_default()(_this.config, 'muted', true);
    _this.initVolume = _this.muted ? 0 : 1;
    _this.playsInline = get_default()(_this.config, 'playsinline', true);
    _this.url = get_default()(_this.config, 'dfp.url'); //check defaul value in config?

    _this.output = get_default()(_this.config, 'dfp.output');
    _this.description_url = get_default()(_this.config, 'dfp.description_url');
    _this.cmsid = get_default()(_this.config, 'dfp.cmsid');
    _this.ad_rule = get_default()(_this.config, 'dfp.ad_rule');
    _this.pp = get_default()(_this.config, 'dfp.pp');
    _this.ciu_szs = get_default()(_this.config, 'dfp.ciu_szs');
    _this.gdfp_req = get_default()(_this.config, 'dfp.gdfp_req');
    _this.unviewed_position_start = get_default()(_this.config, 'dfp.unviewed_position_start'); // make this 3 values based on team page or regular vpp

    _this.iu = get_default()(_this.config, 'dfp.vpp.iu');
    _this.sz = get_default()(_this.config, 'dfp.vpp.sz');
    _this.cust_params = get_default()(_this.config, 'dfp.cust_params');
    _this.contentResumeCalled = false;
    _this.deviceManager = new device();
    _this.onAdsManagerLoaded = _this.onAdsManagerLoaded.bind(dfp_plugin_assertThisInitialized(_this));
    _this.onAdError = _this.onAdError.bind(dfp_plugin_assertThisInitialized(_this));

    _this.initAdContainer();

    return _this;
  }
  /**
   *
   * @desc Initialize and create the ad container and video node. Also attaches the video node to the DOM
   * as a child of the ad container. The video node is prepended to the children of the adContainer
   *
   */


  dfp_plugin_createClass(DfpPlugin, [{
    key: "initAdContainer",
    value: function initAdContainer() {
      this.adContainer = document.getElementById(this.videoAdContainerId);

      if (!this.adContainer) {
        throw new Error("An element with the id ".concat(this.videoAdContainerId, " is required for ad playback"));
      }
    }
    /**
     * Recursively traverses up the DOM finding the nearest parent with a width and a height
     *
     * @param leaf {DOMElement} starting point
     *
     * @return {Object} Object containing `width` and `height` properties
     */

  }, {
    key: "findParentSize",
    value: function findParentSize(baseElement) {
      var parent = baseElement.parentNode;
      var width = 640;
      var height = 360;

      if (parent) {
        width = get_default()(parent, 'clientWidth');
        height = get_default()(parent, 'clientHeight');
      }

      if (width > 0 && height > 0) {
        return {
          width: width,
          height: height
        };
      }

      return this.findParentSize(parent);
    }
    /**
     *
     * @desc Subscribe to the ObservationCenter messages
     *
     */

  }, {
    key: "subscribeToMessages",
    value: function subscribeToMessages() {
      var _this2 = this;

      var PlayerEvents = external_commonjs_mlb_media_player_commonjs2_mlb_media_player_amd_mlb_media_player_root_MediaPlayer_["MediaPlayerEvents"][this.mediaPlayer.player.playerTypeConfig.playerType];
      var MediaEvents = external_commonjs_mlb_media_player_commonjs2_mlb_media_player_amd_mlb_media_player_root_MediaPlayer_["MediaPlayerEvents"]['MEDIA_PLAYER']; // Player subscriptions

      var playerSubscription = this.observationCenter.playerSubject.subscribe(function (data) {
        switch (data.type) {
          case PlayerEvents.VOLUME_CHANGE:
            {
              var volume = get_default()(data, 'event.target.volume');

              var muted = get_default()(data, 'event.target.muted');

              _this2.onVolumeChanged(volume, muted);

              break;
            }

          case MediaEvents.PLAYER_RESIZED:
            {
              var newSize = get_default()(data, 'data');

              _this2.setSize(newSize.width, newSize.height);

              break;
            }
        }
      }); // Plugin subscriptions

      var pluginSubscription = this.observationCenter.pluginSubject.subscribe(function (data) {
        switch (data.type) {
          case advertising_plugin_events.AD_START:
            {
              _this2.mediaPlayer.setIsAdPlaying(true);

              _this2.adContainer.style.display = '';
              break;
            }

          case advertising_plugin_events.AD_COMPLETE:
            {
              _this2.mediaPlayer.setIsAdPlaying(false);

              _this2.adContainer.style.display = 'none';
              break;
            }

          case advertising_plugin_events.AD_ERROR:
          case advertising_plugin_events.AD_PLUGIN_ERROR:
          case advertising_plugin_events.AD_BLOCK_DETECTED:
            {
              _this2.pluginDidError = true;

              _this2.mediaPlayer.setIsAdPlaying(false);

              _this2.adContainer.style.display = 'none';

              _this2.destroy();

              break;
            }
        }
      });
      this.subscriptions.push(playerSubscription);
      this.subscriptions.push(pluginSubscription);
    }
    /**
     *
     * @desc Unsubscribe from the event stream
     * @private
     *
     */

  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      this.subscriptions.forEach(function (subscription) {
        subscription.unsubscribe();
      });
    }
  }, {
    key: "setMediaPlayer",
    value: function setMediaPlayer(mediaPlayer) {
      var _this3 = this;

      /* If we have a mediaPlayer, we need to unsubscribe from the event streams
          because we're going to resubscribe shorlty for the new player */
      if (this.mediaPlayer) {
        this.unsubscribe();
      } // Set so subscribeToMessages has a reference


      this.mediaPlayer = mediaPlayer; // init the plugin

      return this.init().then(function () {
        _this3.subscribeToMessages(); // Let the super know (this also calls pluginReady())


        dfp_plugin_get2(dfp_plugin_getPrototypeOf(DfpPlugin.prototype), "setMediaPlayer", _this3).call(_this3, mediaPlayer);
      });
    }
    /**
     *
     * @desc Initialize the plugin.
     *
     */

  }, {
    key: "init",
    value: function init(scriptUrl) {
      var _this4 = this;

      return Promise.resolve(get_default()(window, 'window.google.ima')).then(function (googleIMA) {
        if (!googleIMA) {
          return script_loader.getAPI(_this4.scriptUrl, 'window.google.ima');
        } //console.log('load ad manager');


        return googleIMA;
      }).then(function (googleIMA) {
        //console.log('ad manager loaded');
        if (!_this4.googleIMA) {
          _this4.googleIMA = googleIMA;
        }

        _this4.onScriptLoaded();
      }).catch(function (error) {
        console.log('ad manager error', error);
        _this4.adBlockedError = true;

        _this4.destroy(); // Dispatch error message


        _this4.pluginSubject.next({
          type: advertising_plugin_events.AD_PLUGIN_ERROR,
          error: error
        });
      });
    }
    /**
     *
     * @access private
     * @desc Called when the DFPPlugin has been successfully loaded.
     * Dispatches the AD_PLUGIN_LOADED event
     *
     */

  }, {
    key: "onScriptLoaded",
    value: function onScriptLoaded() {
      this.ready = true; // log.call(this, 'onScriptLoaded');
      // Send AD_PLUGIN_LOADED message

      this.pluginSubject.next({
        type: advertising_plugin_events.AD_PLUGIN_LOADED
      });
    }
  }, {
    key: "onVolumeChanged",
    value: function onVolumeChanged(volume, muted) {
      var adsManager = this.adsManager;

      if (adsManager) {
        adsManager.setVolume(muted ? 0 : volume);
      }
    }
  }, {
    key: "initializeForAutoPlayPermission",
    value: function initializeForAutoPlayPermission(adVideoElement, adContainer) {
      this.clearAdsLoader();
      this.initializeAdContainer(adContainer);
    }
    /**
     *
     * @access private
     * @desc Cleans up and deletes the adLoader, so it can be created within a userEvent
     *
     */

  }, {
    key: "clearAdsLoader",
    value: function clearAdsLoader() {
      if (this.adsLoader) {
        this.adsLoader.removeEventListener(this.googleIMA.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, this.onAdsManagerLoaded);
        this.adsLoader.removeEventListener(this.googleIMA.AdErrorEvent.Type.AD_ERROR, this.onAdError);
        delete this.adsLoader;
        delete this.adBlockedError;
      }
    }
  }, {
    key: "initializeAdContainer",
    value: function initializeAdContainer(adContainer) {
      var _this$findParentSize = this.findParentSize(this.adContainer),
          width = _this$findParentSize.width,
          height = _this$findParentSize.height;

      this.setSize(width, height);

      if (!this.adsLoader) {
        var adDisplayContainer = new this.googleIMA.AdDisplayContainer(adContainer);
        adDisplayContainer.initialize(); // Create ads loader.

        this.adsLoader = new this.googleIMA.AdsLoader(adDisplayContainer); // Listen and respond to ads loaded and error events.

        this.adsLoader.addEventListener(this.googleIMA.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, this.onAdsManagerLoaded, false);
        this.adsLoader.addEventListener(this.googleIMA.AdErrorEvent.Type.AD_ERROR, this.onAdError, false);
      }
    }
    /**
     *
     * @desc Set the volume on the adManager for the ads
     * @param {double} newVolume Value between 0 (no volume) and 1 (loudest)
     *
     */

  }, {
    key: "setVolume",
    value: function setVolume(newVolume) {
      this.initVolume = newVolume;

      if (this.adsManager) {
        this.mediaPlayer.setVolume(this.initVolume);
        this.adsManager.setVolume(this.initVolume);
      }
    } // ========================================
    // Ad requests
    // ========================================

  }, {
    key: "requestAd",
    value: function requestAd(clip) {
      var _this5 = this;

      if (this.ready) {
        this.mediaPlayer.pause();
        this.clip = clip;
        this.currentAdDuration = 0;
        this.adPodDuration = 0;
        this.elapsedAdsInPodTime = 0;
        this.initializeAdContainer(this.adContainer);
        this.startAdsRequest();
      } else if (!this.adBlockedError) {
        ////log.call(this, 'requestAdQueued');
        this.requestAdTimeoutID = setTimeout(function () {
          _this5.requestAd(clip);
        }, 500);
      }
    }
  }, {
    key: "startAdsRequest",
    value: function startAdsRequest(cuePointVO) {
      var _this6 = this;

      // Request video ads.
      var adsRequest = new this.googleIMA.AdsRequest();

      var dfpConfig = get_default()(this.config, 'dfp', {});

      var request = dfp_request_builder.build(dfpConfig, this.clip, cuePointVO);
      adsRequest.adTagUrl = request; // Specify the linear and nonlinear slot sizes. This helps the SDK to
      // select the correct creative if multiple are returned.

      adsRequest.linearAdSlotWidth = 640;
      adsRequest.linearAdSlotHeight = 400;
      adsRequest.nonLinearAdSlotWidth = 640;
      adsRequest.nonLinearAdSlotHeight = 150;
      external_commonjs_mlb_media_player_commonjs2_mlb_media_player_amd_mlb_media_player_root_MediaPlayer_["FeatureDetection"].testHTML5Autoplay().then(function (result) {
        var stateModel = get_default()(_this6.mediaPlayer, 'player.stateModel');

        var volume = stateModel.volume;
        _this6.autoPlayPolicy = result;

        if (result.regular) {
          adsRequest.setAdWillAutoPlay(true);
          adsRequest.setAdWillPlayMuted(volume.muted);

          _this6.setVolume(volume.muted ? 0 : volume.value);
        } else if (result.muted) {
          adsRequest.setAdWillAutoPlay(true);
          adsRequest.setAdWillPlayMuted(true);

          _this6.setVolume(0);
        } else {
          console.error('Ad request error, we can\'t determine autoplay, we\'ll default muted');
          adsRequest.setAdWillAutoPlay(true);
          adsRequest.setAdWillPlayMuted(true);
        }

        _this6.adsLoader.requestAds(adsRequest);
      }).catch(function (error) {
        console.error('Ad request error', error);
      });
    } // ===============================================
    // DFP/Player API
    // ===============================================

    /**
     *
     * @access private
     * @param {HTMLElement} adContainer - the container that the video node lives
     * @param {Object} event
     * @desc start the ad playing. Copied from the docs at
     * https://developers.google.com/interactive-media-ads/docs/sdks/html5/quickstart
     *
     */

  }, {
    key: "onAdsManagerLoaded",
    value: function onAdsManagerLoaded(event) {
      // Get the ads manager.
      var adsRenderingSettings = new this.googleIMA.AdsRenderingSettings();
      adsRenderingSettings.restoreCustomPlaybackStateOnAdBreakComplete = true; // 1st param should be set to the content video element.

      this.adsManager = event.getAdsManager(this.mediaPlayer.player.videoEl, adsRenderingSettings); // Add listeners to the required events.

      this.adsManager.addEventListener(this.googleIMA.AdErrorEvent.Type.AD_ERROR, this.onAdError);
      this.adsManager.addEventListener(this.googleIMA.AdEvent.Type.CONTENT_PAUSE_REQUESTED, this.onContentPauseRequested.bind(this));
      this.adsManager.addEventListener(this.googleIMA.AdEvent.Type.CONTENT_RESUME_REQUESTED, this.onContentResumeRequested.bind(this));
      this.adsManager.addEventListener(this.googleIMA.AdEvent.Type.ALL_ADS_COMPLETED, this.onAdEvent.bind(this)); // Listen to any additional events, if necessary.

      this.adsManager.addEventListener(this.googleIMA.AdEvent.Type.LOADED, this.onAdEvent.bind(this));
      this.adsManager.addEventListener(this.googleIMA.AdEvent.Type.STARTED, this.onAdEvent.bind(this));
      this.adsManager.addEventListener(this.googleIMA.AdEvent.Type.COMPLETE, this.onAdEvent.bind(this));
      this.adsManager.addEventListener(this.googleIMA.AdEvent.Type.AD_PROGRESS, this.onAdEvent.bind(this));

      try {
        // Initialize the ads manager. Ad rules playlist will start at this time.
        var _get3 = get_default()(this.config, 'dfp', {}),
            width = _get3.width,
            height = _get3.height;

        if (!(width && height)) {
          var _this$findParentSize2 = this.findParentSize(this.adContainer);

          width = _this$findParentSize2.width;
          height = _this$findParentSize2.height;
        } // const muted = _get(this.mediaPlayer, 'player.stateModel.volume.muted', true);
        // const playerVolume = _get(this.mediaPlayer, 'player.stateModel.volume.value', 0);


        this.adsManager.init(width, height, this.googleIMA.ViewMode.NORMAL); // Call start to show ads. Single video and overlay ads will
        // start at this time; this call will be ignored for ad rules, as ad rules
        // ads start when the adsManager is initialized.

        this.adsManager.start();
      } catch (adError) {
        // An error may be thrown if there was a problem with the VAST response.
        console.log('ERROR', adError);
      }
    }
    /**
     *
     * @access private
     * @param {Object} adEvent
     * @desc common handler for all ad events {LOADED, STARTED, COMPLETE}
     *
     */

  }, {
    key: "onAdEvent",
    value: function onAdEvent(adEvent) {
      // Retrieve the ad from the event. Some events (e.g. ALL_ADS_COMPLETED)
      // don't have ad object associated.
      var ad = adEvent.getAd(); //log.call(this, 'onAdEvent: [', adEvent.type, '] isLinear:', ad.isLinear());

      switch (adEvent.type) {
        case this.googleIMA.AdEvent.Type.LOADED:
          // This is the first event sent for an ad - it is possible to
          // determine whether the ad is a video ad or an overlay.

          /** Init Moat ad tracking */
          this.trackMoat();
          this.contentResumeCalled = false;

          if (!ad.isLinear()) {} // Position AdDisplayContainer correctly for overlay.
          // Use ad.width and ad.height.
          // [MIGHT NEED TO REVIEW - DS] videoContent.play();
          //log.call(this, 'AD_LOADED');
          // TODO: Replace with subject...
          //this.dispatcher.publish(PaidInterruptionEvents.AD_LOADED, adEvent.o);


          this.pluginSubject.next({
            type: advertising_plugin_events.AD_LOADED,
            adEvent: adEvent
          });
          break;

        case this.googleIMA.AdEvent.Type.STARTED:
          // This event indicates the ad has started - the video player
          // can adjust the UI, for example display a pause button and
          // remaining time.
          this.contentResumeCalled = false;

          if (['phone', 'tablet'].includes(this.deviceManager.formFactor)) {
            this.observationCenter.controlsSubject.next({
              type: 'HIDE_CONTROLS'
            });
          }

          if (ad.isLinear()) {
            // For a linear ad, a timer can be started to poll for
            // the remaining time.
            var self = this;
            this.elapsedAdsInPodTime += this.currentAdDuration;
            this.currentAdDuration = ad.getDuration(); //log.call(this, 'AD_STARTED', 'currentAdDuration:', this.currentAdDuration, 'elapsedAdsInPodTime', this.elapsedAdsInPodTime);
            // this.intervalTimer = setInterval(this.updateRemainingTimer.bind(self), 300); // every 300ms

            this.updateRemainingTimer();
          }

          break;

        case this.googleIMA.AdEvent.Type.COMPLETE:
          // This event indicates the ad has finished - the video player
          // can perform appropriate UI actions, such as removing the timer for
          // remaining time detection.
          this.observationCenter.controlsSubject.next({
            type: 'SHOW_CONTROLS'
          });

          if (ad.isLinear()) {//log.call(this, 'AD_COMPLETE');
            //clearInterval(this.intervalTimer);
          }

          break;

        case this.googleIMA.AdEvent.Type.ALL_ADS_COMPLETED:
          this.observationCenter.controlsSubject.next({
            type: 'SHOW_CONTROLS'
          });

          var preRollAdsEnabled = get_default()(this.config, 'preRollAdsEnabled', false);

          var midRollAdsEnabled = get_default()(this.config, 'midRollAdsEnabled', false);

          if (preRollAdsEnabled || midRollAdsEnabled) {
            // TODO: replace with subject
            // TODO: Replace with subject...//
            //this.dispatcher.publish(PaidInterruptionEvents.ALL_ADS_COMPLETED, this.config);
            this.pluginSubject.next({
              type: advertising_plugin_events.ALL_ADS_COMPLETED,
              config: this.config
            });
          }

          if (ad.isLinear()) {////log.call(this, 'ALL_ADS_COMPLETED');
            // Sometimes 'complete' event is not triggered and we only receive this event
            // (noticed it when there is only one ad)
            //clearInterval(this.intervalTimer);
          }

          break;

        case this.googleIMA.AdEvent.Type.AD_PROGRESS:
          {
            this.updateRemainingTimer();
            break;
          }
      }
    }
    /**
     *
     * @access private
     * @param {Object} adErrorEvent
     * @desc publish AD_ERROR and destroy the adsManager session
     *
     */

  }, {
    key: "onAdError",
    value: function onAdError(adErrorEvent) {
      // Handle the error logging.
      var AD_AUTOPLAY_BLOCKED_ERROR_CODE = 1205; //log.call(this, adErrorEvent.getError());

      var innerErrorCode;
      var error = adErrorEvent.getError();
      var innerError = error.getInnerError();

      if (innerError) {
        innerErrorCode = innerError.getErrorCode();
      }

      if (innerErrorCode === AD_AUTOPLAY_BLOCKED_ERROR_CODE) {
        this.adBlockedError = true; // TODO: Replace with subject...
        //this.dispatcher.publish(PaidInterruptionEvents.AD_AUTOPLAY_BLOCKED);

        this.pluginSubject.next({
          type: advertising_plugin_events.AD_AUTOPLAY_BLOCKED
        });
      } else {
        // TODO: Replace with subject...
        //this.dispatcher.publish(PaidInterruptionEvents.AD_ERROR, adErrorEvent);
        this.pluginSubject.next({
          type: advertising_plugin_events.AD_ERROR,
          error: adErrorEvent
        });

        if (this.adsManager) {
          this.destroy();
        }
      }
    }
    /**
     *
     * @access private
     * @param {Object} adEvent
     * @desc event handler that the content has paused and that the AD_START is fired
     * Use this method to setup UI for showing ads (e.g.
     * display ad timer countdown, disable seeking etc.)
     *
     */

  }, {
    key: "onContentPauseRequested",
    value: function onContentPauseRequested(adEvent) {
      var duration = this.adsManager.getRemainingTime();
      var ad = adEvent.getAd();
      var adPodInfo = ad.getAdPodInfo();
      this.adPodDuration = adPodInfo.getMaxDuration();
      this.elapsedAdsInPodTime = 0; //log.call(this,'onContentPauseRequested', 'adPodDuration:', this.adPodDuration);

      this.contentResumeCalled = false; //this.dispatcher.publish(PaidInterruptionEvents.AD_START, { duration: this.adPodDuration });

      this.pluginSubject.next({
        type: advertising_plugin_events.AD_START,
        duration: this.adPodDuration,
        player: this.mediaPlayer
      });
    }
    /**
     *
     * @access private
     * @param {Object} adEvent
     * @desc event handler for the ad is complete and the content should resume. AD_COMPLETE is fired
     *
     */

  }, {
    key: "onContentResumeRequested",
    value: function onContentResumeRequested(adEvent) {
      //log.call(this, 'onContentResumeRequested');
      if (!this.adBlockedError) {
        //this.dispatcher.publish(PaidInterruptionEvents.AD_COMPLETE, adEvent);
        this.pluginSubject.next({
          type: advertising_plugin_events.AD_COMPLETE,
          player: this.mediaPlayer
        });
      }
    }
    /**
     *
     * @accesss private
     * @desc dispatch AD_TIME_UPDATE_ELAPSED with the elapsed time of the ad(s)
     */

  }, {
    key: "updateRemainingTimer",
    value: function updateRemainingTimer() {
      var remainingTime = this.adsManager.getRemainingTime();
      var duration = Math.max(this.currentAdDuration, remainingTime);
      var elapsedTime = duration - remainingTime;
      var podElapsedTime = this.elapsedAdsInPodTime + elapsedTime;
      var payload = {
        countdown: remainingTime,
        currentTime: podElapsedTime,
        // not using this, but not sure if anything else is relying on it
        currentAdElapsedTime: elapsedTime,
        currentPodElapsedTime: podElapsedTime,
        currentAdDuration: duration
      }; // Send AD_TIME_UPDATE_ELAPSED message

      this.pluginSubject.next(dfp_plugin_objectSpread({
        type: advertising_plugin_events.AD_TIME_UPDATE_ELAPSED
      }, payload));
    }
  }, {
    key: "trackMoat",
    value: function trackMoat() {
      var moatTrackingEnabled = get_default()(this.config, 'dfp.moatTrackingEnabled', false);

      var moatPartnerCode = get_default()(this.config, 'dfp.moatPartnerCode', null);

      if (moatTrackingEnabled && moatPartnerCode) {
        var ids = {
          partnerCode: moatPartnerCode,
          viewMode: this.googleIMA.ViewMode.NORMAL
        };
        moat_tracking.initMoatTracking(this.adsManager, ids, this.adContainer);
      }
    }
  }, {
    key: "setSize",

    /**
     * @access public
     * @param {Number} w - width
     * @param {Number} h - height
     * @param {Boolean} isFullScreen
     * @desc relay the new player size to the ad plugin
     * @memberof DFPPlugin
     *
     */
    value: function setSize() {
      var w = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 640;
      var h = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 360;
      var isFullScreen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      this.width = w;
      this.height = h;
      this.isFullscreen = isFullScreen;

      set_default()(this.config, 'dfp.width', w);

      set_default()(this.config, 'dfp.height', h);

      if (this.adsManager) {
        //log.call(this, 'setSize', w, h, isFullScreen);
        this.adsManager.resize(w, h, this.googleIMA.ViewMode.NORMAL);
      }
    }
  }, {
    key: "destroy",

    /**
     *
     * @desc Clean up the DFPPlugin and associated objects.
     *
     */
    value: function destroy() {
      clearTimeout(this.requestAdTimeoutID);

      if (this.adsManager) {
        this.adsManager.destroy();
      }
    }
    /**
     *
     * @desc Utility function for returning the name of the class.
     * @return string The class type.
     *
     */

  }, {
    key: "toString",
    value: function toString() {
      return 'DfpPlugin';
    }
  }]);

  return DfpPlugin;
}(base_advertising_plugin);

/* harmony default export */ var dfp_plugin = (dfp_plugin_DfpPlugin);
// EXTERNAL MODULE: /Users/crosby/_projects/_web-media/mlb-media-player/web-media-playback/node_modules/bandwagon/bandwagon.js
var bandwagon = __webpack_require__(6);
var bandwagon_default = /*#__PURE__*/__webpack_require__.n(bandwagon);

// CONCATENATED MODULE: ./src/js/comm/bandwagon-adapter.js
function bandwagon_adapter_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { bandwagon_adapter_typeof = function _typeof(obj) { return typeof obj; }; } else { bandwagon_adapter_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return bandwagon_adapter_typeof(obj); }

function bandwagon_adapter_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function bandwagon_adapter_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function bandwagon_adapter_createClass(Constructor, protoProps, staticProps) { if (protoProps) bandwagon_adapter_defineProperties(Constructor.prototype, protoProps); if (staticProps) bandwagon_adapter_defineProperties(Constructor, staticProps); return Constructor; }

function bandwagon_adapter_possibleConstructorReturn(self, call) { if (call && (bandwagon_adapter_typeof(call) === "object" || typeof call === "function")) { return call; } return bandwagon_adapter_assertThisInitialized(self); }

function bandwagon_adapter_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function bandwagon_adapter_getPrototypeOf(o) { bandwagon_adapter_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return bandwagon_adapter_getPrototypeOf(o); }

function bandwagon_adapter_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) bandwagon_adapter_setPrototypeOf(subClass, superClass); }

function bandwagon_adapter_setPrototypeOf(o, p) { bandwagon_adapter_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return bandwagon_adapter_setPrototypeOf(o, p); }




/**
 *
 * @module BandwagonAdapter
 * @desc Translates Subject data streams to Bandwagon.dispatches to allow comm for old implementations of
 * the new unified=-player messaging system
 * @class BandwagonAdapter
 *
 */

var bandwagon_adapter_BandwagonAdapter =
/*#__PURE__*/
function (_AbstractPlugin) {
  bandwagon_adapter_inherits(BandwagonAdapter, _AbstractPlugin);

  /**
   *
   * @param {object} targetPlayerEvents
   * @param {object} targetPluginEvents
   * @param {object} requestParams
   * @param {string} bandwagonKey
   * @param {MediaPlayer.ObservationCenter} observationCenter
   * @constructor
   *
   */
  function BandwagonAdapter(config, observationCenter) {
    var _this2;

    bandwagon_adapter_classCallCheck(this, BandwagonAdapter);

    _this2 = bandwagon_adapter_possibleConstructorReturn(this, bandwagon_adapter_getPrototypeOf(BandwagonAdapter).call(this, config, observationCenter));
    /**
     *
     * @type {object}
     *
     */

    _this2.targetPlayerEvents = get_default()(config, 'targetPlayerEvents', []);
    /**
     *
     * @type {object}
     *
     */

    _this2.targetPluginEvents = get_default()(config, 'targetPluginEvents', []);
    /**
     *
     * @type {ObservationCenter}
     *
     */

    _this2.observationCenter = observationCenter;
    /**
     *
     * @type {Bandwagon}
     *
     */

    _this2.dispatcher = bandwagon_default.a.getInstanceByKey("#".concat(get_default()(config, 'bandwagonKey', 'video-player')));

    _this2.subscribeToPlayerEvents();

    _this2.subscribeToPluginEvents();

    return _this2;
  }
  /**
   *
   * @desc Subscribe to the player event stream
   * @param {Subject} subject
   *
   */


  bandwagon_adapter_createClass(BandwagonAdapter, [{
    key: "subscribeToPlayerEvents",
    value: function subscribeToPlayerEvents(subject) {
      var _this3 = this;

      var _this = this;

      this.observationCenter.playerSubject.subscribe(function (stream) {
        var type = _this.targetPlayerEvents[stream.type];

        if (type) {
          _this3.publishMessage(type);
        }
      });
    }
    /**
     *
     * @desc Subscribe to the plugin event stream
     * @param {Subject} subject
     * @todo AdEvents
     *
     */

  }, {
    key: "subscribeToPluginEvents",
    value: function subscribeToPluginEvents(subject) {
      var _this = this;

      this.observationCenter.pluginSubject.subscribe(function (stream) {
        var type = _this.targetPluginEvents[stream.type];

        if (type) {
          _this.publishMessage(type);
        }
      });
    }
    /**
     *
     *  'META_DATA_LOADED'
     *
     * @desc Publish a message to the bandwagon message bus
     * @param {string} event The event type to publish
     * @param {*} payload object to send
     *
     */

  }, {
    key: "publishMessage",
    value: function publishMessage(event, payload) {
      this.dispatcher.publish(event, payload);
    }
  }]);

  return BandwagonAdapter;
}(external_commonjs_mlb_media_player_commonjs2_mlb_media_player_amd_mlb_media_player_root_MediaPlayer_["AbstractPlugin"]);

/* harmony default export */ var bandwagon_adapter = (bandwagon_adapter_BandwagonAdapter);
// EXTERNAL MODULE: /Users/crosby/_projects/_web-media/mlb-media-player/web-media-playback/node_modules/lodash/forIn.js
var forIn = __webpack_require__(83);
var forIn_default = /*#__PURE__*/__webpack_require__.n(forIn);

// CONCATENATED MODULE: ./src/js/comm/event-replicator.js
function event_replicator_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { event_replicator_typeof = function _typeof(obj) { return typeof obj; }; } else { event_replicator_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return event_replicator_typeof(obj); }

function event_replicator_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function event_replicator_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function event_replicator_createClass(Constructor, protoProps, staticProps) { if (protoProps) event_replicator_defineProperties(Constructor.prototype, protoProps); if (staticProps) event_replicator_defineProperties(Constructor, staticProps); return Constructor; }

function event_replicator_possibleConstructorReturn(self, call) { if (call && (event_replicator_typeof(call) === "object" || typeof call === "function")) { return call; } return event_replicator_assertThisInitialized(self); }

function event_replicator_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function event_replicator_getPrototypeOf(o) { event_replicator_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return event_replicator_getPrototypeOf(o); }

function event_replicator_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) event_replicator_setPrototypeOf(subClass, superClass); }

function event_replicator_setPrototypeOf(o, p) { event_replicator_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return event_replicator_setPrototypeOf(o, p); }





/**
 *
 * @module EventReplicator
 * @desc Sends specified events to the parent window
 * @class EventReplicator
 *
 */

var event_replicator_EventReplicator =
/*#__PURE__*/
function (_AbstractPlugin) {
  event_replicator_inherits(EventReplicator, _AbstractPlugin);

  /**
   *
   * @param {object} config
   * @param {MediaPlayer.ObservationCenter} observationCenter
   * @constructor
   *
   */
  function EventReplicator(config, observationCenter) {
    var _this;

    event_replicator_classCallCheck(this, EventReplicator);

    _this = event_replicator_possibleConstructorReturn(this, event_replicator_getPrototypeOf(EventReplicator).call(this, config, observationCenter));
    /**
     *
     * @type {Window} Reference to the current parent window
     *
     */

    _this.parentWindow = get_default()(config, 'parentWindow', window.parent);
    /**
     *
     * @type {Bandwagon} bandwagon event bus, created using the `bandwagonKey` config value
     *
     */

    _this.dispatcher = bandwagon_default.a.getInstanceByKey("#".concat(get_default()(config, 'bandwagonKey', 'video-player')));
    /**
     *
     * @type {string} the playerId to reference in the replicated message
     *
     */

    _this.playerId = get_default()(config, 'playerId', 'video-player');
    /**
     *
     * @type {array} List of events to replicate
     *
     */

    _this.events = get_default()(config, 'eventsToReplicate', []);

    _this.replicate();

    return _this;
  }

  event_replicator_createClass(EventReplicator, [{
    key: "replicate",
    value: function replicate() {
      var _this2 = this;

      forIn_default()(this.events, function (eventName) {
        /**
         *
         * if I see a mediaStartEvent, I'm re-sending metaData there's a weird VAST/VPAID ad thing that makes MOAT go
         * crazy and the MetaDataEvent gets eaten by the AdEvents, so this is a workaround.
         *
         */
        _this2.dispatcher.on(eventName, function (data, event) {
          //console.log("event.post: ", event.type, event);
          _this2.parentWindow.postMessage({
            type: event.type,
            playerId: _this2.playerId,
            payload: !!data ? _this2.removeCircularReferences(eventName, data) : undefined
          }, '*');
        });
      });
    }
  }, {
    key: "removeCircularReferences",
    value: function removeCircularReferences(eventName, object) {
      var cache = [];

      var replacer = function replacer(key, value) {
        if (typeof value === 'function' || value === undefined || value === null || value instanceof Window) {
          return;
        }

        if (value instanceof Object) {
          if (cache.indexOf(value) > -1) {
            return;
          }

          cache.push(value);
        }

        return value;
      }; //don't pass around player


      if (object && object.player) {
        var playerId = object.player.id;
        object.player = {
          id: playerId
        };
      }

      try {
        return JSON.parse(JSON.stringify(object, replacer));
      } catch (e) {
        console.log('removeCircularReferences: error replicating event: ', eventName, e);
        return {};
      }
    }
  }]);

  return EventReplicator;
}(external_commonjs_mlb_media_player_commonjs2_mlb_media_player_amd_mlb_media_player_root_MediaPlayer_["AbstractPlugin"]);

/* harmony default export */ var event_replicator = (event_replicator_EventReplicator);
// CONCATENATED MODULE: ./src/js/comm/communication.js


/* harmony default export */ var communication = ({
  BandwagonAdapter: bandwagon_adapter,
  EventReplicator: event_replicator
});
// CONCATENATED MODULE: ./src/js/analytics/analytics-plugin-events.js
/**
 *
 * @module AnalyticsPluginEvents enum
 * @desc Analytics evnt enum
 *
 */
/* harmony default export */ var analytics_plugin_events = ({
  ANALYTICS_PLUGIN_LOADED: 'analyticsPluginLoaded',
  ANALYTICS_PLUGIN_ERROR: 'analyticsPluginError',
  ANALYTICS_ERROR: 'analyticsError',
  ANALYTICS_LOADED: 'analyticsLoaded'
});
// EXTERNAL MODULE: /Users/crosby/_projects/_web-media/mlb-media-player/web-media-playback/node_modules/lodash/forEach.js
var forEach = __webpack_require__(55);
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);

// EXTERNAL MODULE: external {"root":["rxjs","operators"],"commonjs":"rxjs/operators","commonjs2":"rxjs/operators","amd":"rxjs/operators"}
var operators_ = __webpack_require__(8);

// EXTERNAL MODULE: /Users/crosby/_projects/_web-media/mlb-media-player/web-media-playback/node_modules/bam-wiretap/WiretapVideo.js
var WiretapVideo = __webpack_require__(84);
var WiretapVideo_default = /*#__PURE__*/__webpack_require__.n(WiretapVideo);

// EXTERNAL MODULE: /Users/crosby/_projects/_web-media/mlb-media-player/web-media-playback/node_modules/bam-wiretap/utils/MLBTokenHelpers.js
var MLBTokenHelpers = __webpack_require__(85);
var MLBTokenHelpers_default = /*#__PURE__*/__webpack_require__.n(MLBTokenHelpers);

// EXTERNAL MODULE: /Users/crosby/_projects/_web-media/mlb-media-player/web-media-playback/node_modules/pageMeta/pageMeta.js
var pageMeta = __webpack_require__(32);
var pageMeta_default = /*#__PURE__*/__webpack_require__.n(pageMeta);

// CONCATENATED MODULE: ./src/js/analytics/omniture/token-helpers.js

/* harmony default export */ var token_helpers = ({
  'MEDIA_STREAM_ID': function MEDIA_STREAM_ID(screenData) {
    return get_default()(screenData, 'player.currentMediaItem.metaData.content_id');
  }
});
// CONCATENATED MODULE: ./src/js/analytics/omniture/omniture-plugin.js
function omniture_plugin_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { omniture_plugin_typeof = function _typeof(obj) { return typeof obj; }; } else { omniture_plugin_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return omniture_plugin_typeof(obj); }

function omniture_plugin_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function omniture_plugin_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function omniture_plugin_createClass(Constructor, protoProps, staticProps) { if (protoProps) omniture_plugin_defineProperties(Constructor.prototype, protoProps); if (staticProps) omniture_plugin_defineProperties(Constructor, staticProps); return Constructor; }

function omniture_plugin_possibleConstructorReturn(self, call) { if (call && (omniture_plugin_typeof(call) === "object" || typeof call === "function")) { return call; } return omniture_plugin_assertThisInitialized(self); }

function omniture_plugin_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function omniture_plugin_get2(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { omniture_plugin_get2 = Reflect.get; } else { omniture_plugin_get2 = function _get(target, property, receiver) { var base = omniture_plugin_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return omniture_plugin_get2(target, property, receiver || target); }

function omniture_plugin_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = omniture_plugin_getPrototypeOf(object); if (object === null) break; } return object; }

function omniture_plugin_getPrototypeOf(o) { omniture_plugin_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return omniture_plugin_getPrototypeOf(o); }

function omniture_plugin_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) omniture_plugin_setPrototypeOf(subClass, superClass); }

function omniture_plugin_setPrototypeOf(o, p) { omniture_plugin_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return omniture_plugin_setPrototypeOf(o, p); }

/* External Dependencies */



/* Core Dependencies */


var omniture_plugin_HTML5PlayerEvents = external_commonjs_mlb_media_player_commonjs2_mlb_media_player_amd_mlb_media_player_root_MediaPlayer_["MediaPlayerEvents"].HTML5;
/* Omniture Dependencies */







var URL = __webpack_require__(195);
/**
 *
 * @module OmniturePlugin
 * @desc
 * @class OmniturePlugin
 *
 */


var omniture_plugin_OmniturePlugin =
/*#__PURE__*/
function (_AbstractPlugin) {
  omniture_plugin_inherits(OmniturePlugin, _AbstractPlugin);

  function OmniturePlugin(config, obsvervationCenter) {
    var _this;

    omniture_plugin_classCallCheck(this, OmniturePlugin);

    _this = omniture_plugin_possibleConstructorReturn(this, omniture_plugin_getPrototypeOf(OmniturePlugin).call(this, config, obsvervationCenter));
    _this.playerSubject = _this.observationCenter.playerSubject;
    _this.siteTraffic = get_default()(_this.config.omniture, 'siteTraffic', '');
    _this.section = get_default()(_this.config.omniture, 'section', '');
    _this.wiretapVideoJson = get_default()(_this.config.omniture, 'wiretapVideoJson', {});
    _this.bandwagonPlayerEvents = get_default()(_this.config.omniture, 'bandwagonPlayerEvents', {
      MEDIA_LOAD_START: 'loadstart',
      MEDIA_START: 'play',
      MEDIA_COMPLETE: 'ended'
    });
    _this.autoPlay = null;
    _this.wiretapVideo = null;
    _this.dispatcher = null;
    return _this;
  }
  /**
   *
   * @desc Override setMediaPlayer.
   *
   */


  omniture_plugin_createClass(OmniturePlugin, [{
    key: "setMediaPlayer",
    value: function setMediaPlayer(mediaPlayer) {
      var _this2 = this;

      /* If we have a mediaPlayer, we need to unsubscribe from the event streams
          because we're going to resubscribe shorlty for the new player */
      if (this.mediaPlayer) {
        this.unsubscribe();
      } // Set so init and subscribeToMessages has a reference


      this.mediaPlayer = mediaPlayer;
      this.autoPlay = mediaPlayer.config.playerTypeConfig.autoPlay; // init the omniture plugin

      return this.init().then(function () {
        _this2.subscribeToMessages(); // Let the super know (this also calls pluginReady())


        omniture_plugin_get2(omniture_plugin_getPrototypeOf(OmniturePlugin.prototype), "setMediaPlayer", _this2).call(_this2, _this2.mediaPlayer);
      }).catch(function (error) {
        console.log('Error when calling setMediaPlayer(this.mediaPlayer)', error);
        return error;
      });
    }
    /**
     *
     * @desc Initialize the plugin.
     *
     */

  }, {
    key: "init",
    value: function init() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        if (_this3.wiretapVideo) {
          return resolve();
        } // BandWagon: register the player events so it knows what to respond to


        bandwagon_default.a.registerEvents('PLAYER_EVENTS', omniture_plugin_HTML5PlayerEvents); // Retrieve the dispatcher

        _this3.dispatcher = bandwagon_default.a.getInstanceByKey("#".concat(get_default()(_this3.mediaPlayer, 'player.playerTypeConfig.domTarget', 'media-player'))); //URL Location

        var location = URL.Location(); // Wiretap tracking variables.

        var wiretapPageConfig = {
          bandwagon: bandwagon_default.a,
          siteTraffic: _this3.siteTraffic,
          property: get_default()(window, 'videoProperty', ''),
          topicName: get_default()(window, 'dataBootstrap.title', ''),
          playerContext: location.getParam('playerContext'),
          location: location.getParam('location'),
          systemAutoPlay: _this3.autoPlay ? 'System Generated' : 'User Generated',
          section: _this3.section,
          topic: get_default()(window, 'dataBootstrap', ''),
          langLocale: pageMeta_default.a.lang
        }; // Team info.

        if (pageMeta_default.a.team_id) {
          var allTheTeams = window.team_info;

          var justMyTeam = _.filter(allTheTeams, function (team) {
            return team.id == pageMeta_default.a.team_id;
          });

          wiretapPageConfig['teamAbbrev'] = justMyTeam.abbreviation;
          wiretapPageConfig['teamDisplay'] = justMyTeam.name;
        }

        try {
          var tokenHelpers = Object.assign({}, MLBTokenHelpers_default.a, token_helpers); // Start video tracking (playback).

          _this3.wiretapVideo = new WiretapVideo_default.a(_this3.wiretapVideoJson, tokenHelpers, wiretapPageConfig);
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    }
    /**
     *
     * @desc Subscribe to the ObservationCenter messages
     *
     */

  }, {
    key: "subscribeToMessages",
    value: function subscribeToMessages() {
      var _this4 = this;

      // Switch flag to prevent tracking when user pauses and plays the video
      var trackMediaStart = false;

      forEach_default()(this.bandwagonPlayerEvents, function (playerEvent) {
        var subscription;
        subscription = _this4.playerSubject.pipe(Object(operators_["filter"])(function (event) {
          return event.type === playerEvent;
        })).subscribe(function (data) {
          var dataType = data.type; // Use media load start to determine when to track 1st time media plays

          var mediaLoadStarted = dataType === _this4.bandwagonPlayerEvents.MEDIA_LOAD_START;
          var mediaStarted = dataType === _this4.bandwagonPlayerEvents.MEDIA_START;

          if (mediaLoadStarted) {
            trackMediaStart = true;
          } else if (trackMediaStart && mediaStarted) {
            _this4.dispatchPlayerEvent(dataType);

            trackMediaStart = false;
          } else if (!mediaLoadStarted && !mediaStarted) {
            _this4.dispatchPlayerEvent(dataType);
          }
        });

        _this4.subscriptions.push(subscription);
      });
    }
    /**
     *
     * @desc Unsubscribe from event streams
     * @private
     *
     */

  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      this.subscriptions.forEach(function (subscription) {
        subscription.unsubscribe();
      });
    }
    /**
     *
     * @desc Called when the video's PlayerEvent event fires and is found in the bandwagonPlayerEvents object.
     *
     */

  }, {
    key: "dispatchPlayerEvent",
    value: function dispatchPlayerEvent(videoPlayerEvent) {
      this.dispatcher.publish(videoPlayerEvent, {
        player: this.mediaPlayer
      });
    }
    /**
     *
     * @desc Utility function for returning the name of the class.
     * @return string The class type.
     *
     */

  }, {
    key: "toString",
    value: function toString() {
      return 'OmniturePlugin';
    }
  }]);

  return OmniturePlugin;
}(external_commonjs_mlb_media_player_commonjs2_mlb_media_player_amd_mlb_media_player_root_MediaPlayer_["AbstractPlugin"]);

/* harmony default export */ var omniture_plugin = (omniture_plugin_OmniturePlugin);
// EXTERNAL MODULE: /Users/crosby/_projects/_web-media/mlb-media-player/web-media-playback/node_modules/lodash/find.js
var find = __webpack_require__(86);
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// CONCATENATED MODULE: ./src/js/analytics/chartbeat/chartbeat-plugin.js
function chartbeat_plugin_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { chartbeat_plugin_typeof = function _typeof(obj) { return typeof obj; }; } else { chartbeat_plugin_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return chartbeat_plugin_typeof(obj); }

function chartbeat_plugin_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function chartbeat_plugin_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function chartbeat_plugin_createClass(Constructor, protoProps, staticProps) { if (protoProps) chartbeat_plugin_defineProperties(Constructor.prototype, protoProps); if (staticProps) chartbeat_plugin_defineProperties(Constructor, staticProps); return Constructor; }

function chartbeat_plugin_possibleConstructorReturn(self, call) { if (call && (chartbeat_plugin_typeof(call) === "object" || typeof call === "function")) { return call; } return chartbeat_plugin_assertThisInitialized(self); }

function chartbeat_plugin_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function chartbeat_plugin_getPrototypeOf(o) { chartbeat_plugin_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return chartbeat_plugin_getPrototypeOf(o); }

function chartbeat_plugin_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) chartbeat_plugin_setPrototypeOf(subClass, superClass); }

function chartbeat_plugin_setPrototypeOf(o, p) { chartbeat_plugin_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return chartbeat_plugin_setPrototypeOf(o, p); }






var chartbeat_plugin_ChartBeatPlugin =
/*#__PURE__*/
function (_AbstractPlugin) {
  chartbeat_plugin_inherits(ChartBeatPlugin, _AbstractPlugin);

  function ChartBeatPlugin(config, observationCenter) {
    var _this;

    chartbeat_plugin_classCallCheck(this, ChartBeatPlugin);

    _this = chartbeat_plugin_possibleConstructorReturn(this, chartbeat_plugin_getPrototypeOf(ChartBeatPlugin).call(this, config, observationCenter));
    /**
     *
     * @type {observer}
     * @desc The player observer
     *
     */

    _this.playerSubject = observationCenter.playerSubject;
    /**
     *
     * @type {object}
     * @desc ChartBeat library object
     *
     */

    _this.cbv = undefined;
    /**
     *
     * @type {domElement}
     * @desc Reference to the video tag dom element
     *
     */

    _this.domPlayer = undefined;
    /**
     *
     * @type {object}
     * @desc The metadata object
     *
     */

    _this.metaData = undefined;

    _this.initPlugin();

    return _this;
  }
  /**
   * @desc Init the charBeat Plugin
   *
   * @memberof ChartBeatPlugin
   */


  chartbeat_plugin_createClass(ChartBeatPlugin, [{
    key: "initPlugin",
    value: function initPlugin() {
      try {
        this.checkChartBeatReady();
      } catch (e) {
        console.error(e);
      }
    }
    /**
     *
     *
     * @desc Check chartBeat Library readiness
     * @memberof ChartBeatPlugin
     */

  }, {
    key: "checkChartBeatReady",
    value: function checkChartBeatReady() {
      if (document.readyState === "complete" && !window._cbv) {
        throw new Error('ChartBeat library not found. Can not track the player');
      }

      if (document.readyState !== "complete" && !window._cbv) {
        var initPluginBound = this.initPlugin.bind(this);
        window.addEventListener("load", function () {
          initPluginBound();
        });
        return;
      }

      this.cbv = window._cbv;
      this.playerSubscription();
    }
    /**
     * @desc Handel player subscription fo start tracking the video element
     *
     * @memberof ChartBeatPlugin
     */

  }, {
    key: "playerSubscription",
    value: function playerSubscription() {
      var _this2 = this;

      var HTML5PlayerEvents = external_commonjs_mlb_media_player_commonjs2_mlb_media_player_amd_mlb_media_player_root_MediaPlayer_["MediaPlayerEvents"].HTML5;
      this.playerSubject.pipe(Object(operators_["first"])(function (_ref) {
        var type = _ref.type;
        return type === HTML5PlayerEvents.MEDIA_START;
      })).subscribe(function () {
        _this2.setVideoTagReference();

        _this2.updateVideoDom(_this2.domPlayer, _this2.metaData);

        _this2.cbv.push(_this2.domPlayer); // console.log('tracking player');

      });
    }
    /**
     *
     * @desc Finds the src URL for the specified aspect ratio, width and height in metaData.image.cuts
     * @param {object} metaData The current metaData object to search
     * @param {string} aspectRatio Default "16:9" the aspect ratio to match in image.cuts
     * @param {number} width Default 960 the width to match in image.cuts
     * @param {number} height Default 540 the height to match in image.cuts
     *
     */

  }, {
    key: "getPosterImage",
    value: function getPosterImage(metaData) {
      var aspectRatio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '16:9';
      var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 960;
      var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 540;

      var imageCuts = get_default()(metaData, 'image.cuts', []);

      var result = find_default()(imageCuts, {
        aspectRatio: aspectRatio,
        width: width,
        height: height
      });

      return get_default()(result, 'src', '');
    }
    /**
    *
    * @desc Set metadata in the plugin instance
    *
    */

  }, {
    key: "setMetadata",
    value: function setMetadata(metaData) {
      this.metaData = {
        titleValue: metaData.title,
        posterValue: this.getPosterImage(metaData)
      };

      if (this.domPlayer) {
        this.updateVideoDom(this.domPlayer, this.metaData);
      }
    }
    /**
     * @desc Set a reference to the video dom element
     *
     * @memberof ChartBeatPlugin
     */

  }, {
    key: "setVideoTagReference",
    value: function setVideoTagReference() {
      if (!this.mediaPlayer.player.videoEl) {
        throw new Error('Video Tag element not defined in media player');
      }

      this.domPlayer = this.mediaPlayer.player.videoEl;
    }
    /**
     * @desc Update metadata on video tag element
     *
     * @param {domReference} domPlayer
     * @param {object} metaData
     * @memberof ChartBeatPlugin
     */

  }, {
    key: "updateVideoDom",
    value: function updateVideoDom(domPlayer, metaData) {
      var titleValue = get_default()(metaData, 'titleValue');

      var posterValue = get_default()(metaData, 'posterValue');

      if (titleValue) {
        domPlayer.setAttribute('title', titleValue);
      }

      if (posterValue) {
        domPlayer.setAttribute('poster', posterValue);
      }
    }
  }]);

  return ChartBeatPlugin;
}(external_commonjs_mlb_media_player_commonjs2_mlb_media_player_amd_mlb_media_player_root_MediaPlayer_["AbstractPlugin"]);

/* harmony default export */ var chartbeat_plugin = (chartbeat_plugin_ChartBeatPlugin);
// CONCATENATED MODULE: ./src/js/analytics/conviva/conviva-plugin.js
function conviva_plugin_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { conviva_plugin_typeof = function _typeof(obj) { return typeof obj; }; } else { conviva_plugin_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return conviva_plugin_typeof(obj); }

function conviva_plugin_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function conviva_plugin_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function conviva_plugin_createClass(Constructor, protoProps, staticProps) { if (protoProps) conviva_plugin_defineProperties(Constructor.prototype, protoProps); if (staticProps) conviva_plugin_defineProperties(Constructor, staticProps); return Constructor; }

function conviva_plugin_possibleConstructorReturn(self, call) { if (call && (conviva_plugin_typeof(call) === "object" || typeof call === "function")) { return call; } return conviva_plugin_assertThisInitialized(self); }

function conviva_plugin_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function conviva_plugin_get2(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { conviva_plugin_get2 = Reflect.get; } else { conviva_plugin_get2 = function _get(target, property, receiver) { var base = conviva_plugin_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return conviva_plugin_get2(target, property, receiver || target); }

function conviva_plugin_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = conviva_plugin_getPrototypeOf(object); if (object === null) break; } return object; }

function conviva_plugin_getPrototypeOf(o) { conviva_plugin_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return conviva_plugin_getPrototypeOf(o); }

function conviva_plugin_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) conviva_plugin_setPrototypeOf(subClass, superClass); }

function conviva_plugin_setPrototypeOf(o, p) { conviva_plugin_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return conviva_plugin_setPrototypeOf(o, p); }

/* External Dependencies */


/* Core Dependencies */




/**
 *
 * @module ConvivaPlugin
 * @desc
 * @class ConvivaPlugin
 *
 */

var conviva_plugin_ConvivaPlugin =
/*#__PURE__*/
function (_AbstractPlugin) {
  conviva_plugin_inherits(ConvivaPlugin, _AbstractPlugin);

  function ConvivaPlugin(config, observationCenter) {
    var _this;

    conviva_plugin_classCallCheck(this, ConvivaPlugin);

    _this = conviva_plugin_possibleConstructorReturn(this, conviva_plugin_getPrototypeOf(ConvivaPlugin).call(this, config, observationCenter));
    _this.playerSubject = _this.observationCenter.playerSubject;
    _this.pluginSubject = _this.observationCenter.pluginSubject; // Conviva Asset Name

    _this.assetName = get_default()(_this.config, 'conviva.assetName', ''); // Conviva SDK Library

    _this.sdk = get_default()(_this.config, 'conviva.sdk', ''); // Conviva Customer Key @string

    _this.customerKey = get_default()(_this.config, 'conviva.customerKey', ''); // Conviva Application Name @string

    _this.applicationName = get_default()(_this.config, 'conviva.applicationName', ''); // Conviva Custom @string

    _this.custom = get_default()(_this.config, 'conviva.custom', ''); // Conviva Gateway URL @string

    _this.gatewayUrl = get_default()(_this.config, 'conviva.gatewayUrl', ''); // Track Live Videos

    _this.trackLiveVideos = get_default()(_this.config, 'trackLiveVideos', true); // Track VOD Videos

    _this.trackVodVideos = get_default()(_this.config, 'trackVodVideos', false); // Track if content is Live or VOD

    _this.contentIsLive = null; // Conviva Core and HTML5 Native Implementation @object

    _this.Conviva = null; // Conviva Content Session Key @string

    _this.contentSessionKey = null; // Conviva System Factory @object

    _this.systemFactory = null; // Conviva Client @object

    _this.client = null; // Conviva Player Manager @object

    _this.playerStateManager = null; // Conviva is ready to track

    _this.trackingInitialized = null; // Conviva Viewer ID

    _this.viewerId = null; // Conviva monitoring session

    _this.html5PlayerInterface = null;
    return _this;
  }
  /**
   *
   * @desc Subscribe to the ObservationCenter messages
   *
   */


  conviva_plugin_createClass(ConvivaPlugin, [{
    key: "subscribeToMessages",
    value: function subscribeToMessages() {
      var _this2 = this;

      var mediaPlayerEvents = external_commonjs_mlb_media_player_commonjs2_mlb_media_player_amd_mlb_media_player_root_MediaPlayer_["MediaPlayerEvents"].MEDIA_PLAYER;
      var hlsPlayerEvents = external_commonjs_mlb_media_player_commonjs2_mlb_media_player_amd_mlb_media_player_root_MediaPlayer_["MediaPlayerEvents"].HLSJS;
      var mediaItemObservable = this.playerSubject.pipe(Object(operators_["filter"])(function (event) {
        return event.type === mediaPlayerEvents.MEDIA_ITEM_SET;
      })).subscribe(function (data) {
        // If tracking initialized
        if (_this2.trackingInitialized) {
          // Reset conviva
          _this2.resetTracking();
        }

        if (_this2.trackVodVideos) {
          // Init tracking
          _this2.initTracking();
        }
      }); // Level Loaded subscription

      var levelLoadedSubscription = this.playerSubject.pipe(Object(operators_["filter"])(function (event) {
        return event.type === hlsPlayerEvents.LEVEL_LOADED;
      })).subscribe(function (data) {
        // Content is live
        var isLive = get_default()(data, 'details.live', false); // Media Stream Type Changed


        var mediaStreamTypeChanged = _this2.contentIsLive !== isLive; // Update content is live

        _this2.contentIsLive = isLive; //@TODO
        //How can we do this in conjunction with this.trackLiveVideos and this.trackVodVideos?

        if (_this2.trackingInitialized && mediaStreamTypeChanged) {
          // Update tracking metadata
          _this2.updateTrackingMetadata();
        } else if (_this2.trackLiveVideos && !_this2.trackingInitialized && _this2.contentIsLive) {
          // Init tracking
          _this2.initTracking();
        }
      }); // Append media item subscription and level loaded subscription into subscriptions to get it released when the plugin is destroyed

      this.subscriptions.push(mediaItemObservable);
      this.subscriptions.push(levelLoadedSubscription);
    }
    /**
     *
     * @desc Unsubscribe from event streams
     * @private
     *
     */

  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      this.subscriptions.forEach(function (subscription) {
        subscription.unsubscribe();
      });
    }
  }, {
    key: "setMediaPlayer",
    value: function setMediaPlayer(mediaPlayer) {
      var _this3 = this;

      /* If we have a mediaPlayer, we need to unsubscribe from the event streams
          because we're going to resubscribe shorlty for the new player */
      if (this.mediaPlayer) {
        this.unsubscribe();
      } // Set so init and subscribeToMessages has a reference


      this.mediaPlayer = mediaPlayer; // init the conviva plugin

      return this.init().then(function () {
        _this3.subscribeToMessages(); // Let the super know (this also calls pluginReady())


        conviva_plugin_get2(conviva_plugin_getPrototypeOf(ConvivaPlugin.prototype), "setMediaPlayer", _this3).call(_this3, _this3.mediaPlayer);
      });
    }
    /**
     *
     * @desc Initialize the plugin.
     *
     */

  }, {
    key: "init",
    value: function init() {
      var _this4 = this;

      var env = get_default()(window, 'mediaConfig.app.runTimeConfig', 'prod');

      return Promise // Load Conviva Core script
      .resolve(script_loader.getAPI(get_default()(this.sdk, 'core.' + env), 'Conviva')).then(function (Conviva) {
        // Load Conviva HTML5 native implementation script
        return script_loader.getAPI(get_default()(_this4.sdk, 'html5Impl.' + env), 'Conviva');
      }).then(function (Conviva) {
        // Store Conviva Core and HTML5 Native Implementation
        _this4.Conviva = Conviva; // On script loaded

        _this4._onScriptLoaded();
      }).catch(function (error) {
        _this4.handleError(error, analytics_plugin_events.ANALYTICS_PLUGIN_ERROR, true);
      });
    }
    /**
     *
     * @desc Called when tracking is not initialized.
     *
     */

  }, {
    key: "initTracking",
    value: function initTracking() {
      try {
        // Create session
        this.createTrackingSession(); // Attach Tracker to player

        this.attachTrackerToPlayer(); // Send ANALYTICS_LOADED message

        this.pluginSubject.next({
          type: analytics_plugin_events.ANALYTICS_LOADED
        }); // Tracking has been initialized

        this.trackingInitialized = true;
      } catch (error) {
        this.handleError(error, analytics_plugin_events.ANALYTICS_ERROR);
      }
    }
    /**
     *
     * @desc Get the Tracking Client.
     *
     */

  }, {
    key: "getTrackingClient",
    value: function getTrackingClient() {
      if (!this.client) {
        // Create system settings
        var systemSettings = new Conviva.SystemSettings(); // Create system interfaces

        var systemInterface = new Conviva.SystemInterface(new Conviva.Impl.Html5Time(), new Conviva.Impl.Html5Timer(), new Conviva.Impl.Html5Http(), new Conviva.Impl.Html5Storage(), new Conviva.Impl.Html5Metadata(), new Conviva.Impl.Html5Logging()); // Create system factory

        this.systemFactory = new Conviva.SystemFactory(systemInterface, systemSettings); // Create client settings

        var clientSettings = new Conviva.ClientSettings(this.customerKey); // Valiate gateway url

        if (this.gatewayUrl) {
          // Set client gateway url
          clientSettings.gatewayUrl = this.gatewayUrl;
        } // Create client


        this.client = new Conviva.Client(clientSettings, this.systemFactory);
      }

      return this.client;
    }
    /**
     *
     * @desc Create the Tracking Session after creating the Tracking Client.
     *
     */

  }, {
    key: "createTrackingSession",
    value: function createTrackingSession() {
      // Retrieve content metadata.
      var contentMetadata = this.createTrackingMetadata(); // Create session.

      this.contentSessionKey = this.getTrackingClient().createSession(contentMetadata); // Validate session key.

      if (this.contentSessionKey === Conviva.Client.NO_SESSION_KEY) {
        throw new Error('Unable to create Conviva Session');
      } // Retrieve player manager


      this.playerStateManager = this.getTrackingClient().getPlayerStateManager(); // Create HTML 5 player interface.

      this.html5PlayerInterface = new Conviva.Impl.Html5PlayerInterface(this.playerStateManager, get_default()(this.mediaPlayer, 'player.videoEl'), this.systemFactory);
    }
  }, {
    key: "destroyTrackingSession",
    value: function destroyTrackingSession(sessionKey) {
      // Terminate the existing Conviva monitoring session represented by sessionKey
      this.html5PlayerInterface.cleanup();
      this.html5PlayerInterface = null;
      this.client.cleanupSession(sessionKey); // Reset content session key

      this.contentSessionKey = null;
    }
    /**
     *
     * @desc Create Tracking Metadata after the Tracking Session is created.
     *
     */

  }, {
    key: "createTrackingMetadata",
    value: function createTrackingMetadata() {
      // Conviva Content Metadata
      var trackingMetaData = new Conviva.ContentMetadata(); // Set application name

      trackingMetaData.applicationName = this.applicationName; // Set asset name

      trackingMetaData.assetName = this.assetName; // Set stream type

      trackingMetaData.streamType = !this.trackingInitialized ? Conviva.ContentMetadata.StreamType.UNKNOWN : this.contentIsLive ? Conviva.ContentMetadata.StreamType.LIVE : Conviva.ContentMetadata.StreamType.VOD; // Set viewer id. if we have it available

      if (this.viewerId) {
        trackingMetaData.viewerId = this.viewerId;
      } // Set stream url


      trackingMetaData.streamUrl = get_default()(this.mediaPlayer, 'player.playerTypeConfig.mediaItem.src'); // Validate custom

      if (this.custom) {
        // Set custom
        trackingMetaData.custom = this.custom;
      }

      return trackingMetaData;
    }
    /**
     *
     * @desc Update existing session tracking metadata
     *
     */

  }, {
    key: "updateTrackingMetadata",
    value: function updateTrackingMetadata() {
      // Validate client
      if (this.client) {
        if (this.contentSessionKey !== Conviva.Client.NO_SESSION_KEY && Number.isInteger(this.contentSessionKey)) {
          // Retrieve content metadata.
          var contentMetadata = this.createTrackingMetadata(); // Update the current session with metadata changes

          this.client.updateContentMetadata(this.contentSessionKey, contentMetadata);
        }
      }
    }
    /**
     *
     * @desc Attach Tracker to Player after creating Tracking Client and Tracking Session.
     *
     */

  }, {
    key: "attachTrackerToPlayer",
    value: function attachTrackerToPlayer() {
      if (!this.client.isPlayerAttached(this.contentSessionKey)) {
        // Attach player to client
        this.getTrackingClient().attachPlayer(this.contentSessionKey, this.playerStateManager);
      }
    }
    /**
     *
     * @desc Reset tracking
     *
     */

  }, {
    key: "resetTracking",
    value: function resetTracking() {
      // Reset tracking initialized
      this.trackingInitialized = false; // Reset content is live

      this.contentIsLive = null; // Reset asset name

      this.assetName = get_default()(this.config, 'conviva.assetName', ''); // Reset viewer id

      this.viewerId = null; // Validate client

      if (this.client) {
        if (this.contentSessionKey !== Conviva.Client.NO_SESSION_KEY && Number.isInteger(this.contentSessionKey)) {
          if (this.client.isPlayerAttached(this.contentSessionKey)) {
            // Detach player
            this.client.detachPlayer(this.contentSessionKey);
          }
          /**
           * Validate content session key
           * Session key is represented by an integer (0 included)
           */
          // Cleanup session


          this.destroyTrackingSession(this.contentSessionKey);
        } // Validate player state manager


        if (this.playerStateManager) {
          // Reset player state manager
          this.playerStateManager.reset();
        }
      }
    }
  }, {
    key: "destroyConviva",
    value: function destroyConviva() {
      // reset client and system Factory
      // Release client
      if (this.client) {
        this.client.release();
      } // Release player state manager


      if (this.playerStateManager) {
        this.client.releasePlayerStateManager(this.playerStateManager);
        this.playerStateManager = null;
      } // Release system factory


      if (this.systemFactory) {
        this.systemFactory.release(); // Set system factory to null

        this.systemFactory = null;
      }
    }
    /**
    *
    * @desc Set Tracking Metadata
    * @param {string} assetName
    * @param {string} {optional} viewerId
    */

  }, {
    key: "setTrackingMetadata",
    value: function setTrackingMetadata(assetName) {
      var viewerId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      // If we don't have an asset name
      if (!assetName && !this.assetName) {
        var error = new Error('Missing Conviva Asset Name');
        this.handleError(error, analytics_plugin_events.ANALYTICS_ERROR);
      } // Set asset name


      this.assetName = assetName || this.assetName; // Set viewer id

      this.viewerId = viewerId;
    }
    /**
    *
    * @desc Handle Error
    * @param {object} error
    * @param {string} type
    * @param {boolean} {optional} fatal
    */

  }, {
    key: "handleError",
    value: function handleError(error, type) {
      var fatal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      // Get error message
      var errorMessage = get_default()(error, 'message');

      if (this.Conviva && errorMessage) {
        var fatalStatus = get_default()(this.Conviva, 'Client.ErrorSeverity.FATAL');

        var warningStatus = get_default()(this.Conviva, 'Client.ErrorSeverity.WARNING'); // Retrieve severity


        var severity = (fatal ? fatalStatus : warningStatus) || 'UNKNOWN'; // Validate player state manager

        if (this.playerStateManager) {
          // Send error
          this.playerStateManager.sendError(errorMessage, severity);
        } else if (this.contentSessionKey) {
          // Validate session
          // Report error
          this.getTrackingClient().reportError(this.contentSessionKey, errorMessage, severity);
        }
      } // Reset Conviva


      this.resetTracking(); // Inform PluginManager of error

      this.pluginSubject.next({
        type: type,
        error: error
      }); // Destroy if error is fatal

      if (fatal) {
        this.destroy();
      }
    }
    /**
     *
     * @desc Fires when the Conviva library scripts has loaded.
     *
     */

  }, {
    key: "_onScriptLoaded",
    value: function _onScriptLoaded() {
      // Conviva Content session key.
      this.contentSessionKey = Conviva.Client.NO_SESSION_KEY; // Send ANALYTICS_PLUGIN_LOADED message

      this.pluginSubject.next({
        type: analytics_plugin_events.ANALYTICS_PLUGIN_LOADED
      });
    }
    /**
     *
     * @desc Called when the analytics manager is destroyed.
     *
     */

  }, {
    key: "disposeContext",
    value: function disposeContext() {
      if (this.context) {
        this.context.dispose();
      }
    }
    /**
     *
     * @desc Destroy the analytics manager.
     *
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.destroyConviva();
      this.disposeContext();

      conviva_plugin_get2(conviva_plugin_getPrototypeOf(ConvivaPlugin.prototype), "destroy", this).call(this);
    }
  }, {
    key: "attachLogger",
    value: function attachLogger(logger) {
      this.logger = logger;
    }
    /**
     *
     * @desc Utility function for returning the name of the class.
     * @return string The class type.
     *
     */

  }, {
    key: "toString",
    value: function toString() {
      return 'ConvivaPlugin';
    }
  }]);

  return ConvivaPlugin;
}(external_commonjs_mlb_media_player_commonjs2_mlb_media_player_amd_mlb_media_player_root_MediaPlayer_["AbstractPlugin"]);

/* harmony default export */ var conviva_plugin = (conviva_plugin_ConvivaPlugin);
// CONCATENATED MODULE: ./src/js/entry.js
/* concated harmony reexport BaseAdvertisingPlugin */__webpack_require__.d(__webpack_exports__, "BaseAdvertisingPlugin", function() { return base_advertising_plugin; });
/* concated harmony reexport AdvertisingPluginEvents */__webpack_require__.d(__webpack_exports__, "AdvertisingPluginEvents", function() { return advertising_plugin_events; });
/* concated harmony reexport FreewheelPlugin */__webpack_require__.d(__webpack_exports__, "FreewheelPlugin", function() { return freewheel_plugin; });
/* concated harmony reexport DfpPlugin */__webpack_require__.d(__webpack_exports__, "DfpPlugin", function() { return dfp_plugin; });
/* concated harmony reexport Communication */__webpack_require__.d(__webpack_exports__, "Communication", function() { return communication; });
/* concated harmony reexport AnalyticsPluginEvents */__webpack_require__.d(__webpack_exports__, "AnalyticsPluginEvents", function() { return analytics_plugin_events; });
/* concated harmony reexport OmniturePlugin */__webpack_require__.d(__webpack_exports__, "OmniturePlugin", function() { return omniture_plugin; });
/* concated harmony reexport ChartBeatPlugin */__webpack_require__.d(__webpack_exports__, "ChartBeatPlugin", function() { return chartbeat_plugin; });
/* concated harmony reexport ConvivaPlugin */__webpack_require__.d(__webpack_exports__, "ConvivaPlugin", function() { return conviva_plugin; });
/**
 *
 * @module Entry
 * @desc Main entry point for plugins
 *
 */

/* Import Advertising Plugins */




/* Import Communication Plugins */


/* Import Analytics Plugins */






/***/ })
/******/ ]);
});
//# sourceMappingURL=mlb-player-plugins.js.map